// 彩票用到的翻译 中文
const lottyer_cn = {
  三分钟系统2: '三分钟系统2',
  三分钟系统1: '三分钟系统1',
  五分钟系统1: '五分钟系统1',
  体彩排列3: '体彩排列3',
  排列5: '排列5',
  十分钟系统4: '十分钟系统4',
  十分钟系统3: '十分钟系统3',
  十分钟系统2: '十分钟系统2',
  十分钟系统1: '十分钟系统1',
  DICE代理返点: 'DICE代理返点',
  幸运飞艇: '幸运飞艇',
  幸运飞艇信用: '幸运飞艇信用',
  亚洲飞艇: '亚洲飞艇',
  欧洲飞艇: '欧洲飞艇',
  美洲飞艇: '美洲飞艇',
  极速飞艇: '极速飞艇',
  '分分飞艇(信)': '分分飞艇(信)',
  澳门六合彩: '澳门六合彩',
  '澳门六合彩-两面': '澳门六合彩-两面',
  '澳门六合彩-色波': '澳门六合彩-色波',
  '澳门六合彩-特肖': '澳门六合彩-特肖',
  '澳门六合彩-正码': '澳门六合彩-正码',
  '澳门六合彩-正码特一': '澳门六合彩-正码特一',
  正码特一: '正码特一',
  正码特二: '正码特二',
  正码特三: '正码特三',
  正码特四: '正码特四',
  正码特五: '正码特五',
  正码特六: '正码特六',
  七色波: '七色波',
  加拿大28: '加拿大28',
  赛车: '赛车',
  '澳门六合彩-正码1-6': '澳门六合彩-正码1-6',
  '澳门六合彩-三中二单选/复式': '澳门六合彩-三中二单选/复式',
  '澳门六合彩-一肖': '澳门六合彩-一肖',
  '澳门六合彩-尾数': '澳门六合彩-尾数',
  '澳门六合彩-一肖中': '澳门六合彩-一肖中',
  '澳门六合彩-五不中': '澳门六合彩-五不中',
  '澳门六合彩-二肖单选/复式': '澳门六合彩-二肖单选/复式',
  '澳门六合彩-二尾单选/复式': '澳门六合彩-二尾单选/复式',
  '澳门六合彩-龙虎斗': '澳门六合彩-龙虎斗',
  澳门六合彩玩法说明: '澳门六合彩玩法说明',
  香港六合彩: '香港六合彩',
  澳门分分六合: '澳门分分六合',
  香港五分六合: '香港五分六合',
  分分快三信用: '分分快三信用',
  '香港六合彩-特码': '香港六合彩-特码',
  香港彩六合彩: '香港彩六合彩',
  分分快三: '分分快三',
  三分快三: '三分快三',
  分分赛车: '分分赛车',
  极速三分赛车: '极速三分赛车',
  三分快三信用: '三分快三信用',
  五分快三信用: '五分快三信用',
  '三分时时彩(信)': '三分时时彩(信)',
  三分赛车: '三分赛车',
  '三分飞艇(信)': '三分飞艇(信)',
  五分快三: '五分快三',
  宁夏快三: '宁夏快三',
  河南快三: '河南快三',
  青海快三: '青海快三',
  山西快三: '山西快三',
  四川快三: '四川快三',
  云南快三: '云南快三',
  极速分分赛车: '极速分分赛车',
  极速五分赛车: '极速五分赛车',
  五分赛车: '五分赛车',
  极速赛车信用: '极速赛车信用',
  极速赛车: '极速赛车',
  '极速赛车-冠亚和单双': '极速赛车-冠亚和单双',
  '极速赛车-冠亚和大小': '极速赛车-冠亚和大小',
  '极速赛车-冠亚和指定': '极速赛车-冠亚和指定',
  '极速赛车-猜冠军': '极速赛车-猜冠军',
  '极速赛车-猜冠亚军': '极速赛车-猜冠亚军',
  '极速赛车-猜前三名': '极速赛车-猜前三名',
  '极速赛车-两面': '极速赛车-两面',
  '极速赛车-龙虎': '极速赛车-龙虎',
  福彩3D: '福彩3D',
  一字组合: '一字组合',
  大小单双质合: '大小单双质合',
  二字组合: '二字组合',
  三字组合: '三字组合',
  一字定位: '一字定位',
  二字定位: '二字定位',
  三字定位: '三字定位',
  二字和数: '二字和数',
  三字和数: '三字和数',
  组三: '组三',
  组六: '组六',
  组选: '组选',
  组选三: '组选三',
  组选六: '组选六',
  跨度: '跨度',
  幸运赛车: '幸运赛车',
  澳洲赛车: '澳洲赛车',
  澳洲幸运10: '澳洲幸运10',
  分分飞艇信用: '分分飞艇信用',
  分分飞艇: '分分飞艇',
  三分飞艇信用: '三分飞艇信用',
  三分飞艇: '三分飞艇',
  老幸运飞艇信用: '老幸运飞艇信用',
  老幸运飞艇: '老幸运飞艇',
  腾讯分分彩信用: '腾讯分分彩信用',
  腾讯分分彩: '腾讯分分彩',
  三分时时彩信用: '三分时时彩信用',
  三分时时彩: '三分时时彩',
  五分时时彩信用: '五分时时彩信用',
  五分时时彩: '五分时时彩',
  '五分快三(信)': '五分快三(信)',
  '五分时时彩(信)': '五分时时彩(信)',
  澳洲幸运5: '澳洲幸运5',
  澳洲幸运20: '澳洲幸运20',
  初级房: '初级房',
  初级房1: '初级房1',
  初级房2: '初级房2',
  中级房: '中级房',
  中级房1: '中级房1',
  中级房2: '中级房2',
  高级房: '高级房',
  vip房1: 'vip房1',
  vip房2: 'vip房2',
  台湾宾果: '台湾宾果',
  台湾彩: '台湾彩',
  股票彩: '股票彩',
  新加坡彩: '新加坡彩',
  越南彩: '越南彩',
  泰彩: '泰彩',
  马来西亚彩: '马来西亚彩',
  幸运28: '幸运28',
  泰国指数: '泰国指数',
  日经指数: '日经指数',
  印度指数: '印度指数',
  新加坡指数: '新加坡指数',
  台湾指数: '台湾指数',
  马来西亚指数: '马来西亚指数',
  恒生指数: '恒生指数',
  深圳指数: '深圳指数',
  韩国指数: '韩国指数',
  上海指数: '上海指数',
  台湾四星彩: '台湾四星彩',
  新加坡4D: '新加坡4D',
  多多万字: '多多万字',
  万能4D: '万能4D',
  大马彩: '大马彩',
  TCG300秒4D: 'TCG300秒4D',
  TCG60秒4D: 'TCG60秒4D',
  TCG180秒4D: 'TCG180秒4D',
  老挝彩: '老挝彩',
  平顺越南彩: '平顺越南彩',
  金瓯越南彩: '金瓯越南彩',
  平福越南彩: '平福越南彩',
  东塔越南彩: '东塔越南彩',
  广治越南彩: '广治越南彩',
  广平越南彩: '广平越南彩',
  龙安越南彩: '龙安越南彩',
  昆嵩越南彩: '昆嵩越南彩',
  同奈越南彩: '同奈越南彩',
  北宁越南彩: '北宁越南彩',
  广南越南彩: '广南越南彩',
  林同越南彩: '林同越南彩',
  平阳越南彩: '平阳越南彩',
  广宁越南彩: '广宁越南彩',
  头顿越南彩: '头顿越南彩',
  富安越南彩: '富安越南彩',
  芹苴越南彩: '芹苴越南彩',
  茶荣越南彩: '茶荣越南彩',
  广义越南彩: '广义越南彩',
  海防越南彩: '海防越南彩',
  嘉来越南彩: '嘉来越南彩',
  南定越南彩: '南定越南彩',
  胡志明市越南彩: '胡志明市越南彩',
  岘港越南彩: '岘港越南彩',
  前江越南彩: '前江越南彩',
  朔庄越南彩: '朔庄越南彩',
  宁顺越南彩: '宁顺越南彩',
  庆和越南彩: '庆和越南彩',
  北京赛车信用: '北京赛车信用',
  后江越南彩: '后江越南彩',
  嘉义越南彩: '嘉义越南彩',
  太平越南彩: '太平越南彩',
  坚江越南彩: '坚江越南彩',
  平定越南彩: '平定越南彩',
  安江越南彩: '安江越南彩',
  越南河内彩: '越南河内彩',
  永隆越南彩: '永隆越南彩',
  西宁越南彩: '西宁越南彩',
  TCG急速3D: 'TCG急速3D',
  TCG60秒3D: 'TCG60秒3D',
  TCG180秒3D: 'TCG180秒3D',
  TCG300秒3D: 'TCG300秒3D',
  英国赛车: '英国赛车',
  亚洲赛车: '亚洲赛车',
  '分分快三(信)': '分分快三(信)',
  '三分快三(信)': '三分快三(信)',
  快3: '快3',
  吉林快3: '吉林快3',
  新疆快3: '新疆快3',
  台湾快3: '台湾快3',
  贵州快3: '贵州快3',
  甘肃快3: '甘肃快3',
  河北快3: '河北快3',
  北京快3: '北京快3',
  湖北快3: '湖北快3',
  江苏快3: '江苏快3',
  安徽快3: '安徽快3',
  分分时时彩: '分分时时彩',
  '分分时时彩(信)': '分分时时彩(信)',
  分分时时彩信用: '分分时时彩信用',
  BTC10分彩: 'BTC10分彩',
  DOGE10分彩: 'DOGE10分彩',
  DOGE5分彩: 'DOGE5分彩',
  DOGE3分彩: 'DOGE3分彩',
  DOGE1分彩: 'DOGE1分彩',
  ETH10分彩: 'ETH10分彩',
  ETH5分彩: 'ETH5分彩',
  ETH3分彩: 'ETH3分彩',
  ETH1分彩: 'ETH1分彩',
  BTC5分彩: 'BTC5分彩',
  BTC3分彩: 'BTC3分彩',
  BTC1分彩: 'BTC1分彩',
  QUKUAI1分彩: 'QUKUAI1分彩',
  QUKUAI3分彩: 'QUKUAI3分彩',
  QUKUAI5分彩: 'QUKUAI5分彩',
  QUKUAI10分彩: 'QUKUAI10分彩',
  PK10: 'PK10',
  美洲赛车: '美洲赛车',
  欧洲赛车: '欧洲赛车',
  天成彩票: '天成彩票',
  GPI彩票: 'GPI彩票',
  '自动投注：当出现长龙时，系统根据玩家设置自动进行顺龙投注或者砍龙投注。': '自动投注：当出现长龙时，系统根据玩家设置自动进行顺龙投注或者砍龙投注。',
  '顺龙投注：如连续开5期"单"，继续选择"单"进行投注，这种投注方案称之为顺龙投注。': '顺龙投注：如连续开5期"单"，继续选择"单"进行投注，这种投注方案称之为顺龙投注。',
  '砍龙投注：如连续开5期"单"，选择"双"进行投注，这种投注方案称之为砍龙投注。': '砍龙投注：如连续开5期"单"，选择"双"进行投注，这种投注方案称之为砍龙投注。',
  '例如期数设置为4，表示当长龙出现4次以后，开始自动投注。': '例如期数设置为4，表示当长龙出现4次以后，开始自动投注。',
  '是一个长龙里最多投注次数，如设置为3，表示这个长龙最多投注3次。当然不管选择顺龙投注还是砍龙投注，当长龙断了以后自动结束该长龙投注方案。(例如设置为3次，投注1次以后长龙就断了，则自动结束该长龙投注方案。': '是一个长龙里最多投注次数，如设置为3，表示这个长龙最多投注3次。当然不管选择顺龙投注还是砍龙投注，当长龙断了以后自动结束该长龙投注方案。(例如设置为3次，投注1次以后长龙就断了，则自动结束该长龙投注方案。',
  '每隔1期x1倍，表示每期都是1倍投注。': '每隔1期x1倍，表示每期都是1倍投注。',
  '每隔1期x2倍，表示投注方案倍数为': '每隔1期x2倍，表示投注方案倍数为',
  '每隔1期x3倍，表示投注方案倍数为': '每隔1期x3倍，表示投注方案倍数为',
  '每隔2期x2倍，表示投注方案倍数为': '每隔2期x2倍，表示投注方案倍数为',
  '超过截止时间后不进行自动投注，自动投注方案截止。': '超过截止时间后不进行自动投注，自动投注方案截止。',
  '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码， 开和视为不中奖。': '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码， 开和视为不中奖。',
  '当玩家钱包余额不足时，会提前结束该自动投注方案。': '当玩家钱包余额不足时，会提前结束该自动投注方案。',
  '单码/双面规则说明︰': '单码/双面规则说明︰',
  '指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖。': '指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖。',
  '开出的号码大于或等于6为大，小于或等于5为小。': '开出的号码大于或等于6为大，小于或等于5为小。',
  '号码为双数叫双，如4、6；号码为单数叫单，如3、5。': '号码为双数叫双，如4、6；号码为单数叫单，如3、5。',
  '冠军龙虎：': '冠军龙虎：',
  "龙：冠军号码大于第十名号码视为'龙'中奖，如冠军开出07，第十名开出03。": "龙：冠军号码大于第十名号码视为'龙'中奖，如冠军开出07，第十名开出03。",
  "虎：冠军号码小于第十名号码视为'虎'中奖，如冠军开出03，第十名开出07。": "虎：冠军号码小于第十名号码视为'虎'中奖，如冠军开出03，第十名开出07。",
  '亚军龙虎：': '亚军龙虎：',
  "龙：亚军号码大于第九名号码视为'龙'中奖，如亚军开出07，第九名开出03。": "龙：亚军号码大于第九名号码视为'龙'中奖，如亚军开出07，第九名开出03。",
  "虎：亚军号码小于第九名号码视为'虎'中奖，如亚军开出03，第九名开出07。": "虎：亚军号码小于第九名号码视为'虎'中奖，如亚军开出03，第九名开出07。",
  '季军龙虎：': '季军龙虎：',
  "龙：季军号码大于第八名号码视为'龙'中奖，如季军开出07，第八名开出03。": "龙：季军号码大于第八名号码视为'龙'中奖，如季军开出07，第八名开出03。",
  "虎：季军号码小于第八名号码视为'虎'中奖，如季军开出03，第八名开出07。": "虎：季军号码小于第八名号码视为'虎'中奖，如季军开出03，第八名开出07。",
  '第四名龙虎：': '第四名龙虎：',
  "龙：第四名号码大于第七名号码视为'龙'中奖，如第四名开出07，第七名开出03。": "龙：第四名号码大于第七名号码视为'龙'中奖，如第四名开出07，第七名开出03。",
  "虎：第四名号码小于第七名号码视为'虎'中奖，如第四名开出03，第七名开出07。": "虎：第四名号码小于第七名号码视为'虎'中奖，如第四名开出03，第七名开出07。",
  '第五名龙虎：': '第五名龙虎：',
  "龙：第五名号码大于第六名号码视为'龙'中奖，如第五名开出07，第六名开出03。": "龙：第五名号码大于第六名号码视为'龙'中奖，如第五名开出07，第六名开出03。",
  "虎：第五名号码小于第六名号码视为'虎'中奖，如第五名开出03，第六名开出07。": "虎：第五名号码小于第六名号码视为'虎'中奖，如第五名开出03，第六名开出07。",
  冠亚军和: '冠亚军和',
  '冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖': '冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖',
  冠亚军和大小: '冠亚军和大小',
  "当开奖结果冠军号码与亚军号码的和值大于11为大，投注'和大'则视为中奖；小于等于11为小，投注'和小'则视为中奖。": "当开奖结果冠军号码与亚军号码的和值大于11为大，投注'和大'则视为中奖；小于等于11为小，投注'和小'则视为中奖。",
  冠亚军和单双: '冠亚军和单双',
  "当开奖结果冠军号码与亚军号码的和值为单数如9、13，投注'和单'则视为中奖；为双数如12、16，投注'和双'则视为中奖。": "当开奖结果冠军号码与亚军号码的和值为单数如9、13，投注'和单'则视为中奖；为双数如12、16，投注'和双'则视为中奖。",
  玩法说明: '玩法说明',
  '出码规则：': '出码规则：',
  '1.以官方时时彩开奖第四位，第五位拼合组成一”组合号码“。': '1.以官方时时彩开奖第四位，第五位拼合组成一”组合号码“。',
  '2.将组合号码按情况得出特别号码开奖结果:': '2.将组合号码按情况得出特别号码开奖结果:',
  '游戏中奖：': '游戏中奖：',
  '1)组合号码为00，则当期所有该游戏投注均以不中奖计算。': '1)组合号码为00，则当期所有该游戏投注均以不中奖计算。',
  '2)组合号码=50,则当期所有该游戏投注均以中奖,并且中奖奖金固定为1.8倍(不含返点)计算。': '2)组合号码=50,则当期所有该游戏投注均以中奖,并且中奖奖金固定为1.8倍(不含返点)计算。',
  '3)组合号码>50(不含50),则以100减去组合号码数值作为当期开奖结果特别号码。': '3)组合号码>50(不含50),则以100减去组合号码数值作为当期开奖结果特别号码。',
  '例如：第四位为9，第五位为8，那么特码等于100减去98即是开奖号码为02': '例如：第四位为9，第五位为8，那么特码等于100减去98即是开奖号码为02',
  '4)其他情况下直接以组合号码所代表数值作为当期开奖结果特别号码。': '4)其他情况下直接以组合号码所代表数值作为当期开奖结果特别号码。',
  '例如：第四位为1，第五位为3，那么当期特码等则为13': '例如：第四位为1，第五位为3，那么当期特码等则为13',
  '3.玩法说明：': '3.玩法说明：',
  '小：01，02，03，04，05，06，07，08，09，10，11，12，13，14，15，16，17，18，19，20，21，22，23，24': '小：01，02，03，04，05，06，07，08，09，10，11，12，13，14，15，16，17，18，19，20，21，22，23，24',
  '大：25，26，27，28，29，30，31，32，33，34，35，36，37，38，39，40，41，42，43，44，45，46，47，48，49': '大：25，26，27，28，29，30，31，32，33，34，35，36，37，38，39，40，41，42，43，44，45，46，47，48，49',
  '红波：01,02,07,08,12,13,18,19,23,24,29,30,34,35,40,45,46': '红波：01,02,07,08,12,13,18,19,23,24,29,30,34,35,40,45,46',
  '绿波：05,06,11,16,17,21,22,27,28,32,33,38,39,43,44,49': '绿波：05,06,11,16,17,21,22,27,28,32,33,38,39,43,44,49',
  '蓝波：03,04,09,10,14,15,20,25,26,31,36,37,41,42,47,48': '蓝波：03,04,09,10,14,15,20,25,26,31,36,37,41,42,47,48',
  '1赔41.00倍': '1赔41.00倍',
  '生肖(详看生肖表)': '生肖(详看生肖表)',
  '1赔10.40倍': '1赔10.40倍',
  '1赔1.80倍': '1赔1.80倍',
  '1赔2.70倍': '1赔2.70倍',
  '1赔3.60倍': '1赔3.60倍',
  '生肖号码按当年公历年份计算.': '生肖号码按当年公历年份计算.',
  '玩法规则：': '玩法规则：',
  '每期开奖号码为7个，最后1个号码为特码': '每期开奖号码为7个，最后1个号码为特码',
  '玩法介绍：': '玩法介绍：',
  '特码单、双': '特码单、双',
  '特码为双数叫特双，如8、16；特码为单数叫特单，如21、35；49则均为和。': '特码为双数叫特双，如8、16；特码为单数叫特单，如21、35；49则均为和。',
  '特码大、小': '特码大、小',
  '开出之特码大于或等于25为特码大，小于或等于24为特码小；49则均为和。': '开出之特码大于或等于25为特码大，小于或等于24为特码小；49则均为和。',
  '特码大单、大双': '特码大单、大双',
  '特码为双数且大于或等于26叫大双，如26、42；特码为单数且大于或等于25叫大单，如25、37；49则均为和。': '特码为双数且大于或等于26叫大双，如26、42；特码为单数且大于或等于25叫大单，如25、37；49则均为和。',
  '特码小单、小双': '特码小单、小双',
  '特码为双数且小于或等于24叫小双，如8、16；特码为单数且小于或等于23叫小单，如11、21；49则均为和。': '特码为双数且小于或等于24叫小双，如8、16；特码为单数且小于或等于23叫小单，如11、21；49则均为和。',
  特码总和大: '特码总和大',
  '所有七个开奖号码的分数总和大于或等于175。': '所有七个开奖号码的分数总和大于或等于175。',
  特码总和小: '特码总和小',
  '所有七个开奖号码的分数总和小于或等于174。': '所有七个开奖号码的分数总和小于或等于174。',
  特码总和单: '特码总和单',
  '所有七个开奖号码的分数总和是‘单数’，如分数总和是133、197。': '所有七个开奖号码的分数总和是‘单数’，如分数总和是133、197。',
  特码总和双: '特码总和双',
  '所有七个开奖号码的分数总和是‘双数’，如分数总和是120、188。': '所有七个开奖号码的分数总和是‘双数’，如分数总和是120、188。',
  '特尾大、小': '特尾大、小',
  '开出之特码取出尾数大于或等于5为特尾大，小于或等于4为特尾小；49则均为和。': '开出之特码取出尾数大于或等于5为特尾大，小于或等于4为特尾小；49则均为和。',
  特码合单双: '特码合单双',
  '以特码个位和十位数字之和来判断胜负，如01、12、29、32、47为合单；02、11、33、48为合双；49则均为和。': '以特码个位和十位数字之和来判断胜负，如01、12、29、32、47为合单；02、11、33、48为合双；49则均为和。',
  特码合大小: '特码合大小',
  '以特码个位和十位数字之和来判断胜负，介于1-6为合小；介于7-12为合大；13则为和。如01、24、33为合小；07、34、48为合大；49则为和。': '以特码个位和十位数字之和来判断胜负，介于1-6为合小；介于7-12为合大；13则为和。如01、24、33为合小；07、34、48为合大；49则为和。',
  '合尾大、小': '合尾大、小',
  '以特码个位和十位数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。': '以特码个位和十位数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。',
  '家禽、野兽': '家禽、野兽',
  '开出的特码属于十二生肖中的牛、马、羊、鸡、狗、猪号码为家禽，开出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。': '开出的特码属于十二生肖中的牛、马、羊、鸡、狗、猪号码为家禽，开出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。',
  '六合彩公司当期开出的最后一码为特码，假如投注号码为开出之特码，视为中奖，其余情形视为不中奖。': '六合彩公司当期开出的最后一码为特码，假如投注号码为开出之特码，视为中奖，其余情形视为不中奖。',
  '开出之特码落在1~16为小；17~32为中；33~48为大；49则为和。': '开出之特码落在1~16为小；17~32为中；33~48为大；49则为和。',
  '号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。': '号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。',
  descText1: "开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注'偶'者中奖；如果奇数和偶数号码数目相同时（均为3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。",
  '以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖；若当期特码开出49号，则视为和局；其余情形视为不中奖。': '以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖；若当期特码开出49号，则视为和局；其余情形视为不中奖。',
  '特码对应的生肖,如今年是猴年，所以号码1是猴，按生肖顺序:鼠>牛>虎>兔>龙>蛇>马>羊>猴>鸡>狗>猪依次将49个号码分为12个生肖（如下），再以生肖下注，若当期特码落在下注生肖范围内，则视为中奖。': '特码对应的生肖,如今年是猴年，所以号码1是猴，按生肖顺序:鼠>牛>虎>兔>龙>蛇>马>羊>猴>鸡>狗>猪依次将49个号码分为12个生肖（如下），再以生肖下注，若当期特码落在下注生肖范围内，则视为中奖。',
  '虎：开出之号码第一球(万位)的中奖号码小于第五球(个位)的中奖号码， 开和视为不中奖。': '虎：开出之号码第一球(万位)的中奖号码小于第五球(个位)的中奖号码， 开和视为不中奖。',
  '鼠:1,13,25,37,49': '鼠:1,13,25,37,49',
  '牛:12,24,36,48': '牛:12,24,36,48',
  '虎:11,23,35,47': '虎:11,23,35,47',
  '兔:10,22,34,46': '兔:10,22,34,46',
  '龙:9,21,33,45': '龙:9,21,33,45',
  '蛇:8,20,32,44': '蛇:8,20,32,44',
  '马:7,19,31,43': '马:7,19,31,43',
  '羊:6,18,30,42': '羊:6,18,30,42',
  '猴:5,17,29,41': '猴:5,17,29,41',
  '鸡:4,16,28,40': '鸡:4,16,28,40',
  '狗:3,15,27,39': '狗:3,15,27,39',
  '猪:2,14,26,38': '猪:2,14,26,38',
  '六合彩公司当期开出之前6个号码叫正码。每一个号码为一投注组合，假如投注号码为开奖号码之正码，视为中奖，其馀情形视为不中奖。': '六合彩公司当期开出之前6个号码叫正码。每一个号码为一投注组合，假如投注号码为开奖号码之正码，视为中奖，其馀情形视为不中奖。',
  '正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其余情形视为不中奖。': '正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其余情形视为不中奖。',
  '六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码一，依次为正码二、正码三┅正码六（并不以号码大小排序）。正码一、正码二┅正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、为单；正码二为10，则正码二为小、为双；号码若开出为49，则大小、单双与合码皆视为和局。': '六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码一，依次为正码二、正码三┅正码六（并不以号码大小排序）。正码一、正码二┅正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、为单；正码二为10，则正码二为小、为双；号码若开出为49，则大小、单双与合码皆视为和局。',
  '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其馀情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有08，即为三中二，按三中二赔付；如开奖号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。': '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其馀情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有08，即为三中二，按三中二赔付；如开奖号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。',
  '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其馀情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码码视为不中奖。': '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其馀情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码码视为不中奖。',
  '二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其馀情形（含一个正码加一个特码）视为不中奖。': '二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其馀情形（含一个正码加一个特码）视为不中奖。',
  '二中特:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其馀情形视为不中奖。': '二中特:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其馀情形视为不中奖。',
  '特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其馀情形（含二个号码都是正码）视为不中奖。': '特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其馀情形（含二个号码都是正码）视为不中奖。',
  '生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。': '生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。',
  '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。': '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。',
  '尾数对碰:是一种简易模式，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。': '尾数对碰:是一种简易模式，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]。',
  '指开奖正码及特码７个号码当中含有所下注生肖内的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。': '指开奖正码及特码７个号码当中含有所下注生肖内的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。',
  七色波玩法说明: '七色波玩法说明',
  '以开出的7个色波为例，哪种颜色最多为中奖。开出的6个正码各以1个色波计，特别号以1.5个色波计。而以下3种结果视为和局。': '以开出的7个色波为例，哪种颜色最多为中奖。开出的6个正码各以1个色波计，特别号以1.5个色波计。而以下3种结果视为和局。',
  '1：6个正码开出3蓝3绿，而特别码是1.5红;': '1：6个正码开出3蓝3绿，而特别码是1.5红;',
  '2：6个正码开出3蓝3红，而特别码是1.5绿;': '2：6个正码开出3蓝3红，而特别码是1.5绿;',
  '3：6个正码开出3绿3红，而特别码是1.5蓝': '3：6个正码开出3绿3红，而特别码是1.5蓝',
  '如果出现和局，所有投注红，绿，蓝七色波的金币将全数退回，会员也可投注和局': '如果出现和局，所有投注红，绿，蓝七色波的金币将全数退回，会员也可投注和局',
  '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。': '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。',
  '1尾:01,11,21,31,41': '1尾:01,11,21,31,41',
  '2尾:02,12,22,32,42': '2尾:02,12,22,32,42',
  '3尾:03,13,23,33,43': '3尾:03,13,23,33,43',
  '4尾:04,14,24,34,44': '4尾:04,14,24,34,44',
  '5尾:05,15,25,35,45': '5尾:05,15,25,35,45',
  '6尾:06,16,26,36,46': '6尾:06,16,26,36,46',
  '7尾:07,17,27,37,47': '7尾:07,17,27,37,47',
  '8尾:08,18,28,38,48': '8尾:08,18,28,38,48',
  '9尾:09,19,29,39,49': '9尾:09,19,29,39,49',
  '0尾:10,20,30,40': '0尾:10,20,30,40',
  '依合肖类别挑选1到11个生肖（排列如同生肖）为一个组合，并选择开奖号码的特码是否在此组合内，若选择【中】且开奖号码的特码亦在此组合内，则视为中奖。若选择【不中】且开奖号码的特码一不在此组合内，即视为中奖，其馀情形视为不中奖；开出49则视为和局。': '依合肖类别挑选1到11个生肖（排列如同生肖）为一个组合，并选择开奖号码的特码是否在此组合内，若选择【中】且开奖号码的特码亦在此组合内，则视为中奖。若选择【不中】且开奖号码的特码一不在此组合内，即视为中奖，其馀情形视为不中奖；开出49则视为和局。',
  '五不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '五不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '六不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '六不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '七不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '七不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '八不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '八不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '九不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '九不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '十不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '十一不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十一不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '十二不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十二不中:所投的每一注号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '依选择的连肖类别挑选2～5个生肖（排列如同生肖）为一个组合，当期的开奖号码（六个正码及特码）座落于所勾选之生肖组合所属号码内，且所勾选之生肖皆至少有中一个号码，则视为中奖；其馀情形一律视为不中奖；若选择的生肖组合内有包含本年生肖则称之为正肖，没有包含本年生肖则称之为平肖，正肖与平肖的中奖赔率不同（请注意49亦算输赢，不为和）。': '依选择的连肖类别挑选2～5个生肖（排列如同生肖）为一个组合，当期的开奖号码（六个正码及特码）座落于所勾选之生肖组合所属号码内，且所勾选之生肖皆至少有中一个号码，则视为中奖；其馀情形一律视为不中奖；若选择的生肖组合内有包含本年生肖则称之为正肖，没有包含本年生肖则称之为平肖，正肖与平肖的中奖赔率不同（请注意49亦算输赢，不为和）。',
  '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为中奖，其馀情形视为不中奖(请注意49亦算输赢，不为和)': '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为中奖，其馀情形视为不中奖(请注意49亦算输赢，不为和)',
  '举例1∶下注2尾碰，勾选0,1，当期七个号码若0尾及1尾皆有开出，视为中奖。（尾数所对应的号码和尾数项目的一样；一个尾数对应多个号码，不论同尾数的号码出现一个或多个，派彩只派一次。每个尾数都有自己的赔率，下注组合的总赔率，取该组合尾数的最低赔率为总赔率）': '举例1∶下注2尾碰，勾选0,1，当期七个号码若0尾及1尾皆有开出，视为中奖。（尾数所对应的号码和尾数项目的一样；一个尾数对应多个号码，不论同尾数的号码出现一个或多个，派彩只派一次。每个尾数都有自己的赔率，下注组合的总赔率，取该组合尾数的最低赔率为总赔率）',
  '1.二尾连[中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '1.二尾连[中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '2.三尾连[中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '2.三尾连[中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '3.四尾连[中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '3.四尾连[中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '4.二尾连[不中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '4.二尾连[不中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '5.三尾连[不中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '5.三尾连[不中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '6.四尾连[不中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '6.四尾连[不中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '共有21个单独的投注台面，每一个投注台面的左边为龙，右边为虎。如在正1vs正2的投注台面，则正1为龙，正2为虎；计算公式为：正1的结果为龙的点数，正2的结果为虎的点数。若选择正1vs正5台面，则正1为龙，正5为虎，以此类推。': '共有21个单独的投注台面，每一个投注台面的左边为龙，右边为虎。如在正1vs正2的投注台面，则正1为龙，正2为虎；计算公式为：正1的结果为龙的点数，正2的结果为虎的点数。若选择正1vs正5台面，则正1为龙，正5为虎，以此类推。',
  '龙、虎：以龙和虎点数大小比较来判断胜负，龙大于虎则投注龙者中奖，如龙开8，虎开1；若龙小于虎则投注虎者中奖。注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49': "龙、虎：以龙和虎点数大小比较来判断胜负，龙大于虎则投注'龙'者中奖，如龙开8，虎开1；若龙小于虎则投注'虎'者中奖。注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49",
  快3玩法介绍: '快3玩法介绍',
  '玩法时间：': '玩法时间：',
  '8:30~22:10,20分钟一期，每天82期': '8:30~22:10,20分钟一期，每天82期',
  '每期开出3个数作为开奖号码，每个数字取值范围为1~6（相当于摇3个骰子）': '每期开出3个数作为开奖号码，每个数字取值范围为1~6（相当于摇3个骰子）',
  '奖项设置：': '奖项设置：',
  中奖条件: '中奖条件',
  '猜3个开奖号相加的和，4-10为小，11-17为大，5 、7 、9、11、13、15、17为单，4，6，8，10，12，14，16为双。若开出为豹子111和666，通杀大，小，单，双，对子，总和': '猜3个开奖号相加的和，4-10为小，11-17为大，5 、7 、9、11、13、15、17为单，4，6，8，10，12，14，16为双。若开出为豹子111和666，通杀大，小，单，双，对子，总和',
  '若开出为豹子111和666，通杀大，小，单，双，对子，总和': '若开出为豹子111和666，通杀大，小，单，双，对子，总和',
  '备注:中奖率小于等于2％的单挑最高派奖': '备注:中奖率小于等于2％的单挑最高派奖',
  三同号单选: '三同号单选',
  '猜中111、222、333、444、555、666中指定一个': '猜中111、222、333、444、555、666中指定一个',
  三同号通选: '三同号通选',
  '111、222、333、444、555、666任意一个开出': '111、222、333、444、555、666任意一个开出',
  '猜中3个号(有2个号相同)': '猜中3个号(有2个号相同)',
  猜中开奖号中相同的2个号: '猜中开奖号中相同的2个号',
  '猜中3个号（各不相同）': '猜中3个号（各不相同）',
  猜中开奖号中不相同的2个号: '猜中开奖号中不相同的2个号',
  三连号通选: '三连号通选',
  '123、234、345、456任意一个开出': '123、234、345、456任意一个开出',
  开奖频率: '开奖频率',
  彩种名称: '彩种名称',
  销售时间: '销售时间',
  每日期数: '每日期数',
  '1、玩法分为：猜数字、大小单双、波色、豹子。': '1、玩法分为：猜数字、大小单双、波色、豹子。',
  '2、猜数字：投注号码竞猜范围为0-27，共28个号码。每期开出3个号码作为开奖号码，3个号码之和即为特码。': '2、猜数字：投注号码竞猜范围为0-27，共28个号码。每期开出3个号码作为开奖号码，3个号码之和即为特码。',
  '3、大小单双': '3、大小单双',
  '4、波色：指对开奖特码的形态进行投注，形态号码如下：': '4、波色：指对开奖特码的形态进行投注，形态号码如下：',
  绿波号码: '绿波号码',
  蓝波号码: '蓝波号码',
  红波号码: '红波号码',
  '灰波号码：0、13、14、27（若开出灰波号码，则投注任何波色均视为不中奖。）': '灰波号码：0、13、14、27（若开出灰波号码，则投注任何波色均视为不中奖。）',
  '5、豹子：投注当期的3个开奖号为豹子号码。3个开奖号码为同一号码，即为中奖。': '5、豹子：投注当期的3个开奖号为豹子号码。3个开奖号码为同一号码，即为中奖。',
  '长龙助手是对快3、时时彩、PK10、六合彩特定玩法的“大小单双”开奖结果进行跟踪统计，并可进行快捷投注的助手工具；': '长龙助手是对快3、时时彩、PK10、六合彩特定玩法的“大小单双”开奖结果进行跟踪统计，并可进行快捷投注的助手工具；',
  '每期出现大、小、单、双的概率相同，如果连续3期及以上的开奖结果相同，称之为“长龙”，通常会采用倍投的方式进行“砍龙”或“顺龙”。': '每期出现大、小、单、双的概率相同，如果连续3期及以上的开奖结果相同，称之为“长龙”，通常会采用倍投的方式进行“砍龙”或“顺龙”。',
  '什么是砍龙？': '什么是砍龙？',
  "如连续开5期'单'，可以选择'双'进行投注，这种投注方案称之为“砍龙”；": "如连续开5期'单'，可以选择'双'进行投注，这种投注方案称之为“砍龙”；",
  '什么是顺龙？': '什么是顺龙？',
  "如连续开5期'单'，继续选择'单'进行投注，这种投注方案称之为“顺龙”；": "如连续开5期'单'，继续选择'单'进行投注，这种投注方案称之为“顺龙”；",
  '什么是倍投？': '什么是倍投？',
  '倍投是一种翻倍投注方式，是为了保障能够在“砍龙”或“顺龙”的过程中持续盈利的一种投注方式。': '倍投是一种翻倍投注方式，是为了保障能够在“砍龙”或“顺龙”的过程中持续盈利的一种投注方式。',
  '投注方式：': '投注方式：',
  '彩种玩法：': '彩种玩法：',
  '长龙期数：': '长龙期数：',
  '投注次数：': '投注次数：',
  '投注金币：': '投注金币：',
  '倍投方案：': '倍投方案：',
  '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码，开和视为不中奖。': '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码，开和视为不中奖。',
  '虎：开出之号码第一球(万位)的中奖号码小于第五球(个位)的中奖号码，开和视为不中奖。': '虎：开出之号码第一球(万位)的中奖号码小于第五球(个位)的中奖号码，开和视为不中奖。',
  '中奖号码的十位百位千位数字都相同。': '中奖号码的十位百位千位数字都相同。',
  '中奖号码为000、111、999等，中奖号码的十位百位千位数字相同，则投注豹子者视为中奖，其它视为不中奖。': '中奖号码为000、111、999等，中奖号码的十位百位千位数字相同，则投注豹子者视为中奖，其它视为不中奖。',
  '中奖号码为000、111、999等，中奖号码的十位百位千位数字相同，则投注豹子者视为中奖，其它视为不中奖': '中奖号码为000、111、999等，中奖号码的十位百位千位数字相同，则投注豹子者视为中奖，其它视为不中奖',
  '中奖号码的十位百位千位数字都相连，不分顺序。': '中奖号码的十位百位千位数字都相连，不分顺序。',
  '如中奖号码为123、321、546等，中奖号码十位百位千位数字相连，则投注顺子者视为中奖，其它视为不中奖。': '如中奖号码为123、321、546等，中奖号码十位百位千位数字相连，则投注顺子者视为中奖，其它视为不中奖。',
  '如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。': '如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。',
  '如果开奖号码为豹子,则对子视为不中奖。': '如果开奖号码为豹子,则对子视为不中奖。',
  '如果开奖号码为豹子,则对子视为不中奖': '如果开奖号码为豹子,则对子视为不中奖',
  '如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。': '如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。',
  '如果开奖号码为顺子、对子,则半顺视为不中奖。': '如果开奖号码为顺子、对子,则半顺视为不中奖。',
  '中奖号码的个位十位百位数字都相同。': '中奖号码的个位十位百位数字都相同。',
  '中奖号码为000、111、999等，中奖号码的个位十位百位数字相同，则投注豹子者视为中奖，其它视为不中奖。': '中奖号码为000、111、999等，中奖号码的个位十位百位数字相同，则投注豹子者视为中奖，其它视为不中奖。',
  '中奖号码的个位十位百位数字都相连，不分顺序。': '中奖号码的个位十位百位数字都相连，不分顺序。',
  '中奖号码为123、321、546等，中奖号码个位十位百位数字相连，则投注顺子者视为中奖，其它视为不中奖。': '中奖号码为123、321、546等，中奖号码个位十位百位数字相连，则投注顺子者视为中奖，其它视为不中奖。',
  时时彩经典玩法介绍: '时时彩经典玩法介绍',
  '本公司时时彩经典彩(时时彩,信用彩，飞艇信用彩)具体游戏规则如下︰ ': '本公司时时彩经典彩(时时彩,信用彩，飞艇信用彩)具体游戏规则如下︰',
  '开奖结果为五码(万、仟、佰、拾、个)。假设结果为1、2、3、4、5。': '开奖结果为五码(万、仟、佰、拾、个)。假设结果为1、2、3、4、5。',
  两面玩法: '两面玩法',
  玩法: '玩法',
  说明: '说明',
  中奖示例: '中奖示例',
  单双: '单双',
  '单：1、3、5、7、9': '单：1、3、5、7、9',
  '双：0、2、4、6、8': '双：0、2、4、6、8',
  '投注方案：投注者购买佰位单': '投注方案：投注者购买佰位单',
  '开奖号码：20130（1为单），则视为中奖。': '开奖号码：20130（1为单），则视为中奖。',
  大小: '大小',
  '开奖结果万位、仟位、佰位、拾位或个位数字为5、6、7、8、9时为“大”，若为0、1、2、3、4时为“小”，当投注位数大小与开奖结果的位数大小相符时，即为中奖。': '开奖结果万位、仟位、佰位、拾位或个位数字为5、6、7、8、9时为“大”，若为0、1、2、3、4时为“小”，当投注位数大小与开奖结果的位数大小相符时，即为中奖。',
  '大：5、6、7、8、9': '大：5、6、7、8、9',
  '小：0、1、2、3、4': '小：0、1、2、3、4',
  '投注方案：投注者购买佰位小': '投注方案：投注者购买佰位小',
  '开奖号码：20352（3为小），则视为中奖。': '开奖号码：20352（3为小），则视为中奖。',
  '和：开出之号码第一球(万位)的中奖号码等于第五球(个位)的中奖号码。': '和：开出之号码第一球(万位)的中奖号码等于第五球(个位)的中奖号码。',
  '龙：开奖号码为4***2，则投注龙局者视为中奖。': '龙：开奖号码为4***2，则投注龙局者视为中奖。',
  '虎：开奖号码为7***9，则投注虎局者视为中奖。': '虎：开奖号码为7***9，则投注虎局者视为中奖。',
  '和：开奖号码为2***2，则投注和局者视为中奖。': '和：开奖号码为2***2，则投注和局者视为中奖。',
  总和: '总和',
  '总大：开奖结果5个号码加起的总和，大于等于23为总大。': '总大：开奖结果5个号码加起的总和，大于等于23为总大。',
  '总小：开奖结果5个号码加起的总和，小于等于22为总小。': '总小：开奖结果5个号码加起的总和，小于等于22为总小。',
  '总单：开奖结果5个号码加起的总和为单数。': '总单：开奖结果5个号码加起的总和为单数。',
  '总双：开奖结果5个号码加起的总和为双数。': '总双：开奖结果5个号码加起的总和为双数。',
  '总大：投注者购买总和大，当期开奖结果如为总数为28，则视为中奖。': '总大：投注者购买总和大，当期开奖结果如为总数为28，则视为中奖。',
  '总小：投注者购买总和小，当期开奖结果如为总数为18，则视为中奖。': '总小：投注者购买总和小，当期开奖结果如为总数为18，则视为中奖。',
  '总单：投注者购买总和单，当期开奖结果如为总数为29，则视为中奖。': '总单：投注者购买总和单，当期开奖结果如为总数为29，则视为中奖。',
  '总双：投注者购买总和双，当期开奖结果如为总数为18，则视为中奖。': '总双：投注者购买总和双，当期开奖结果如为总数为18，则视为中奖。',
  豹子: '豹子',
  波色: '波色',
  '中奖号码的百位千位万位数字都相同。': '中奖号码的百位千位万位数字都相同。',
  '中奖号码为000、111、999等，中奖号码的百位千位万位数字相同，则投注豹子者视为中奖，其它视为不中奖。': '中奖号码为000、111、999等，中奖号码的百位千位万位数字相同，则投注豹子者视为中奖，其它视为不中奖。',
  顺子: '顺子',
  '中奖号码的百位千位万位数字都相连，不分顺序。': '中奖号码的百位千位万位数字都相连，不分顺序。',
  '中奖号码为123、321、546等，中奖号码百位千位万位数字相连，则投注顺子者视为中奖，其它视为不中奖。': '中奖号码为123、321、546等，中奖号码百位千位万位数字相连，则投注顺子者视为中奖，其它视为不中奖。',
  对子: '对子',
  '中奖号码的百位千位万位任意两位数字相同。（不包括豹子）': '中奖号码的百位千位万位任意两位数字相同。（不包括豹子）',
  '中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。': '中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖。',
  '如果开奖号码为豹子，则对子视为不中奖。': '如果开奖号码为豹子，则对子视为不中奖。',
  半顺: '半顺',
  '中奖号码的百位千位万位任意两位数字相连，不分顺序。（不包括顺子、对子。）': '中奖号码的百位千位万位任意两位数字相连，不分顺序。（不包括顺子、对子。）',
  '中奖号码为125、540、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。': '中奖号码为125、540、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖。',
  杂六: '杂六',
  '不包括豹子、对子、顺子、半顺的所有中奖号码。': '不包括豹子、对子、顺子、半顺的所有中奖号码。',
  '如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。': '如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。',
  '开奖号码：前二位58，即中前二星直选。': '开奖号码：前二位58，即中前二星直选。',
  '开奖号码:中三位至少出现1个1，即中中三一码不定位': '开奖号码:中三位至少出现1个1，即中中三一码不定位',
  '开奖号码:后三位至少出现1个1，即中后三一码不定位': '开奖号码:后三位至少出现1个1，即中后三一码不定位',
  '开奖号码:前三位至少出现1个1，即中前三一码不定位': '开奖号码:前三位至少出现1个1，即中前三一码不定位',
  '中三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的千位、百位、十位中包所选的2个号码，即为中奖': '中三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的千位、百位、十位中包所选的2个号码，即为中奖',
  '如何免费注册成会员？': '如何免费注册成会员？',
  '第一步：未登录时，点击首页的【注册】。': '第一步：未登录时，点击首页的【注册】。',
  点击立即注册: '点击立即注册',
  '第二步：填写用户名、密码、验证码(必填)、邀请码(选填)。': '第二步：填写用户名、密码、验证码(必填)、邀请码(选填)。',
  '第三步：完善资料后，点击“注册”，完成注册。': '第三步：完善资料后，点击“注册”，完成注册。',
  '最后，恭喜你成为娱乐城的一员！': '最后，恭喜你成为娱乐城的一员！',
  '如有任何问题，请联系客服，我们提供7*24小时的在线服务。': '如有任何问题，请联系客服，我们提供7*24小时的在线服务。',
  '注册时用户需要注意什么？': '注册时用户需要注意什么？',
  '1、用户名一旦注册成功，是唯一且不可更改的，请选择容易记忆且安全级别高的用户名，并妥善保管。': '1、用户名一旦注册成功，是唯一且不可更改 的，请选择容易记忆且安全级别高的用户名，并妥善保管。',
  '2、填写密码时设置较高复杂度，并保护好密码，防止被他人盗用。': '2、填写密码时设置较高复杂度，并保护好密码，防止被他人盗用。',
  '3、为保障用户提现安全，请在注册后在“个人中心-个人信息-修改密码”修改资金密码。': '3、为保障用户提现安全，请在注册后在“个人中心-个人信息-修改密码”修改资金密码。',
  '4、提现时，先在“ 个人中心-钱包管理”页面绑定银行卡。而且，银行卡开户名必须与真实姓名相同，不允许修改和删除。': '4、提现时，先在“个人中心-钱包管理”页面绑定银行卡。而且，银行卡开户名必须与真实姓名相 同，不允许修改和删除。',
  '注册时填写用户名和密码有什么要求？': '注册时填写用户名和密码有什么要求？',
  '1、用户名必须为5-12位，只能包含字母或数字。': '1、用户名必须为5-12位，只能包含字母或数字。',
  '2、密码必须6-16位，只能包含字母或数字。': '2、密码必须6-16位，只能包含字母或数字。',
  '无法登录？': '无法登录？',
  '首先，请确认登录链接为娱乐城官方地址。': '首先，请确认登录链接为娱乐城官方地址。',
  '如果忘记用户名或者密码，请联系客服，并提供相应的材料证明。': '如果忘记用户名或者密码，请联系客服，并提供相应的材料证明。',
  '建议用户首次登录后，完善个人资料并绑定实名银行卡，方便客服快速验证。': '建议用户首次登录后，完善个人资料并绑定实名银行卡，方便客服快速验证。',
  '4、提现时，先在“个人中心-钱包管理”页面绑定银行卡。而且，银行卡开户名必须与真实姓名相同，不允许修改和删除。': '4、提现时，先在“个人中心-钱包管理”页面绑定银行卡。而且，银行卡开户名必须与真实姓名相同，不允许修改和删除。',
  '如有任何问题，请联系客服，我们提供7*24h的在线服务。': '如有任何问题，请联系客服，我们提供7*24h的在线服务。',
  '如何修改个人信息？': '如何修改个人信息？',
  '用户登录后，进入”个人中心-个人信息“，修改安全资料。': '用户登录后，进入”个人中心-个人信息“， 修改安全资料。',
  '个人信息安全问题？': '个人信息安全问题？',
  '一、 保护用户隐私信息': '一、 保护用户隐私信息',
  '开奖号码：前二位58或是85（顺序不限，不含对子）即中前二组选。': '开奖号码：前二位58或是85（顺序不限，不含对子）即中前二组选。',
  '本平台承诺，在未经用户允许或者授权，不得将用户信息提供给他人及其他活动。': '本平台承诺，在未经用户允许或者授权，不得将用户信息提供给他人及其他活动。',
  '平台义务保障用户个人信息安全，防止他人盗用、泄漏等问题。': '平台义务保障用户个人信息安全，防止他人 盗用、泄漏等问题。',
  '用户务必保存好用户帐号、登录密码、资金密码等信息。': '用户务必保存好用户帐号、登录密码、资金密码等信息。',
  '用户若发现帐号被非法使用或网站安全漏洞问题，请立即与我们客服联系。': '用户若发现帐号被非法使用或网站安全漏洞问题，请立即与我们客服联系。',
  '二、交易过程加密': '二、交易过程加密',
  '平台拥有强大的安全技术团队，针对用户购彩、支付、提现等操作，都进行了端到端的加密处理。': '平台拥有强大的安全技术团队，针对用户购彩、支付、提现等操作，都进行了端到端的加密处理。',
  '对于中奖的用户，完全保密用户的个人信息，除平台内专门的运维人员，其他人均无法看到用户的真实中奖信息。': '对于中奖的用户，完全保密用户的个人信息，除平台内专门的运维人员，其他人均无法看到用户的真实中奖信息。',
  '如何修改登录密码？': '如 何修改登录密码？',
  '登录平台官网，修改路径“个人中心-个人信息”，点击修改密码，输入旧密码、新密码，即可完成密码修改操作。': '登录平台官网，修改路径“个人中心-个人信息”，点击修改密码，输入旧密码、新密码，即可完成密码修改操作。',
  '忘记密码怎么办？': '忘记密码怎么办？',
  '如果忘记登录密码，请直接联系客服，需提供相应的验证资料，然后才能修改密码。': '如果忘记登录密码，请直接联系客服，需提供相应的验证资料，然后才能修改密码。',
  '考虑到安全问题，建议用户妥善保管好密码。': '考虑到安全问题，建议用户妥善保管好密码。',
  '忘记资金密码怎么办？': '忘记资金密码怎么办？',
  '如果忘记资金密码，请直接联系客服，需提供相应的验证资料，然后才能修改密码。': '如果忘记资金密码，请直接联系客服，需提供相应的验证资料，然后才能修改密码。',
  '第一步：点击网站首页【充值】或”个人中心“点击【充值】进入充值页面。': '第一步：点击网站首页【充值】或”个人中心“点击【充值】进入充值页面。',
  '第二步：在线存款方式为“银行卡转账”，选择“存入银行”。': '第二步：在线存款方式为“银行卡转账”，选择“存入银行”。',
  '第三步：确认需转账的银行、开户行、帐号和收款人。': '第三步：确认需转账的银行、开户行、帐 号和收款人。',
  '第四步：确定存入金币、真实姓名和存入时间，核对入款帐号信息，点击”提交充值“。': '第四步：确定存入金币、真实姓名和存入时间，核对入款帐号信息，点击”提交充值“。',
  '恭喜您提交入款申请成功，我们会尽快审核入帐信息。': '恭喜您提交入款申请成功，我们会尽快审核入帐信息。',
  '如果您还未转账，请尽快安排银行转账入款。并在银行转账时备注填写“效验码”，方便客服快速审核。': '如果您还未转账，请尽快安排银行转账入款。并在银行转账时备注填写“效验码”，方便客服快速审核。',
  '1、同行转账：完成转账后请于30分钟内查收您的会员账号余额，如未加上请联系在线客服。': '1、同行转账：完成转账后请于30分钟内查收您的会员账号余额，如未加上请联系在线客服。',
  '2、跨行转账：银行不承诺跨行汇款到帐时间， 如您的款项在24小时内未加上， 烦请您联系在线客服为您提供帮助。': '2、跨行转账：银行不承诺跨行汇款到帐时间， 如您的款项在24小时内未加上， 烦请您联系在线客服为您提供帮助。',
  '通过在线支付进行充值：': '通过在线支付进行充值：',
  '一、快捷支付': '一、快捷支付',
  '支持平台：支付宝、微信、财付通、QQ钱包、百度钱包、京东支付等第三方支付平台。': '支持平台：支付宝、微信、 财付通、QQ钱包、百度钱包、京东支付等第三方支付平台。',
  '二、网银支付': '二、网银支付',
  '支持银行：中国银行、中国工商银行、中国农业银行、中国建设银行，以及国内的其他主流银行。': '支持银行：中国银行、中国工商银行、中国农业银行、中国建设银行，以及国内的其他主流银行。',
  '提示：银行卡（借记卡）需具备网银功能，开通方式可以在银行系统在线申请或咨询银行客服。': '提示：银行卡（借记卡）需具备网银功能，开通方式可以在银行系统在线申请或咨询银行客服。',
  '充值步骤：': '充值步骤：',
  '第一步： 点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。': ' 第一步： 点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。',
  '第二步：在线存款方式为”在线支付“，选择第三方”快捷支付“或者“网银支付”。': '第二步：在线存款方式为”在线支付“， 选择第三方”快捷支付“或者“网银支付”。',
  '第三步：进入第三方支付页面，填写资料并继续完成支付操作。': '第三步：进入第三方支付页面，填写资料并继续完成支付操作。',
  '第四步：完成支付后，回到”在线存款“页面，点击”确定“充值成功。': '第四步：完成支付后，回到”在线存款“页面，点击”确定“充值成功。',
  '恭喜您已完成充值，我们会尽快审核入账信息。': '恭喜您已完成充值，我们会尽 快审核入账信息。',
  '微信、QQ钱包、支付宝转账': '微信、QQ钱包、支付宝转账',
  '通过微信、支付宝直接转账支付：': '通过微信、支付宝直接转账支付：',
  '第一步： 登录娱乐城官网，点击首页【充值】或”用户中心-在线存款“进入充值页面。': '第一步： 登录娱乐城官网，点击首页【充值】或”用户中心-在线存款“进入充值页面。',
  '第二步：在线存款方式为”微信” qq钱包”  或者“支付宝”。 ': '第 二步：在线存款方式为”微信” qq钱包”  或者“支付宝”。 ',
  '第三步：填写充值金币，点击”下一步“。': '第三步：填写充值金币，点击”下一步“。',
  '第四步：扫描二维码，核对收款信息，确认支付。': '第四步：扫描二维码，核对收款信息，确认支付。',
  '第五步：填写您的微信昵称或者帐号，点击”提交入款“。': '第五步：填写您的微信昵称或者帐号，点击”提交入款“。',
  '如何进行在线支付？': '如 何进行在线支付？',
  '第一步：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。': '第一步：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。',
  '支持哪些第三方支付平台？': '支持哪些第三方支付平台？',
  '支持哪些银行网银？': '支持哪些银行网银？',
  '为什么通过线上充值后，账户余额未到账？': '为什么通过线上充值后，账户余额未到账？',
  '1、通过线上支付进行充值的，一般是实时到帐，系统自动审核后账款入用户账户余额。': '1、通过线上支付进行充值的，一般是实时到帐，系统自动审核后账款入用户账户余额。',
  '2、可以查询充值状态，查询路径“个人中心-账户明细”，类型选择充值。': '2、可以查询充值状态，查询路径“个人中心-账户明细”，类型选择充值。',
  '3、如果充值成功后，15分钟内账户余额未变，请核实账户是否扣款成功，若扣款成功，请联系我们客服核实。': '3、如果充值成功后，15分钟内账户余额未变，请核实账户是否扣款成功，若扣款成功，请联系我们客服核实。',
  '如何查询充值记录？': '如何查询充值记录？',
  '“个人中心-账户明细”，选择充值，进入充值记录页面。': '“个人中心-账户明细”，选择充值，进入充值记录页面。',
  '在线支付时应该注意些什么？': '在线支付时应该注意些什么？',
  '1、线上支付时，按充值正常步骤完成入款，最后提示付款成功。': '1、线上支付时，按充值正常步骤完成入款，最后提示付款成功。',
  '2、完成充值后，回到“在线存款”页面，点击“确定”充值成功，客服会快速审核入款。': '2、完成充值后，回到“在线存款”页面，点击“确定”充值成功，客服会快速审核入款。',
  '使用本平台投注及支付，安全吗？': '使用本平台投注及支付，安全吗？',
  '支付多样 -- ': '支付多样 -- ',
  '平台提供了银行转账、在线支付、微信、支付宝等多种充值方式。': '平台提供了银行转账、在线支付、微信、支付宝等多种充值方式。',
  '快捷支付 -- 平台已与各大银行开通快捷支付通道，彻底解决通过银行转账进行支付的不安全问题。': '快捷支付 -- 平台已与各大银行开通快捷支付通道，彻底解决通过银行转账进行支付的不安全问题。',
  '实力背景 -- 平台拥有强大的安全技术团队和良好企业征信，与支付宝、微信和第三方平台等公司进行了深度合作。': '实力背景 -- 平台拥有强大的安全技术团队和良好企业征信，与支付宝、微信和第三方平台等公司进行了深度合作。',
  '支付安全 -- 完全保障用户的支付安全，为用户提供安全、稳定、快速的充值支付体验。': '支付安全 -- 完全保障用户的支付安全，为用户提供安全、稳定、快速的充值支付体验。',
  '如何进行银行转账入款？': '如何进行银行转账入款？',
  '银行转账入款步骤：': '银行转账入款步骤：',
  '第一步：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。 ': '第一步：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面。 ',
  '第二步：在线存款方式为”银行转账“，选择”存入银行“和填写“充值金币”，点击”下一步“。': '第二步：在线存款方式为”银行转账“，选择”存入银行“和填写“充值金币”，点击”下一步“。',
  '第三步：保存并确认需转账的银行、开户行、帐号和收款人  ，点击”下一步“。': '第三步：保存并确认需转账的银行、开户行、帐号和收款人  ，点击”下一步“。',
  '第四步：确定存入金币、真实姓名和存入时间，核对入款帐号信息和保存”校验码“，点击”提交入款“。': '第四步：确定存入金币、真实姓名和存入时间，核对入款帐号信息和保存”校验码“，点击”提交入款“。',
  '转账支持哪些银行？': '转账支持 哪些银行？',
  '转账入款时间？': '转账入款时间？',
  '同行转账：完成转账后请于30分钟内查收您的用户账号余额，如未加上请联系在线客服。': '同行转账：完成转账后请于30分钟内查收您的用户账号余额，如未加上请联系在线客服。',
  '跨行转账：银行不承诺跨行汇款到帐时间， 如您的款项在24小时内未加上， 烦请您联系在线客服为您提供帮助。': '跨行转账：银行不承诺跨行汇款到帐时间， 如您 的款项在24小时内未加上， 烦请您联系在线客服为您提供帮助。',
  '银行转账后，为什么账户余额没有改变？': '银行转账后，为什么账户余额没有改变？',
  '1. 通过银行转账入款，跨城跨行的转账，都有一定的等待时间，具体以银行实际到账时间为准。': '1. 通过银行转账入款，跨城跨行的转账，都有一定的等待时间，具体以银行实际到账时间为准。',
  '4. 建议用户查看银行的转账状态，并提供转账成功的水单或者截图，发送客服，我们会尽快处理。': '4. 建议用户查看银行的转账状态，并提供转账成功的水单或者截图，发送客服，我们会尽快处理。',
  '银行入款注意事项？': '银行入款注意事项？',
  '1. 保存并确认需转账的银行、开户行、帐号和收款人，建议汇款时提前与客服校验。': '1. 保存并确认需转账的银行、开户行、帐号和收款人，建议汇款时提前与客服校验。',
  '2. 如果涉及大额转账，请提前联系客服。': '2. 如果涉及大额转账，请提前联系客服。',
  '3. 在银行转账时备注填写”效验码“，方便客服快速审核。': '3. 在银行转账时备注填写”效验码“，方便客服快速审核。',
  '如何进行微信转账？': '如何进行微信转账？',
  '微信转账入款步骤：': '微信转账入款步骤：',
  '第二步：在线存款方式为”微信”，填写充值金币，点击”下一步“。': '第二步：在线存款方式为”微信”，填写充值金币，点击”下 一步“。',
  '第三步：扫描二维码，核对“微信收款信息”，然后确认支付。': '第三步：扫描二维码，核对“微信收款信息”，然后确认支付。',
  '第四步：填写您的微信昵称或者帐号，点击”提交入款“。 ': '第四步：填写您的微信昵称或者帐号，点击”提交入款“。 ',
  '微信支付后，为什么账户余额没有改变？': '微信支付后，为什么账户余额没有改变？',
  '通过微信支付进行充值的，一般是实时到帐，额度会在5分钟内审核入用户账户余额。': '通过微信支付进行充值的，一般是实时到帐，额度会在5分钟内审核入用户账户余额。',
  '微信支付时应该注意什么事项？': '微信支付时应该注意什么事项？',
  '1、在点击“提交入款”时，填写好微信昵称或者帐号，方便客服快速审核。如果未填写资料，请联系客服，并提供相应的支付订单号和帐号名。': '1、在点击“提交入款”时，填写好微信昵称或者帐号，方便客服快速审核。如果未填写资料，请联系客服，并提供相应的支付订单号和帐号名。',
  '2、如果是大额转账，请用银行转账入款，提前与': '2、如果是大额转账，请用银行转账入款，提前与',
  '客服联系。': '客服联系。',
  '如何进行支付宝转账？': '如何进行支付宝转账？',
  '支付宝转账入款步骤：': '支付宝转账入款步骤：',
  '第二步：在线存款方式为”支付宝”，填写充值金币，点击”下一步“。': '第二步：在线存款方式为”支付宝”，填写充值金币，点击”下一步“。',
  '第三步：扫描二维码，核对“支付宝收款信息”，然后确认支付。': '第三步：扫描二维码，核对“支付宝收款信息”，然后确认支付。',
  '第四步：填写您的支付宝昵称或者帐号，点击”提交入款“': '第四步：填写您的支付宝昵称或者帐号，点击”提交入款“',
  '支付宝转账后，为什么账户余额没有改变？': '支付宝转账后，为什么账户余额没有改变 ？',
  '通过支付宝支付进行充值的，一般是实时到帐，额度会在5分钟内审核入用户账户余额。': '通过支付宝支付进行充值的，一般是实时到帐，额度会在5分钟内审核入用户账户余额。',
  '支付宝支付时应该注意什么事项？': '支付宝支付时应该注意什么事项？',
  '1、在点击“提交入款”时，填写好支付宝昵称或者帐号，方便客服快速审核。如果未填写资料，请联系客服，并提供相应的支付订单号和帐号名。': '1、在点击“提交入款”时，填写好支付宝昵称或者帐号，方便客服快速审核。如果未填写资料，请联系客服，并提供相应的支付订单号和帐号名。',
  如何购彩: '如何购彩',
  '1、免费注册：免费注册成为平台的会员。': '1、免费注册：免费注册成为平台的会员。',
  '2、充值送礼：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面进行充值。': '2、充值送礼：点击网站首页【充值】或“个人中心”点击【充值】进入充值页面进行充值。',
  '3、购买彩票：打开购彩大厅，进行购买彩票。': '3、购买彩票：打开购彩大厅，进行购买彩票。',
  '4、中大奖：恭喜您购买的彩票中奖了。': '4、中大奖：恭喜您购买的彩票中奖了。',
  '5、在线提现：在首页点击“提现”，添加”银行卡“后进行提现。': '5、在线提现：在首页点击“提现”，添加”银行卡“后进行提现。',
  购买彩票流程: '购买彩票流程',
  '购买彩票流程：': '购买彩票流程：',
  '第一步：登录平台后，点击“彩票游戏”的任何彩种进入购彩页面。': '第一步：登录平台后，点击“彩票游戏”的任何彩种进入购彩页面。',
  '第二步：选择左侧适玩的彩种名称，进入投注页面。': '第二步：选择左侧适玩的彩种名称，进入投注页面。',
  '第三步：进入投注页面后，选择”玩法“和输入金币，点击”添加注单“。': '第三步：进入投注页面后，选择”玩法“ 和输入金币，点击”添加注单“。',
  '第四步：查看用户余额是否足够投注，然后点击”确认投注“，核查投注订单无误后，点击”确定“即可完成投注。': '第四步：查看用户余额是否足够投注，然后点击”确 认投注“，核查投注订单无误后，点击”确定“即可完成投注。',
  '最后，恭喜您已完成购买彩票。': '最后，恭喜您已完成购买彩票。',
  如何查看购彩记录: '如何查看购彩记录',
  '点击“个人中心-投注记录”进行查看投注记录。': '点击“个人中心-投注记录”进行查看投注记录。',
  '彩种很多，有没有详细的介绍与玩法': '彩种很多，有没有详细的介绍与玩法',
  '点击顶部“玩法介绍”可以查看各彩种说明、玩法、中奖、投注方式等。': '点击顶部“玩法介绍”可以查看各彩种说明、玩法、中奖、投注方式等。',
  投注时有哪些玩法选择: '投注时有哪些玩法选择',
  '一、 单式投注': '一、 单式投注',
  '单式投注是最基本的投注形式，即购买者根据相应彩票的规则直接选择规定数量的号码组成一注彩票。': '单式投注是最基本的投注形式，即购买者根据相应彩票的规则直接选择规定数量的号码组成一注彩票。',
  '二、复式': '二、复式',
  '复式投注相对于单式投注而言的，指购买者在购买彩票时，选择超过常规开奖的号码个数，并组成一组的投注方式。': '复式投注相对于单式投注而言的，指购买者在购买彩票时，选 择超过常规开奖的号码个数，并组成一组的投注方式。',
  '超过规定数量的号码会依据规定的开奖号码个数排列组合成多注彩票，在提高中奖机会的同时，投注金币也会相应增加。': '超过规定数量的号码会依据规定的开奖号码个数排列组合成多注彩票，在提高中奖机会的同时，投注金币也会相应增加。',
  '三、直选': '三、直选',
  '直选即所选号码与开奖号码相同，且顺序一致才中奖。': '直选即所选号码与开奖号码相同，且顺序一致才中奖。',
  '例：': '例：',
  '时时彩五星直选，投注方案为23456，开奖号码为23456，即为中奖。': '时时彩五星直选，投注方案为23456，开奖号码为23456，即为中奖。',
  '四、组选': '四、组选',
  '直选之外的号码类型称为组选。组选所选出的号码可以和开奖号码的位置、顺序不一样，但是数字必须完全一样才能中奖。': '直选之外的号码类型称为组选。组选所选出的号码 可以和开奖号码的位置、顺序不一样，但是数字必须完全一样才能中奖。',
  '时时彩组选如开奖号码为598，那么投注方案为589、859、958、985都算组选中奖。': '时时彩组选如开奖号码为598，那么投注方案为589、859、958、985都算组选中奖。',
  '五、组三组六': '五、组三组六',
  '1注号码中，3个数字有2个数字相同，这样的号码称为组三，如122、133等。': '1注号码中，3个数字有2个数字相同，这样的号码称为组三，如122、133等。',
  '组三单式投注即从0~9中选择两个数字，如3，5，则形成两注彩票的投注，开奖号码为2个3,1个5或1个3,2个5，即为中奖，次序不限，则形成两注彩票的投注。': '组 三单式投注即从0~9中选择两个数字，如3，5，则形成两注彩票的投注，开奖号码为2个3,1个5或1个3,2个5，即为中奖，次序不限，则形成两注彩票的投注。',
  '时时彩后三组三投注方案为5、8，开奖号码为：558、885，都可中奖（顺序不限）。': '时时彩后三组三投注方案为5、8，开奖号码为：558、885，都可中奖（顺序不限）。',
  '3个数字各不相同的号码称为组六，如123、124、245等。': '3个数字各不相同的号码称为组六，如123、124、245等。',
  '组六共计720注直选，合并为组选共120注。组六单式投注即从0~9中选择三个数字，组成一注彩票的投注。': '组六共计720注直选，合并为组选共120注。组六单式投注即从0~9中选择三个数字，组成一注彩票的投注。',
  '时时彩后三组六投注方案为2、5、8，开奖号码后三位与投注号码相同（顺序不限）如528,852等，即为中奖。': '时时彩后三组六投注方 案为2、5、8，开奖号码后三位与投注号码相同（顺序不限）如528,852等，即为中奖。',
  '六、和值': '六、和值',
  '和值就是基本号码数值的总和。': '和值就是基本号码数值的总和。',
  '时时彩后三和值投注方案为和值6，如开奖号码为：123，相加等于6，即可中奖。': '时时彩后三和值投注方案为和值6，如开奖号码为：123，相加等于6，即可中奖。',
  '七、跨度': '七、跨度',
  '跨度是指所选号码的前三位或者后三位数字中，最大的数字和最小的数字之间相差之数。': '跨度是指所选号码的前三位或者后三位数字中，最大的数字和最小的数字之间相差之数。',
  '时时彩前三投注方案为8，若开奖号码为1、2、9，则最大数为9，最小数为1，两者之差为8，即为中奖。': '时时彩前三投注方案为8，若开奖号码为1、2、9，则最大数为9，最小数为1，两者之差为8，即为中奖。',
  什么是追号: '什么是追号',
  '追号是指连续多期购买同一注号码；会员在平台发起一个任务后，系统将按任务要求连续多期地自动购买投注号码。': '追号是指连续多期购买同一注号码；会员在平台发起一个任务后，系统将按任务要求 连续多期地自动购买投注号码。',
  '游戏提供同倍追号、翻倍追号2种追号方式。': '游戏提供同倍追号、翻倍追号2种追号方式。',
  '同倍追号：': '同倍追号：',
  '同倍追号，即设定追号期数和倍数之后，所有的期数的投注倍数都与设置倍数相同。': '同倍追号，即设定追号期数和倍数之后，所有的期数的投注倍数都与设置倍数相同。',
  '翻倍追号：': '翻倍追号：',
  '需要设置“隔期”、“翻倍”，点击“确认投注”，系统将立即生成为与设置一致的投注。': '需要设置“隔期”、“翻倍”，点击“确认投注”，系统将立即生成为与设置一致的投注。',
  追号规则: '追号规则',
  '（1）玩家可以随时发起追号任务，玩家进行追号的同时，不影响其他彩票的购买。': '（1）玩家可以随时发起追号任务，玩家进行追号的同时，不影响其他彩票的购买。',
  '（2）发起追号任务订单，将一次性扣除追号所需金币，账户余额不满足时，任务将不予发起。': '（2）发起追号任务订单，将一次性扣除追号所需金币，账户余额不满足时，任务将不予发起。',
  '（3）当追号发起时，玩家不可停止。如果任务符合玩家设置的追号停止条件时，系统将自动终止追号任务，如还有剩余未追期数，系统将剩余期数的追号金币自动退还至玩家购彩账户。': '（3）当追号发起时，玩家不可停止。如果任务符合玩家设置的追号停止条件时，系统将自动终止追号任务，如还有剩余未追期数，系统将剩余期数的追号金币自动退还至玩家购彩账户。',
  '（4）高频游戏最大可追号期数为该彩种24小时内全部期数。': '（4）高频游戏最大可追号期数为该彩种24小时内全部期数。',
  如何查看追号记录: '如何查看追号记录',
  '“个人中心-投注记录-追号记录”进行查看追号记录。': '“个人中心-投注记录-追号记录”进行查看追号记录。',
  如何查看投注记录: '如何查看投注记录',
  '“个人中心-投注记录“进行查看购彩记录。': '“个人中心-投注记录“进行查看购彩记录。',
  '中奖后如何进行提现？': '中奖后如何进行提现？',
  '提现步骤：': '提现步骤：',
  '第一步： 点击首页【提现】或“个人中心”点击【提现】进入取款页面。': '第一步： 点击首页【提现】或“个人中心”点击【提现】进入取款页面。',
  '第二步：绑定银行卡，点击”添加卡“进入银行卡绑定页面，完善银行卡资料。': '第二步：绑定银行卡，点击”添加卡“进入银行卡绑定页面，完善银行卡资料。',
  '第三步：设置交易密码，点击“提交”，添加银行卡成功。': '第三步：设置交易密码，点击“提交”，添 加银行卡成功。',
  '第四步：回到“提现”页面，输入提现金币和取款密码，点击“确定”。': '第四步：回到“提现”页面，输入提现金币和取款密码，点击“确定”。',
  '最后，恭喜您提现申请成功，我们会尽快审核后安排出款。': '最后，恭喜您提现申请成功，我们会尽快审核后安排出款。',
  '如何查看提现记录和状态？': '如何查看提现记录和状态？',
  '“个人中心-账户明细”，选提现类型，进行查看提现记录。': '“个人中心-账户明细”，选提现类型，进行查看提现记录。',
  '提现时需要注意什么？': '提现时需要注意什么？',
  '确认提交银行卡的准确信息，方便提现时出款顺畅。': '确认提交银行卡的准确信息，方便提现时出款顺畅。',
  '银行卡绑定主要用于会员提现，不能修改、删除。': '银行卡绑定主要用于会员提现，不能修改、删除。',
  '提现金币不可大于可提现资金。': '提现金币不可大于可提现资金。',
  '用户一般需要达到一定的投注量，才能正常办理提现。': '用户一般需要达到一定的投注量，才能正常办理提现。',
  '提现不成功怎么办？': '提现不成功怎么办？',
  '娱乐城最低取款为1金币，单笔最高提款1,000,000金币，当日不限额度。': '娱乐城最低取款为1金币，单笔最高提款1,000,000金币，当日不限额度。',
  '请用户妥善保管取款密码，切勿告知他人，因客户自身原因导致的账号被盗或者资金损失，平台一律不承担相关责任。': '请用户妥善保管取款密码，切勿告知他人，因客户自身原因导致的账号被盗或者资金损失，平台一律不承担相关责任。',
  '提现需要手续费吗？': '提 现需要手续费吗？',
  '提现不限次数，不限额度。': '提现不限次数，不限额度。',
  '提现时产生的银行手续费由本平台承担。': '提现时产生的银行手续费由本平台承担。',
  '提现后多久到账？': '提现后多久到账？',
  '可以通过“个人中心-账户明细”，选择提现类型，进行查看提现状态。': '可以通过“个人中心-账户明细”，选择提现类型，进行查看提现状态。',
  '提现申请成功后审核核对无误，我们将通过银行转账方式提款到您的账户，一般1-5分钟实时到帐。': '提现申请成功后审核核对无误，我们将通过银行转账方式提款到您的账户，一般1-5分钟实时到帐。',
  '可以绑定多张银行卡吗？': '可以绑定多 张银行卡吗？',
  '平台内用户可以绑定多张银行卡，但银行开户人姓名是唯一的。': '平台内用户可以绑定多张银行卡，但银行开户人姓名是唯一的。',
  '会员提现时请仔细核对银行卡信息，目前支持提现银行卡：': '会员提现时请仔细核对银行卡信息，目前支持提现银行卡：',
  '中国工商银行、交通银行、中国银行、中国建设银行、光大银行、华夏银行、民生银行、广发银行、中信银行、中国邮政储蓄银行、浦发银行，以及国内其他主流银行。': '中国工商银行、交通银行、中国银行、中国建设银行、光大银行、华夏银行、民生银行、广发银行、中信银行、中国邮政储蓄银行、浦发银行，以及国内其他 主流银行。',
  '怎么修改银行卡？': '怎么修改银行卡？',
  '为保障用户提现时资金安全，一旦添加银行卡成功，不能对银行进行修改、删除操作。': '为保障用户提现时资金安全，一旦添加银行卡成功，不能对银行进行修改、删除操作。',
  '如果需要修改银行卡开户人姓名，请直接联系客服，并提供相关验证资料后方可修改。': '如果需要修改银行卡开户人姓名，请直接联系客服，并提供相关验证资料后方可修改。',
  '平台的安全保障措施。': '平台的安全保障措施。',
  '一、多重保障及验证': '一、多重保障及验证',
  '用户登录网站后才可以进入在线取款页面，提现时需要交易密码。': '用户登录网站后才可以进入在线取款页面，提现时需要交易密码。',
  '绑定的银行卡，不可修改、删除，防止被他人修改。': '绑定的银行卡，不可修改、删除，防止被他人修改。',
  '银行卡开户人姓名是唯一的，如果修改，需要提供身份验证资料到本平台客服，才能进行修改。': '银行卡开户人姓名是唯一的，如果修改，需要提供身份验证资料到本平台客服，才能进行修改。',
  '二、交易过程加密处理': '二、交易过程加密 处理',
  '为保证资金安全，用户应注意哪些事项？': '为保证资金安全，用户应注意哪些事项？',
  '用户应保障自身电脑处于安全状态，经常使用杀毒软件进行查毒，并实时更新病毒库。': '用户应保障自身电脑处于安全状态，经常使用杀毒软件进行查毒，并实时更新病毒库。',
  '以下注意常态事项：': '以下注意常态事项：',
  '1. 尽量不要在公共场所（如网吧）等登录本网站。': '1. 尽量不要在公共场所（如网吧）等登录本网站。',
  '2. 尽量在不同场合使用有所区别的密码。': '2. 尽量在不同场合使用有所区别的密码。',
  '3. 牢记密码，如作记录则应妥善保管。': '3. 牢记密码，如作记录则应妥善保管。',
  '4. 密码不得告诉他人，包括自己的亲朋好友。': '4. 密码不得告诉他人，包括自己的亲朋好友。',
  '5. 在登录或网上支付密码输入时，应防止左右可疑的人窥视。': '5. 在登录或网上支付密码输入时，应防止左右可疑的人窥视。',
  '6. 预留密码时不要选用您的身份证、生日、电话、门牌、街巷、重复或连续等易被他人破译的数字。建议选用既不易被他人猜到，又方便记忆的密码。': '6. 预留密码时不要选用您的身份证、生日、电话、门牌、街巷、重复或连续等易被他人破译的数字。建议选用既不易被他人猜到，又方便记忆的密码。',
  '7. 发现泄密的危险时，及时更换密码；不定期更换密码。': '7. 发现泄密的危险时，及时更换密码；不定期更换密码。',
  '时时彩，分分彩': '时时彩，分分彩',
  定位胆: '定位胆',
  '玩法说明：从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖': '玩法说明：从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖',
  '投注方案：万位1': '投注方案：万位1',
  '开奖号码：万位1，即中定位胆万位': '开奖号码：万位1，即中定位胆万位',
  二星: '二星',
  '前二直选复式玩法说明：从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖': '前二直选复式玩法说明：从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖',
  '投注方案：58': '投注方案：58',
  '前二直选和值玩法说明：所选数值等于开奖号码万位、千位二个数字相加之和，即为中奖': '前二直选和值玩法说明：所选数值等于开奖号码万位、千位 二个数字相加之和，即为中奖',
  '投注方案：和值1': '投注方案：和值1',
  '开奖号码：前二位01，10，即中前二星直选': '开奖号码：前二位01，10，即中前二星直选',
  '前二直选跨度玩法说明：所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖': '前二直选跨度玩法说明：所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖',
  '投注方案：跨度9': '投注方案：跨度9',
  '开奖号码：前二位90或09，即中前二直选': '开奖号码：前二位90或09，即中前二直选',
  '前二直选单式玩法说明：手动输入号码，至少输入1个2位数号码组成一注，万位、千位与开奖号码全部相同，且顺序一致，即为中奖。': '前二直选单式玩法说明：手动输入号码，至少输入1个2位数号码组成一注，万位、千位与开奖号码全部相同，且顺序一致，即为中奖。',
  '后二直选复式玩法说明：从十位、个位中选择一个2位数号码组成一注，所选号码与开奖号码的后2位相同，且顺序一致，即为中奖。': '后二直选复式玩法说明：从十位、个位中选择一个2位数号码组成一注，所选号码与开奖号码的后2位相同，且顺序一致，即为中奖。',
  '开奖号码：后二位58，即中后二直选': '开奖号码：后二位58，即中后二直选',
  '后二直选和值玩法说明：所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖': '后二直选和值玩法说明：所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖',
  '开奖号码：后二位01，10，即中后二直选。': '开奖号码：后二位01，10，即中后二直选',
  '后二直选跨度玩法说明：所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖': '后二直选跨度玩法说明：所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖',
  '开奖号码：后二位90或09，即中后二直选': '开奖号码：后二位90或09，即中后二直选',
  '后二直选单式玩法说明：手动输入号码，至少输入1个2位数号码组成一注，十位、个位与开奖号码全部相同，且顺序一致，即为中奖': '后二直选单式玩法说明：手动输入号码，至少输入1个2位数号码组成一注，十位、个位与开奖号码全部相同，且顺序一致，即为 中奖',
  '前二组选复式玩法说明：从0-9中选2个号码组成一注，所选号码与开奖号码的万位、千位相同（不含对子号），顺序不限，即中奖': '前二组选复式玩法说明：从0-9中选2个号码组成一注，所选号码与开奖号码的万位、千位相同（不含对子号），顺序不限，即中奖',
  '开奖号码：前二位58或是85（顺序不限，不含对子）即中前二组选': '开奖号码：前二位58或是85（顺序不限，不含对子）即中前二组选',
  '前二组选和值玩法说明：所选数值等于开奖号码的万位、千位的数字之和，即为中奖': '前二组选和值玩法说明：所选数值等于开奖号码的万位、千位的数字之和，即为中奖',
  '开奖号码：前二位10或是01（顺序不限，不含对子）即中前二组选': '开奖号码：前二位10或是01（顺序不限，不含对子）即中前二组选',
  '前二组选包胆玩法说明：从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖': '前二组选包胆玩法说明：从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖',
  '投注方案：包胆8': '投注方案：包胆8',
  '开奖号码：前二位8x，且x不等于8，即中前二组选': '开奖号码：前二位8x，且x不等于8，即中前二组选',
  '前二组选单式玩法说明：手动输入一个2位数号码组成一注，输入号码万位、千位与开奖号码相同（不含对子号），顺序不限，即中奖': '前二组选单式玩法说明：手动输入一个2位数号码组成一注，输入号码万位、千位与开奖号码相同（不含对子号），顺序不限，即中奖',
  '后二组选复式玩法说明：从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同（不含对子号），顺序不限，即中奖': '后二组选复式玩法说明：从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同（不含对子号），顺序不限，即中奖',
  '开奖号码：后二位58或是85（顺序不限，不含对子）即中后二组选': '开奖号码：后二位58或是85（顺序不限，不含对子）即中后二组选。',
  '后二组选和值玩法说明：所选数值等于开奖号码的十位、个位的数字之和，即为中奖': '后二组选和值玩法说明：所选数值等于开奖号码的十位、个位的数字之和，即为中奖',
  '开奖号码：后二位10或是01（顺序不限，不含对子）即中后二组选': '开奖号码：后二位10或是01（顺序不限，不含对子）即中后二组选',
  '后二组选包胆玩法说明：从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖': '后二组选包胆玩法说明：从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中 奖',
  '开奖号码：后二位8x，且x不等于8，即中后二组选': '开奖号码：后二位8x，且x不等于8，即中后二组选',
  '后二组选单式玩法说明：手动输入一个2位数号码组成一注，输入号码十位、个位与开奖号码相同（不含对子号），顺序不限，即中奖': '后二组选单式玩法说明：手动输入一个2位数号码组成一注，输入号码十位、个位与开奖号码相同（不含对子号），顺序不限，即中奖',
  前三: '前三',
  '前三直选复式法说明：从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖': '前三直选复式法说明：从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖',
  '投注方案：345': '投注方案：345',
  '开奖号码：前三位 345，即中前三直选': '开奖号码：前三位 345，即中前三直选',
  '前三直选和值玩法说明：所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖': '前三直选和值玩法说明：所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖',
  '开奖号码：前三位 001、010、100，即中前三直选和值': '开奖号码：前三位 001、010、100，即中前三直选和值',
  '前三直选跨度玩法说明：所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖': '前三直选 跨度玩法说明：所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖',
  '投注方案：跨度8': '投注方案：跨度8',
  '开奖号码：前三位 0,8,X，其中X不等于9；或者前三位1,9,X，其中X不等于0，即中前三直选跨度': '开奖号码：前三位 0,8,X，其中X不等于9；或者前三位1,9,X，其中X不等于0，即中前三直选跨度',
  '前三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码万位、千位、百位相同，且顺序一致，即为中奖': '前三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码万位、千位、百位相同，且顺序一致，即为中奖',
  '投注方案:345': '投注方案:345',
  '开奖号码:前三位 345，即中前三直选。': '开奖号码:前三位 345，即中前三直选。',
  '前三直选组合玩法说明：从万位、千位、百位中至少各选一个号码组成1-3星的组合共3注，所选号码的百位与开奖号码全部相同，则中1个3等奖；所选号码的千位、百位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '前三直选组合玩法说明：从万位、千位、百位中至少各选一个号码组成1-3星的组合共3注，所选号码的百位与开奖号码全部相同，则中1个3等奖；所选号码的千位、百位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '投注方案：购买6+7+8，有以下3注:678(三星)、78(二星)、8(一星)构成': '投注方案：购买6+7+8，有以下3注:678(三星)、78(二星)、8(一星)构成',
  '开奖号码：678，即可中三星、二星、一星各1注': '开奖号码 ：678，即可中三星、二星、一星各1注',
  '前三组选组三玩法说明：从0-9选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖': '前三组选组三玩法说明：从0-9 选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖',
  '投注方案：588': '投注方案：588',
  '开奖号码：前三位 588（顺序不限），即中前三组选三': '开奖号码 ：前三位 588（顺序不限），即中前三组选三',
  '前三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖': '前三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖',
  '投注方案：258': '投注方案：258',
  '开奖号码：前三位 852（顺序不限），即中前三组选六': '开奖号码：前三位 852（顺序不限），即中前三组选六',
  '前三组选和值玩法说明：所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖': '前三组选和值玩法说明：所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖',
  '投注方案：和值3': '投注方案：和值3',
  '开奖号码： 前三位003（顺序不限）即中前三组选三，或者前三位012（顺序不限）即中前三组选和值': '开奖号码： 前三位003（顺序不限）即中前三组选三，或者前三位012（顺序不限）即中前三组选和值',
  '前三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的万位、千 位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '前三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号 ），即为中奖',
  '投注方案：包胆3': '投注方案：包胆3',
  '开奖号码：前三位33x，即中前三组选三，或者前三位3xx，即中前三组选包胆': '开奖号码：前三位33x，即中前三组选三，或者前三位3xx，即中前三组选包胆',
  '前三其他和值尾数玩法说明：所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖': '前三其他和值尾数玩法说明：所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖',
  '投注方案：和值尾数8': '投注方案：和值尾数8',
  '开奖号码：前三位936，和值尾数为8，即中和值尾数': '开奖号码：前三位936，和值尾数为8，即中和值尾数',
  '前三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码前3位属性一致，即为中奖。其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码': '前三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码前3位属性一致，即为中奖。其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三 位数号码',
  '投注方案：豹子对子顺子': '投注方案：豹子对子顺子',
  '开奖号码：前三位888，即中豹子；前三位678，即中顺子；前三位558即中对子': '开奖号码：前三位888，即中豹子；前三位678，即 中顺子；前三位558即中对子',
  中三: '中三',
  '中三直选复式玩法说明：从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖': '中三直选复式玩 法说明：从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖',
  '开奖号码：中三位 345，即中中三直选': '开奖号码：中三位 345，即中中三直选',
  '中三直选和值玩法说明：所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖': '中三直选和值玩法说明：所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖',
  '开奖号码：中三位 001、010、100，即中中三直选和值': '开奖号码：中三位 001、010、100，即中中三直选和值',
  '中三直选跨度玩法说明：所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖': '中三直选跨度玩法说明：所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖',
  '开奖号码：中三位 0,8,X，其中X不等于9；或者中三位1,9,X，其中X不等于0，即中中三直选跨度': '开奖号码：中三位 0,8,X，其中X不等于9；或者中三位1,9,X，其中X不等于0，即中中三直选跨度',
  '中三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码千位、百位、十位相同，且顺序一致，即为中奖': '中三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码千位、百位、十位相同，且顺序一致，即为中奖',
  '开奖号码:中三位 345，即中中三直选。': '开奖号码:中三位 345，即中中三直选',
  '中三直选组合玩法说明：从千位、百位、十位中至少各选一个号码组成1-3星的组合共3注，所选号码的十位与开奖号码全部相同，则中1个3等奖；所选号码的百位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '中三直选组合玩法说明：从千位、百位、十位中至少各选一个号码组成1-3星的组合共3注，所选号码的十位与开奖号码全部相同，则中1个3等奖；所选号码的百位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '中三组选组三玩法说明：从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖': '中三组选组三玩法说明：从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖',
  '开奖号码：中三位 588（顺序不限），即中中三组选三': '开奖号码：中三位 588（顺序不限），即中中三组选三',
  '中三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖': '中三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖',
  '开奖号码：中三位 852（顺序不限），即中中三组选六': '开奖号码：中三位 852（顺序不限），即中中三组选六',
  '中三组选和值玩法说明：所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖': '中三组选和值 玩法说明：所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖',
  '开奖号码： 中三位003（顺序不限）即中中三组选三，或者中三位012（顺序不限）即中中三组选和值': '开奖号码： 中三位003（顺序不限）即中中三组选三，或者中三位012（顺序不限）即中中三组选和值',
  '中三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '中三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖',
  '开奖号码：中三位33x，即中中三组选三，或者中三位3xx，即中中三组选包胆': '开奖号码：中三位33x，即中中三组选三，或者中三位3xx，即中中三组选包胆',
  '中三其他和值尾数玩法说明：所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖': '中三其他和值尾数玩法说明：所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖',
  '开奖号码：中三位936，和值尾数为8，即中和值尾数': '开奖号码：中三位936，和值尾数为8，即中和值尾数',
  '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子号的千 、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码': '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子 号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码',
  '开奖号码：中三位888，即中豹子；中三位678，即中顺子；中三位558即中对子': '开奖号码：中三位888，即中豹子；中三位678，即中顺子；中三位558即中对子',
  后三: '后三',
  '后三直选复式玩法说明：从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖': '后三直选复式玩法说明：从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖',
  '开奖号码：后三位 345，即中后三直选': '开奖 号码：后三位 345，即中后三直选',
  '后三直选和值玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖': '后三直选和值玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖',
  '开奖号码：后三位 001、010、100，即中后三直选和值': '开奖号码：后三位 001、010、100，即中后三直选和值',
  '后三直选跨度玩法说明：所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖': '后三直选跨度玩法说明：所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖',
  '开奖号码：后三位 0,8,X，其中X不等于9；或者后三位1,9,X，其中X不等于0，即中后三直选跨度': '开奖号码：后三位 0,8,X，其中X不等于9；或者后三位1,9,X，其中X不等于0，即中后三直选跨度',
  '后三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码百位、十位、个位相同，且顺序一致，即为中奖': '后三直选单式玩法说明：手动输入一个3位数号码组成一注，所选号码与开奖号码百位、十位、个位相同，且顺序一致，即为中奖',
  '开奖号码:后三位 345，即中后三直选。': '开奖号码:后三位 345，即中后三直选。',
  '后三直选组合玩法说明：从百位、十位、个位中至少各选一个号码组成1-3星的组合共3注，所选号码的个位与开奖号码全部相同，则中1个3等奖；所选号码的个位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '后三直选组合玩法说明：从百位、十位、个位中至少各选一个号码组成1-3星 的组合共3注，所选号码的个位与开奖号码全部相同，则中1个3等奖；所选号码的个位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '后三组选组三玩法说明：从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖': '后三组选组三玩法说明：从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖',
  '开奖号码：后三位 588（顺序不限），即中后三组选三': '开奖号码：后三位 588（顺序不限），即中后三组选三',
  '后三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖': '后三组选组六玩法说明：从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖',
  '开奖号码：后三位 852（顺序不限），即中后三组选六': '开奖号码：后三位 852（顺序不限），即中后三组选六',
  '后三组选和值玩法说明：所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖': '后三组选和值玩法说明：所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖',
  '开奖号码： 后三位003（顺序不限）即中后三组选三，或者后三位012（顺序不限）即中后三组选六': '开奖号码： 后三位003（顺序不限）即中后三组选三，或者后三位012（顺序不限）即中后三组选六',
  '后三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '后三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（ 不含豹子号），即为中奖',
  '开奖号码：后三位33x，即中后三组选三，或者后三位3xx，即中后三组选六': '开奖号码：后三位33x，即中后三组选三，或者后三位3xx，即中后三组选六',
  '后三其他和值尾 数玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖': '后三其他和值尾数玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为 中奖',
  '开奖号码：后三位936，和值尾数为8，即中和值尾数': '开奖号码：后三位936，和值尾数为8，即中和值尾数',
  '后三其他特殊号码尾数玩法说明：所选的号码特殊属性和开奖号码后3位属性一致，即为中奖。其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码': '后三其他特殊号码尾数玩法说明：所选的号码特殊属性和开奖号码后3位 属性一致，即为中奖。其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码',
  '开奖号码：后三位888，即中豹子；后三位678，即中顺子；后三位558即中对子': '开奖号码：后三位888，即中豹子；后三位678，即中顺子；后三位558即中对子',
  四星: '四星',
  '组选24玩法说明：从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖': '组选24玩法说明：从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖',
  '投注方案：0 5 6 8': '投注方案：0 5 6 8',
  '开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24': '开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24',
  '组选12玩法说明：选择1个二重号码和2个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选二重号码在开奖号码中出现了2次，即为中奖': '组选12玩法说明：选择1个二重号码和2个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选二重号码在开奖号码中出现了2次，即为中奖',
  '投注方案：二重号：8，单号：0、6': '投注方案：二重号：8，单号：0、6',
  '只要开奖的四个数字从小到大排列为 0、6、8、8，即可中四星组选12': '只要开奖的四个数字从小到大排列为 0、6、8、8，即可中四星组选12',
  '组选6玩法说明：选择2个二重号码组成一注，所选的2个二重号码在开奖号码的千位、百位、十位、个位中分别出现了2次，即为中奖': '组选6玩法说明：选择2个二重号码组成一注，所选的2个二重号码在开奖号码的千位、百位、十位、个位中分别出现了2次，即为中奖',
  '投注方案：二重号：2、8': '投注方案：二重号：2、8',
  '只要开奖的四个数字从小到大排列为2、2、8、8，即可中四星组选6': '只要开奖的四个数字从小到大排列为2、2、8、8，即可中四星组选6',
  '组选4玩法说明：选 择1个三重号码和1个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖': '组选4玩法说明：选择1个三重号码和1个单号号码组 成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖',
  '投注方案：三重号：8，单号：2': '投注方案：三重号：8，单号：2',
  '只要开奖的四个数字从小到大排列为2、8、8、8，即可中四星组选4': '只要开奖的四个数字从小到大排列为2、8、8、8，即可中四星组选4',
  '后四直选复式玩法说明：从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖': '后四直选复式玩法说明：从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖',
  '投注方案：3456': '投注方案：3456',
  '开奖号码：3456，即中四星直选': '开奖号码：3456，即中四星直选',
  五星: '五星',
  '组选120玩法说明：从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖': '组选120玩法说明：从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖',
  '投注方案：10568': '投注方案：10568',
  '开奖号码：10568（顺序不限），即可中五星组选120': '开奖号码：10568（顺序不限），即可中五星组选120',
  '组选60玩法说明：选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖': '组选60玩法说明：选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖',
  '投注方案：二重号：8；单号：016': '投注方案：二重号：8；单号：016',
  '开奖号码：01688（顺序不限），即可中五星组选60': '开奖号码：01688（顺序不限），即可中五星组选60',
  '组选30玩法说明：选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖': '组选30玩法说明：选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖',
  '投注方案：二重号：68；单号：0': '投注方案：二重号：68；单号：0',
  '开奖号码：06688（顺序不限），即可中五星组选30': '开奖号码：06688（顺序不限），即可中五星组选30',
  '组选20玩法说明：选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖': '组选20玩法说明：选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖',
  '投注方案：三重号：8；单号：01': '投注方案：三重号：8；单号：01',
  '开奖号码：01888（顺序不限），即可中五星组选20': '开奖号码：01888（顺序不限），即可中五星组 选20',
  '组选10玩法说明：选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖': '组选10玩法说明：选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖',
  '投注方案：三重号：8；二重号：1': '投注方案：三重号：8；二重号：1',
  '开奖号码：11888（顺序不限），即可中五星组选10': '开奖号码：11888（顺序不限），即可中五星组选10',
  '组选5玩法说明：选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖': '组选5玩法说明：选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖',
  '投注方案：四重号：8；单号：1': '投注方案：四重号：8；单号：1',
  '开奖号码：18888（顺序不限），即可中五星组选5': '开奖号码：18888（顺序不限），即可中五星组选5',
  '五星直选复式玩法说明：从万位、千位、百位、十 位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖': '五星直选复式玩法说明：从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开 奖号码全部相同，且顺序一致，即为中奖',
  '投注方案：13456': '投注方案：13456',
  '开奖号码：13456，即中五星直选': '开奖号码：13456，即中五星直选',
  猜数字: '猜数字',
  特殊玩法: '特殊玩法',
  大小单双: '大小单双',
  '大小单双后二玩法说明：对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '大小单双后二玩法说明：对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '投注方案：大单': '投注方案：大单',
  '开奖号码：十位与个位“大单”，即中后二大小单双': '开奖号码：十位与个位“大单”，即中后二大小单双',
  '大小单双后三玩法说明：对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所 选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '大小单双后三玩法说明：对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、 型态与开奖号码的位置、型态相同，即为中奖',
  '投注方案：大单大': '投注方案：大单大',
  '开奖号码：百位、十位、个位“大单大”，即中后三大小单双': '开奖号码：百位、十位、个位“大单大”，即中后三大小单双',
  '大小单双前二玩法说明：对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '大小单双前二玩法说明：对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '开奖号码：万位与千位“大单”，即中前二大小单双': '开奖号码：万位与千位“大单”，即中前二大小单双',
  '大小单双前三玩法说明：对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '大小单双前三玩法说明：对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与 开奖号码的位置、型态相同，即为中奖',
  '开奖号码：万位、千位、百位“大单大”，即中前三大小单双': '开奖号码：万位、千位、百位“大单大”，即中前三大小单双',
  趣味: '趣味',
  '一帆风顺玩法说明 ：从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖': '一帆风顺玩法说明：从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位 、百位、十位、个位中包含所选号码，即为中奖',
  '投注方案：8': '投注方案：8',
  '开奖号码：至少出现1个8，即中一帆风顺。': '开奖号码：至少出现1个8，即中一帆风顺。',
  '好事成双玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现2次，即为中奖': '好事成双玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、 千位、百位、十位、个位中出现2次，即为中奖',
  '开奖号码：至少出现2个8，即中好事成双。': '开奖号码：至少出现2个8，即中好事成双',
  '三星报喜玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现3次，即为中奖': '三星报喜玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现3 次，即为中奖',
  '开奖号码：至少出现3个8，即中三星报喜。': '开奖号码：至少出现3个8，即中三星报喜',
  '四季发财玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现4次，即为中奖': '四季发财玩法说明：从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现4次，即为中奖',
  '开奖号码：至少出现4个8，即中四季发财。': '开奖号码：至少出现4个8，即中四季发财',
  不定位: '不定位',
  '前三一码不定位玩法说明：从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖': '前三一码不定位玩法说明：从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖',
  '投注方案：1': '投注方案：1',
  '开奖号码：前三位至少出现1个1，即中前三一码不定位': '开奖号码：前三位至少出现1个1，即中前三一码不定位',
  '前三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖': '前三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖',
  '投注方案：12': '投注方案：12',
  '开奖号码：前三位至少出现1和2各一个，即中前三二码不定位': '开奖号码：前三位至少出现1和2各一个，即中前三二码不定位',
  '后三一码不定位玩法说明：从0-9中选择1个号码，每注 由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖': '后三一码不定位玩法说明：从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码， 即为中奖',
  '开奖号码：后三位至少出现1个1，即中后三一码不定位': '开奖号码：后三位至少出现1个1，即中后三一码不定位',
  '后三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖': '后三二码不定位玩法说明：从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖',
  '开奖号码：后三位至少出现1和2各一个，即中后三二码不定位': '开奖号码：后三位至少出现1和2各一个，即中后三二码不定位',
  '前四一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖': '前四一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖',
  '开奖号码：前四位，至少出现1个1，即中前四一码不定位': '开奖号码：前四位，至少出现1个1，即中前四一码不定位',
  '前四二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖': '前四二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中 同时包含所选的2个号码，即为中奖',
  '开奖号码：前四位，至少出现1和2各一个，即中前四二码不定位': '开奖号码：前四位，至少出现1和2各一个，即中前四二码不定位',
  '后四一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖': '后四一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的 千位、百位、十位、个位中包含所选号码，即为中奖',
  '开奖号码：后四位，至少出现1个1，即中后四一码不定位': '开奖号码：后四位，至少出现1个1，即中后四一码不定位',
  '后四二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖': '后四二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖',
  '开奖号码：后四位，至少出现1和2各一个，即中后四二码不定位': '开奖号码：后四位，至少出现1和2各一个，即中后四二 码不定位',
  '五星一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖': '五星一码不定位玩法说明：从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖',
  '开奖号码：至少出现1个1，即中五星一码不定位': '开奖号码：至少出现1个1，即中五星一码不定位',
  '五星二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖': '五星二码不定位玩法说明：从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖',
  '开奖号码：至少出现1和2各一个，即中五星二码不定位': '开奖号码：至少出现1和2各一个，即中五星二码不定位',
  '五星三码不定位玩法说明：从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖': '五星三码不定位玩法说明：从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖',
  '投注方案：123': '投注方案：123',
  '开奖号码：至少出现1、2、3各一个，即中五星三码不定位': '开奖号码：至少出现1、2、3各一个，即中五星三码不定位',
  任选二: '任选二',
  '任选二直选复式玩法说明：从万位、千位、百位、十位、个位中至少两位上各选1个号码组成一注，所有号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '任选二直选复式玩法说明：从万位、千位、百位、十位、个位中至少两位上各选1个号码组成 一注，所有号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '投注方案：万位5、百位8': '投注方案：万位5、百位8',
  '开奖号码：51812，即中任选二直选。': '开奖号码：51812，即中任选二直选。',
  '任选二直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '任选二直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '投注方案：位置选择万位、百位，输入号码58': '投注方案：位置选择万位、百位，输入号码58',
  '开奖号码：51812，即中任二直选单式': '开奖号码：51812，即中任二直选单式',
  '任选二直选和 值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖': '任选二直选和值玩法说明：从万位、千位、百位、 十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖',
  '投注方案：位置选择万位、百位，选择和值号码13': '投注方案：位置选择万位、百位，选择和值号码13',
  '开奖号码：51812，即中任二直选和值': '开奖号码：51812，即中任二直选和值',
  '任选二组选复式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,号码区至少选择两个号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选二组选复式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,号码区至少选择两个号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择万位、百位，选择号码85': '投注方案：位置选择万位、百位，选择号码85',
  '开奖号码：51812或81512，即中任二组选': '开奖号码：51812或81512，即中任二组选',
  '任选二组选单式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选二组选单式玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择万位、百位，输入入号码85': '投注方案：位置选择万位、百位，输入入号码85',
  '开奖号码：51812或81512，即中任二组选(单式)': '开奖号码：51812或81512，即中任二组选(单式)',
  '任选二组选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置 ，至少选择一个和值号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。': '任选二组选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值 号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。',
  '位置选择万位、百位，选择和值号码13': '位置选择万位、百位，选择和值号码13',
  '开奖号码：51812，即中任二组选和值': '开奖号码：51812，即中任二组选和值',
  任选三: '任选三',
  '任选三直选复式玩法说明：从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '任选三直选复式玩法说明：从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '投注方案：万位5、百位8、个位2': '投注方案：万位5、百位8、个位2',
  '开奖号码：51812，即为中任三直选': '开奖号码：51812，即为中任三直选',
  '任选三直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '任选三直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '投注方案：位置选择万位、百位、个位，输入号码582': '投注方案：位置选择万位、百位、个位，输入号码582',
  '开奖号码：51812，即中任三直选（单式）': '开奖号码：51812，即中任三直选（单式）',
  '任选三直选和值玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖': '任选三直选和值玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,至少 选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖',
  '投注号码：位置选择万位、百位、个位，选择和值号码15': '投注号码：位置选择万位、百位、个位，选择和值号码15',
  '开奖号码：51812，即中任选三直选和值': '开奖号码：51812，即中任选三直选和值',
  '任选三组三复式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选三组三复式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：选择位置万位、十位、个位，选择号码12': '投注方案：选择位置万位、十位、个位，选择号码12',
  '开奖号码：11812，即中任三组三': '开奖号码：11812，即中任三组三',
  '任选三组三单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选三组三单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：选择位置万位、十位、个位，输入号码122': '投注方案：选择位置万位、十位、个位，输入号码122',
  '开奖号码：11122，即中任三组三（单式）': '开奖号码：11122，即中任三组三（单式）',
  '任选三组六复式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选三组六复式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：选择位置万位、十位、个位，选择号码512': '投注方案：选择位置万位、十位、个位，选择号码512',
  '开奖号码：51812，即中任三组六': '开奖号码：51812，即中任三组六',
  '任选三组六单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选三组六单式玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：选择位置万位、十位、个位，输入号码512': '投注方案：选择位置万位、十位、个位，输入号码512',
  '任选三组选混合玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选三组选混合玩法说明：从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '开奖号码：51812，即中任三混合组选': '开奖号码：51812，即中任三混合组选',
  任选四: '任选四',
  '任选四直选复式玩法说明：从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '任选四直选复式玩法说明：从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '投注方案：万位5、千位1、百位8、十位1': '投注方案：万 位5、千位1、百位8、十位1',
  '开奖号码：51812，即中任四直选': '开奖号码：51812，即中任四直选',
  '任选四直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序致，即为中奖': '任选四直选单式玩法说明：从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序致，即为中奖',
  '投注方案：选择万位、千位、百位、十位，输入号码5181': '投注方案：选择万位、千位、百位、十位，输入号码5181',
  '开奖号码：51812，即中任四直选（单式）': '开奖号码：51812，即中任四直选（单式）',
  '任选四组选24玩法说明：从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选四组选24玩法说明：从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择千位、百位、十位、个位，号码选择0568': '投注方案：位置选择千位、百位、十位、个位，号码选择0568',
  '开奖号码：10568（指定位置号码顺序不限），即中任四组选24': '开奖号码：10568（指定位置号码顺序不限），即中任四组选24',
  '任选四组选12玩法说明：从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选四组选12玩法说明：从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择千位、百位、十位、个位，二重号：8；单号06': '投注方案：位置选择千位、百位、十位、个位，二重号：8；单号06',
  '开奖号码：10688（指定位置号码顺序不限），即中任四组选12': '开奖号码：10688（指定位置号码顺序不限）， 即中任四组选12',
  '任选四组选6玩法说明：从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选四组选6玩法说明：从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择千位、百位、十位、个位，二重号：28': '投注方案：位置选择千位、百位、十位、个位，二重号：28',
  '开奖号码：12288（指定位置号码顺序不限）即中任四组选6': '开奖号码：12288（指定位置号码顺序不限）即中任四组选6',
  '任选四组选4玩法说明：从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖': '任选四组选4玩法说明：从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注，所选号码与开奖号码的指定位置 上的号码相同，且顺序不限，即为中奖',
  '投注方案：位置选择千位、百位、十位、个位，三重号：8；单号：2': '投注方案：位置选择千位、百位、十位、个位，三重号：8；单号：2',
  '开奖号码：18828（指定位置号码顺序不限），即中任四组选4': '开奖号码：18828（指定位置号码顺序不限），即中任四组选4',
  时时彩信用: '时时彩信用',
  '单双说明：': '单双说明：',
  "开奖 结果万位、仟位、佰位、拾位或个位数字为1、3、5、7、9时为'单'，若为0、2、4、6、8时为'双'，当投注位数单双与开奖结果的位数单双相符时，即为中奖": "开奖结果万位、仟位、佰位、拾位或个位 数字为1、3、5、7、9时为'单'，若为0、2、4、6、8时为'双'，当投注位数单双与开奖结果的位数单双相符时，即为中奖",
  '单：1、 3、 5、 7、 9': '单：1、 3、 5、 7、 9',
  '双：0、 2、 4、 6、 8': '双：0、 2、 4、 6、 8',
  '开奖号码：20130（1为单），则视为中奖': '开奖号码：20130（1为单），则视为中奖',
  '大小说明：': '大小说明：',
  '开奖结果万位、仟位、佰位、拾位或个位数字为5、6、7、8、9时为“大”，若为0、1、2、3、4时为“小”，当投注位数大小与开奖结果的位数大小相符时，即为中奖': '开奖结果万位、仟位、佰位、拾位或个位数字为5、6、7、8、9时为“大”，若为0、1、2、3、4时为“小”，当投注位数大小与开奖结果的位数大小相符时，即为中奖',
  '开奖号码：20352（3为小），则视为中奖': '开奖号码：20352（3为小），则视为中奖',
  '龙虎说明：': '龙 虎说明：',
  '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码， 开和视为不中奖': '龙：开出之号码第一球(万位)的中奖号码大于第五球(个位)的中奖号码， 开和视为不中奖',
  '和：开出之号码第一球(万位)的中奖号码等于第五球(个位)的中奖号码': '和：开出之号码第一球(万位)的中奖号码等于第五球(个位)的中奖号码',
  '龙：开奖号码为4***2，则投注龙局者视为中奖': '龙：开奖号码为4***2 ，则投注龙局者视为中奖',
  '虎：开奖号码为7***9，则投注虎局者视为中奖': '虎：开奖号码为7***9，则投注虎局者视为中奖',
  '和：开奖号码为2***2，则投注和局者视为中奖': '和：开奖号码为2***2，则投注和局者视为中奖',
  '总和说明：': '总和说明：',
  '总大：开奖结果5个号码加起的总和，大于等于23为总大': '总大：开奖结果5个号码加起的总和，大于等于23为总大',
  '总小：开奖结果5个号码加起的总和，小于等于22为总小': '总小：开奖结果5个号码加起的总和，小于等于22为总小',
  '总单：开奖结果5个号码加起的总和为单数': '总单：开奖结果5个号码加起的总和为单数',
  '总双：开奖结果5个号码加起的总和为双数': '总双：开奖结果5个号码加起的总和为双数',
  '总大：投注者购买总和大，当期开奖结果如为总数为28，则视为中奖': '总大：投注者购买总和大，当期开奖结果如为总数为28，则视为中奖',
  '总小：投注者购买总和小，当期开奖结果如为总数为18，则视为中奖': '总小：投注者购买总和小，当期开奖结果如为总数为18，则视为中奖',
  '总单：投注者购买总和单，当期开奖结果如为总数为29，则视为中奖': '总单：投注者购买总和单，当期开奖结果如为总数为29，则视为中奖',
  '总双：投注者购买总和双，当期开奖结果如为总数为18，则视为中奖': '总双：投注者购买总和双，当期开 奖结果如为总数为18，则视为中奖',
  '豹子说明：': '豹子说明：',
  中奖号码的百位千位万位数字都相同: '中奖号码的百位千位万位数字都相同',
  '中奖号码为000、111、999等，中奖号码的百位千位万位数字相同，则投注豹子者视为中奖，其它视为不中奖': '中奖号码为000、111、999等，中奖号码的百位千位万位数字相同，则投注豹子者视为中奖，其它视为不中奖',
  '顺子说明：': '顺子说明：',
  '中奖号码的百位千位万位数字都相连，不分顺序': '中奖号码的百位千位万位数字都相连，不分顺序',
  '中奖号码为123、321、546等，中奖号码百位千位万位数字相连，则投注顺子者视为中奖，其它视为不中奖': '中奖号码为123、321、546等，中奖号码百位千位万位数字相连，则投注顺子者视为中奖，其它视为不中奖',
  '对子说明：': '对子说明：',
  '中奖号码的百位千位万位任意两位数字相同。（不包括豹子)': '中奖号码的百位千位万位任意两位数字相同。（不包括豹子)',
  '中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖': '中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖',
  '如果开奖号码为豹子，则对子视为不中奖': '如果开奖号码为豹子，则对子视为不中奖',
  '半顺说明：': '半顺 说明：',
  '中奖号码为125、540、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖': '中奖号码为125、540、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖',
  '如果开奖号码为顺子、对子,则半顺视为不中': '如果开奖号码为顺子、对子,则半顺视为不中',
  '杂六说明：': '杂六说明：',
  '不包括豹子、对子、顺子、半顺的所有中奖号码': '不包括豹子、对子、顺子、半顺的所有中奖号码',
  '如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖': '如中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖',
  中奖号码的十位百位千位数字都相同: '中奖号码的十位百位千位数字都相同',
  '中奖号码的十位百位千位数字都相连，不分顺序': '中奖号码的十位百位千位数字都相连，不分顺序',
  '如中奖号码为123、321、546等，中奖号码十位百位千位数字相连，则投注顺子者视为中奖，其它视为不中奖': '如中奖号码为123、321、546等，中奖号码十位百位千位数字相连，则投注顺子者视为中奖，其它视为不中奖',
  '中奖号码的十位百位千位任意两位数字相同。（不包括豹子）': '中奖号码的十位百位千位任意两位数字相同。（不包括豹子）',
  '如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖': '如中奖号码为001，112、696，中奖号码有两位数字相同，则投注对子者视为中奖，其它视为不中奖',
  '中奖号码的十位百位千位任意两位数字相连，不分顺序。（不包括顺子、对子。）': '中奖号码的十位百位千位任意两位数字相连，不分顺序。（不包括顺子、对子。）',
  '如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖': '如中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖',
  '如果开奖号码为顺子、对子,则半顺视为不中奖': '如果开奖号码为顺子、对子,则半顺视为不中奖',
  '中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖': '中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖',
  中奖号码的个位十位百位数字都相同: '中奖号码的个位十位百位数字都相同',
  '中奖号码为000、111、999等，中奖号码的个位十位百位数字相同，则投注豹子者视为中奖，其它视为不中奖': '中奖号码为000、111、999等，中奖号码的个位十位百位数字相同，则投注豹子者视为中奖，其它视为不中奖',
  '中奖号码的个位十位百位数字都相连，不分顺序': '中奖号码的个位十位百位数字都相连，不分顺序',
  '中奖号码为123、321、546等，中奖号码个位十位百位数字相连，则投注顺子者视为中奖，其它视为不中奖': '中奖号码为123、321、546等，中奖号码个位十位百位数字相连，则投注顺子者视为中奖，其它视为不中奖',
  '中奖号码的个位十位百位任意两位数字相同。（不包括豹子）': '中奖号码的个位十位百位任意两位数字相同。（不包括豹子）',
  '中奖号码的个位十位百位任意两位数字相连，不分顺序。（不包括顺子、对子。）': '中奖号码的个位十位百位任意两位数 字相连，不分顺序。（不包括顺子、对子。）',
  '中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖': '中奖号码为125、540、390、706，中奖号码有两位数字相连，则投注半顺者视为中奖，其它视为不中奖',
  '广东11选5，上海11选5，江西11选5，山东11选5，辽宁11选5': '广东11选5，上海11选5，江西11选5，山东11选5，辽宁11选5',
  三码: '三码',
  '五星直选复式玩法说明：从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖': '五星直选复式玩法说明：从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖',
  '后三其他和值尾数玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖': '后三其他和值尾数玩法说明：所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖',
  '前三直选复式说明：从万 位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码一致，即为中奖': '前三直选复式说明：从万位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码 一致，即为中奖',
  '投注方案：03，04，05': '投注方案：03，04，05',
  '开奖号码：前三位03，04，05，即中前三直选': '开奖号码：前三位03，04，05，即中前三直选',
  '前三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖': '前三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖',
  '投注方案:02 05 08': '投注方案:02 05 08',
  '开奖号码:前三位08 05 02（顺序不限），即中前三组选。': '开奖号码:前三位08 05 02（顺序不限），即中前三组选',
  '前三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖': '前三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖',
  '投注方案:胆码02，拖码01 06': '投注方案:胆码02，拖码01 06',
  '开奖号码:前三位02 01 06（顺序不限）即中前三组选胆拖。': '开奖号码:前三位02 01 06（顺序不限）即中前三组选胆拖',
  '中三直选复式说明：从千位、百位、十位至少个选1个号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖': '中三直选复式说明：从千位、百位、十位至少个选1个号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖',
  '投注方案:03 04 05': '投注方案:03 04 05',
  '开奖号码:中三位03 04 05，即中中三直选。': '开奖号码:中三位03 04 05，即中中三直选。',
  '开奖号码:中三位03 04 05，即中中三直选': '开奖号码:中三位03 04 05，即中中三直选',
  '中三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖': '中三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖',
  '开奖号码:中三位08 05 02（顺序不限），即中中三组选': '开奖号码:中三位08 05 02（顺序不限），即中中三组选',
  '中三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖': '中三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖',
  '开奖号码:中三位02 01 06（顺序不限）即中中三组选胆拖': '开奖号码:中三位02 01 06（顺序不限）即中中三组选 胆拖',
  '后三直选复式说明：从百位、十位、个位至少个选1个号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖': '后三直选复式说明：从百位、十位、个位至少个选1个号码组成一 注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖',
  '开奖号码:后三位03 04 05，即中后三直选': '开奖号码:后三位03 04 05，即中后三直选',
  '后三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖': '后三组选复式说明：从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖',
  '开奖号码:后三位08 05 02（顺序不限），即中后三组选': '开奖号码:后三位08 05 02（顺序不限），即中后三组选',
  '后三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖': '后三组选胆拖说明：从01-11中，选取3个及以上的号码进行投注，每注需 至少包括1个胆码及2个拖码。所选单注号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖',
  '开奖号码:后三位02 01 06（顺序不限）即中后三组选胆拖。': '开奖号码:后三位02 01 06（顺序不限）即中后三组选胆拖',
  二码: '二码',
  '前二直选复式说明：从万位、千位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖': '前二直选复式说明：从万位、千位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖',
  '投注方案:05 08': '投注方案:05 08',
  '开奖号码:前二位05 08，即中前二直选': '开奖号码:前二位05 08，即中前二直选',
  '前二组选复式说明：从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的万位、千位相同，顺序不限，即为中奖': '前二组选复式说明：从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的万位、千位相同，顺序不限，即为中奖',
  '开奖号码:前二位08 05 （顺序不限），即中前二组选': '开奖号码:前二位08 05 （顺序不限），即中前二组选',
  '前二组选胆拖说明 ：从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖': '前二组选胆拖说明：从01-11中，选取2个及以上 的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖',
  '投注方案:胆码02，拖码06': '投注方案:胆码02，拖码06',
  '开奖号码:前二位02 06（顺序不限）即中前二组选胆拖': '开奖号码:前二位02 06（顺序不限）即中前二组选胆拖',
  '后二直选复式说明：从十位、个位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖': '后二直选复式说明：从十位、个位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖',
  '开奖号码:后二位05 08，即中后二直选': '开奖号码:后二位05 08，即中后二直选',
  '后二组选复式说明：从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖': '后二组选复式说明：从01-11中任意选择2个或2 个以上号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖',
  '开奖号码:后二位08 05 （顺序不限），即中后二组选': '开奖号码:后二位08 05 （顺序不限），即中后二组选',
  '后二组选胆拖说明：从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的十位、个位相同，顺序不限，即为中奖': '后二组选胆拖说明：从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的十位、个位相同，顺序不限，即为中奖',
  '开奖号码:后二位02 06（顺序不限）即中后二组选胆拖': '开 奖号码:后二位02 06（顺序不限）即中后二组选胆拖',
  '定位胆说明：从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖': '定位胆说 明：从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖',
  '投注方案:万位1': '投注方案:万位1',
  '开奖号码:万位1，即中定位胆万位': '开奖号码:万位1，即中定位胆万位',
  任选复式: '任选复式',
  '任选复式一中一说明：从01-11共11号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式一中一说明：从01-11共11号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案：05': '投注方案：05',
  '开奖号码:08 04 11 05 03，即中一中一。': '开奖号码:08 04 11 05 03，即中一中一',
  '任选复式二中二说明：从01-11共11号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式二中二说明：从01-11共11号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 04': '投注方案:05 04',
  '开奖号码:08 04 11 05 03，即中二中二': '开奖号码:08 04 11 05 03，即中二中二',
  '任选复式三中三说明：从01-11共11号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式三中三说明：从01-11共11号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 04 11': '投注方案:05 04 11',
  '开奖号码:08 04 11 05 03，即中三中三': '开奖号码:08 04 11 05 03，即中三中 三',
  '任选复式四中四说明：从01-11共11号码中选择4个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式四中四说明：从01-11共11号码中选择4个号码进行购买， 只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 04 08 03': '投注方案:05 04 08 03',
  '开奖号码:08 04 11 05 03，即中四中四': '开奖号码:08 04 11 05 03，即中四中四',
  '任选复式五中五说明：从01-11共11号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式五中五说明：从01-11共11号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 04 11 03 08': '投注方案:05 04 11 03 08',
  '开奖号码:08 04 11 05 03，即中五中五': '开奖号码:08 04 11 05 03，即中五中五',
  '任选复式六中五说明：从01-11共11号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式六中五说明：从01-11共11号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 10 04 11 03 08': '投注方案:05 10 04 11 03 08',
  '开奖号码:08 04 11 05 03，即中六中五': '开奖号码:08 04 11 05 03，即中六 中五',
  '任选复式七中五说明：从01-11共11号码中选择7个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式七中五说明：从01-11共11号码中选择7个号码进行购买 ，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 10 04 11 03 08 09': '投注方案:05 10 04 11 03 08 09',
  '开奖号码:08 04 11 05 03，即中七中五': '开奖号码:08 04 11 05 03，即中七中五',
  '任选复式八中五说明：从01-11共11号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖': '任选复式八中五说明：从01-11共11号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖',
  '投注方案:05 10 04 11 03 08 09 01': '投注方案:05 10 04 11 03 08 09 01',
  '开奖号码:08 04 11 05 03，即中八中五': '开奖号码:08 04 11 05 03，即中八中五',
  任选胆拖: '任选胆拖',
  '任选胆拖二中二说明：分别从胆码和拖码的01-11中，至少选择1个胆码和1个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和拖码，所选胆码必须全中，即为中奖': '任选胆拖二中二说明：分别从胆码和拖码的01-11中，至少选择1个胆码和1个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和拖码，所选胆码必须全中，即为中奖',
  '投投注方案:05 04': '投投注方案:05 04',
  '开奖号码:08 04 11 05 03，即任选中二中二': '开奖号码:08 04 11 05 03，即任选中二中二',
  '任选胆拖三中三说明：分别从胆码和拖码的01-11中，至少选择1个胆码和2个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和2个拖码，所选胆码必须全中，即为中奖': '任选胆拖三中三说 明：分别从胆码和拖码的01-11中，至少选择1个胆码和2个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和2个拖码，所选胆码必须全中，即为中奖',
  '投注方案:胆码08，拖码06 11': '投注方案:胆码08，拖码06 11',
  '开奖号码:06 08 11 09 02，即任选中三中三': '开奖号码:06 08 11 09 02，即任选中三中三',
  '任选胆拖四中四说明：分别从胆码和拖码的01-11中，至少选择1 个胆码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖': '任选胆拖四中四说明：分别从胆码和拖码的01-11中，至少选择1个胆 码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖',
  '投注方案:胆码08，拖码06 09 11': '投注方案:胆码08，拖码06 09 11',
  '开奖号码:06 08 11 09 02，即任选中四中四': '开奖号码:06 08 11 09 02，即任选中四中四',
  '任选胆拖五中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序 摇出的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖': '任选胆拖五中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序摇出 的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖',
  '投注方案:胆码08，拖码02 06 09 11': '投注方案:胆码08，拖码02 06 09 11',
  '开奖号码:06 08 11 09 02，即任选中五中五': '开奖号码:06 08 11 09 02，即任选中五中五',
  '任选胆拖六中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码 和拖码的任意组合中，即为中奖': '任选胆拖六中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即 为中奖',
  '投注方案:胆码08，拖码02 05 06 09 11': '投注方案:胆码08，拖码02 05 06 09 11',
  '开奖号码:06 08 11 09 02，即任选中六中五': '开奖号码:06 08 11 09 02，即任选中六中五',
  '任选胆拖 七中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖': '任选胆拖七中五说明：分别从胆码 和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖',
  '投注方案:胆码08，拖码01 02 05 06 09 11': '投注方案:胆 码08，拖码01 02 05 06 09 11',
  '开奖号码:06 08 11 09 02，即任选中七中五': '开奖号码:06 08 11 09 02，即任选中七中五',
  '任选胆拖八中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和7个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖': '任选胆拖八中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和7个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖',
  '投注方案:胆码08，拖码01 02 03 05 06 09 11': '投注方案:胆码08，拖码01 02 03 05 06 09 11',
  '开奖号码:06 08 11 09 02，即任选中八中五。': '开奖号码:06 08 11 09 02，即任选中八中五',
  '北京赛车，五分赛车，三分赛车，分分赛车，澳洲赛车，幸运赛车': '极速赛车，五分赛车，三分赛车，分分赛车，澳洲赛车，幸运赛车',
  冠亚和值: '冠亚和值',
  '选“单“': '选“单“',
  '开奖号码：第一名01，第二名02，和值01+02=03为单，即中奖。': '开奖号码：第一名01，第二名02，和值01+02=03为单，即中奖',
  '选“大“': '选“大“',
  '开奖号码：第一名05,第二名07，和值05+07=12为大，即中奖。': '开奖号码：第一名05,第二名07，和值05+07=12为大，即中奖',
  '冠亚和指定说明：“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖。': '冠 亚和指定说明：“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖。',
  选择10: '选择10',
  '开奖号码：第一名01，第二名为09，和值为01+09=10即中奖': '开奖号码：第一名01，第二名为09，和值为01+09=10即中奖',
  其它玩法: '其它玩法',
  '猜冠军说明：选择1个号码组成一注。所选号码与当期冠军一致，即为中奖': '猜冠军说明：选择1个号码组成一注。所选号码与当期冠军一致，即为中奖',
  '投注方案：2': '投注方案：2',
  '开奖号码：2 *,即中猜冠军': '开奖号码：2 *,即中猜冠军',
  '猜冠亚军说明：选择2个数字号码竞猜全部开奖号码，投注号码与开奖号码前2相同中奖': '猜冠亚军说明：选择2个数字号码竞猜全部开奖号码，投注号码与开奖号码前2相同中奖',
  '投注方案：1 2': '投注方案：1 2',
  '开奖号码：1 2 *,即中猜冠亚军': '开奖号码：1 2 *,即中猜冠亚军',
  '猜前三名说明：选择3个数字号码竞猜全部开奖号码，投注号码与开奖号码前3相同中奖': '猜前三名说明：选择3个数字号码竞猜全部开奖号码，投注号码与开奖号码前3相同中奖',
  '投注方案：1 2 3': '投注方案：1 2 3',
  '开奖号码：1 2 3 *，即中猜冠亚季军': '开奖号码：1 2 3 *，即中猜冠亚季军',
  '投注方案：冠：小双': '投注方案：冠：小双',
  '开奖号码：冠：小双，即中小双': '开奖号码：冠：小双，即中小双',
  '龙虎说明：开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖': '龙虎说明：开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖',
  '投注方案：龙': '投注方案：龙',
  '开奖号码：8********1，即中猜龙虎斗': '开奖号码：8********1，即中猜龙虎斗',
  '定位胆说明：从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖': '定位胆说明：从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖',
  第一名01: '第一名01',
  '开奖号码:万位1，即中定位胆万位。': '开奖号码:万位1，即中定位胆万位。',
  '开奖号码：第一名01，即中定位胆第一名。': '开奖号码：第一名01，即中定位胆第一名。',
  出码规则: '出码规则',
  '1. 以官方时时彩开奖第四位，第五位拼合组成一”组合号码“。': '1. 以官方时时彩开奖第四位，第五位拼合组 成一”组合号码“。',
  '2. 将组合号码按情况得出特别号码开奖结果:': '2. 将组合号码按情况得出特别号码开奖结果:',
  '1) 组合号码为 00，则当期所有该游戏投注均以不中奖计算。': '1) 组合号码为 00，则当期所有该游戏投注均以不中奖计算。',
  '2) 组合号码 = 50,则当期所有该游戏投注均以中奖,并且中奖奖金固定为 1.8倍(不含返点)计算。': '2) 组合号码 = 50,则当期所有该游戏投注均以中奖,并且中奖奖金固定为 1.8倍(不含返点)计算。',
  '3) 组合号码 > 50(不含50),则以 100 减去 组合号码数值作为当期开奖结果特别号码。': '3) 组合号码 > 50(不含50),则以 100 减去 组合号码数值作为当期开奖结果特别号码。',
  '4) 其他情况下直接以组合号码所代表数值作为当期开奖结果特别号码。': '4) 其他情况下直接以组合号码所代表数值作为当期开奖结果特别号码。',
  '例如：第四位为1，第五位为3，那么当期特码等则为 13': '例如：第四位 为1，第五位为3，那么当期特码等则为 13',
  号码规则: '号码规则',
  '红波：01, 02, 07, 08, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46': '红波：01, 02, 07, 08, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46',
  '绿波：05, 06, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49': '绿波：05, 06, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49',
  '蓝波：03, 04, 09, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48': '蓝波：03, 04, 09, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48',
  赔率: '赔率',
  '特码：1 赔 41.00 倍': '特码：1 赔 41.00 倍',
  '生肖(详看生肖表)：1 赔 10.40 倍': '生肖(详看生肖表)：1 赔 10.40 倍',
  '大小单双：1 赔 1.80 倍': '大小单双：1 赔 1.80 倍',
  '波色： 赔 2.70 倍': '波色： 赔 2.70 倍',
  '组合：1 赔 3.60 倍': '组合：1 赔 3.60 倍',
  生肖表: '生肖表',
  '鼠: 1, 13, 25, 37, 49': '鼠: 1, 13, 25, 37, 49',
  '牛: 12, 24, 36, 48': '牛: 12, 24, 36, 48',
  '虎: 11, 23, 35, 47': '虎: 11, 23, 35, 47',
  '兔: 10, 22, 34, 46': '兔: 10, 22, 34, 46',
  '龙: 9, 21, 33, 45': '龙: 9, 21, 33, 45',
  '蛇: 8, 20, 32, 44': '蛇: 8, 20, 32, 44',
  '马: 7, 19, 31, 43': '马: 7, 19, 31, 43',
  '羊: 6, 18, 30, 42': '羊: 6, 18, 30, 42',
  '猴: 5, 17, 29, 41': '猴: 5, 17, 29, 41',
  '鸡: 4, 16, 28, 40': '鸡: 4, 16, 28, 40',
  '狗: 3, 15, 27, 39': '狗: 3, 15, 27, 39',
  '猪: 2, 14, 26, 38': '猪: 2, 14, 26, 38',
  生肖号码按当年公历年份计算: '生肖号码按当年公历年份计算',
  '开奖频率：': '开奖频率：',
  '三同号通选说明：对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出，即为中奖': '三同号通选说明：对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出，即为中奖',
  '前三直选复式说明：从万位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码一致，即为中奖': '前三直选复式说明：从万位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码一致，即为中奖',
  '彩种名称：北京28，销售时间：09:00~23:55，每日期数：179，开奖频率：5分钟': '彩种名称：北京28，销售时间：09:00~23:55，每日期数：179，开奖频率：5分钟',
  '彩种名称：幸运28，销售时间：00:00~23:59，每日期数：288，开奖频率：5分钟': '彩种名称：幸运28，销售时间：00:00~23:59，每日期数：288，开奖频率：5分钟',
  '彩种名称：澳洲幸运20，销售时间：00:00~23:59，每日期数：288，开奖频率：5分钟': '彩种名称：澳洲幸运20，销售时间：00:00~23:59，每日期数：288，开奖频率：5分钟',
  '彩种名称：台湾宾果，销售时间：07:05~23:55，每日期数：203，开奖频率：5分钟': '彩种名称：台湾宾果 ，销售时间：07:05~23:55，每日期数：203，开奖频率：5分钟',
  '玩法说明：': '玩法说明：',
  '3、大小单双:': '3、大小单双:',
  '大：14，15，16，17，18，19，20，21，22，23，24，25，26，27': '大：14，15，16，17，18，19，20，21，22，23，24，25，26，27',
  '小：0，1，2，3，4，5，6，7，8，9，10，11，12，13': '小：0，1，2，3，4，5，6，7，8，9，10，11，12，13',
  '单：1，3，5，7，9，11，13，15，17，19，21，23，25，27': '单：1，3，5，7，9，11，13，15，17，19，21，23，25，27',
  '双：0，2，4，6，8，10，12，14，16，18，20，22，24，26': '双：0，2，4，6，8，10，12，14，16，18，20，22，24，26',
  '极大：23，24，25，26，27': '极大：23，24，25，26，27',
  '极小：0，1，2，3，4': '极小：0，1，2，3，4',
  '大单：15、17、19、21、23、25、27': '大单：15、17、19、21、23、25、27',
  '小单：1、3、5、7、9、11、13': '小单：1、3、5、7、9、11、13',
  '大双：14、16、18、20、22、24、26': '大双：14、16、18、20、22、24、26',
  '小双：0、2、4、6、8、10、12': '小双：0、2、4、6、8、10、12',
  '绿波号码：1、4、7、10、16、19、22、25': '绿波号码：1、4、7、10、16、19、22、25',
  '蓝波号码：2、5、8、11、17、20、23、26': '蓝波号码：2、5、8、11、17、20、23、26',
  '红波号码：3、6、9、12、15、18、21、24': '红波号码：3、6、9、12、15、18、21、24',
  '初级房赔率说明：': '初级房赔率说明：',
  '特殊说明：': '特殊说明：',
  '中级房赔率说明：': '中级房赔率说明：',
  '高级房赔率说明：': '高级房赔率说明：',
  '初级房回水比例说明：': '初级房回水比例说明：',
  '亏损（当天）': '亏损（当天）',
  '中级房回水比例说明：': '中级房回水比例说明：',
  '高级房回水比例说明：': '高级房回水比例说明：',
  '回水条件：': '回水条件：',
  '任选胆拖七中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖': '任选胆拖七中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖',
  '前二组选胆拖说明：从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖': '前二组选胆拖说明：从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖',
  '后三一码不定位玩法说明：从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖': '后三一码不定位玩法说明：从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖',
  '前三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '前三组选包胆玩法说明：从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖',
  '江苏快3，湖北快3，北京快3，河北快3，甘肃快3，上海快3，三分快三，分分快三，五分快三，云南快三，四川快三，青海快三，山西快三，河南快三，宁夏快三': '江苏快3，湖北快3，北京快3，河北快3，甘肃快3，上海快3，三分快三，分分快三，五分快三，云南快三，四川快三，青海快三，山西快三，河南快三，宁夏快三',
  '和值玩法说明：至少选择1个和值（3个号码之和）进行投注，所选和值与开奖的3个号码的和值相同，即为中奖': '和值玩法说明：至少选择1个和值（3个号码之和）进行投注，所选和值与开奖的3个号码的和值相同 ，即为中奖',
  '开奖号码:1 3 4，即中和值': '开奖号码:1 3 4，即中和值',
  '二同号单选说明：选择1对相同号码和1个不同号码投注，选号与奖号相同（顺序不限），即为中奖': '二同号单选说明：选择1 对相同号码和1个不同号码投注，选号与奖号相同（顺序不限），即为中奖',
  '投注方案：选号：同号 1 1 不同号 3': '投注方案：选号：同号 1 1 不同号 3',
  '开奖号码:1 1 3，即中二同号单选': '开奖 号码:1 1 3，即中二同号单选',
  '二同号复选说明：从11～66中任选1个或多个号码，选号与奖号（包含11～66，不限顺序）相同，即为中奖': '二同号复选说明：从11～66中任选1个或多个号码，选号与奖号（包含11～66，不限顺序）相同，即为中奖',
  '投注方案：选号：1 1': '投注方案：选号：1 1',
  '开奖号码:1 1 2，即中二同号复选': '开奖号码:1 1 2，即中二同号复选',
  '二不同号说明：从1～6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖': '二不同号说明：从1～6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖',
  '投注方案：选号：1 2': '投注方案：选号：1 2',
  '开奖号码:1 2 3，即中二不同号': '开奖号码:1 2 3，即中二不同号',
  '三不同号说明：从1～6中任选3个或多个号码，所选号码与开奖号码的3个号码相同，即为中奖': '三不同号说明： 从1～6中任选3个或多个号码，所选号码与开奖号码的3个号码相同，即为中奖',
  '投注方案：选号：2 4 6': '投注方案：选号：2 4 6',
  '开奖号码:2 4 6，即中三不同号': '开奖号码:2 4 6，即中三不同号',
  '三同号单选说明：对相同的三个号码（111、222、333、444、555、666）中的任意一个进行投注，所选号码开出，即为中奖': '三同号单选说明：对相同的三个号码（111、222、333、444、555、666）中的任意一个进行投注，所选号码开出，即为中奖',
  '投注方案：选号：1 1 1': '投注方案：选号：1 1 1',
  '开奖号码:1 1 1，即中三同号单选': '开奖号码:1 1 1，即中三同号单选',
  '三同号通选说明： 对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出，即为中奖': '三同号通选说明：对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出 ，即为中奖',
  '投注方案：选号：三同号通选': '投注方案：选号：三同号通选',
  '开奖号码:1 1 1，即中三同号通选': '开奖号码:1 1 1，即中三同号通选',
  '三连号通选说明：对所有3个相连的号码（123、234、345、456）进行投注，任意号码开出，即为中奖': '三连号通选说明：对所有3个相连的号码（123、234、345、456）进行投注，任意号码开出，即为中奖',
  '投注方案：选号：三连号通选': '投注 方案：选号：三连号通选',
  '开奖号码:1 2 3，即中三连号通选': '开奖号码:1 2 3，即中三连号通选',
  '单码/双面规则说明︰ ': '单码/双面规则说明︰ ',
  '任选二组选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。': '任选二组选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。',
  '定位说明：指冠军、亚军、季军、第四、第五 、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖': '定位说明：指冠军、亚军、季军、第四、第五、第六、 第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖',
  '大小说明：开出的号码大于或等于6为大，小于或等于5为小 ': ' 大小说明：开出的号码大于或等于6为大，小于或等于5为小 ',
  '单双说明：号码为双数叫双，如4、6；号码为单数叫单，如3、5 ': '单双说明：号码为双数叫双，如4、6；号码为单数叫单，如3、5 ',
  longguanjun01: "龙：冠军号码大于第十名号码视为'龙'中奖，如冠军开出07，第十名开出03。",
  huguanjun01: '虎：冠军号码小于第十名号码视为"虎"中奖，如冠军开出03，第十名开出07。',
  'longguanjun02"龙"中奖，如亚军开出07，第九名开出03。': '龙：亚军号码大于第九名号码视为"龙"中奖，如亚军开出07，第九名开出03。',
  longguanjun02: '龙：亚军号码大于第九名号码视为"龙"中奖，如亚军开出07，第九名开出03。',
  huguanjun02: '虎：亚军号码小于第九名号码视为"虎"中奖，如亚军开出03，第九名开出07。',
  longguanjun03: '龙：季军号码大于第八名号码视为"龙"中奖，如季军开出07，第八名开出03。',
  huguanjun03: '虎：季军号码小于第八名号码视为"虎"中奖，如季军开出03，第八名开出07。',
  longguanjun04: '龙：第四名号码大于第七名号码视为"龙"中奖，如第四名开出07，第七名开出03。',
  huguanjun04: '虎：第四名号码小于第七名号码视为"虎"中奖，如第四名开出03，第七名开出07。',
  '任选二直选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖': '任选二直选和值玩法说明：从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖',
  longguanjun05: '龙：第五名号码大于第六名号码视为"龙"中奖，如第五名开出07，第六名开出03。',
  huguanjun05: '虎：第五名号码小于第六名号码视为"虎"中奖，如第五名开出03，第六名开出07。',
  '冠亚军和说明：冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖 ': '冠亚军和说明：冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖 ',
  longhuguanjun01: '冠亚军和大小说明：当开奖结果冠军号码与亚军号码的和值大于11为大，投注"和大"则视为中奖；小于等于11为小，投注"和小"则视为中奖 ',
  longhuguanjun02: '冠亚军和单双说明：当开奖结果冠军号码与亚军号码的和值为单数如9、13，投注"和单"则视为中奖；为双数如12、16，投注"和双"则视为中奖 ',
  '幸运飞艇，三分飞艇，分分飞艇': '幸 运飞艇，三分飞艇，分分飞艇',
  '冠亚和指定玩法说明：“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖': '冠亚和指定玩法说明：“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖',
  '前一直选复式玩法说明：选号与开奖号码按位猜对1位即中奖': '前一直选复式玩法说明：选号与开奖号码按位猜对1位即中奖',
  '一帆风顺玩法说明：从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖': '一帆风顺玩法说明：从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖',
  '投注方案：01': '投注方案：01',
  '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前一直选。': '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前一直选',
  '前二直选复式玩法说明：选号与开奖号码按位猜对2位即中奖': '前二直选复式玩法说明：选号与开奖号码按位猜对2位即中奖',
  '投注方案：01 02': '投注方案：01 02',
  '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前二直选。': '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前二直选',
  '前三直选复式玩法说明：选号与开奖号码按位猜对3位即中奖': '前三直选复式玩法说明：选号与开奖号码按位猜对3位即中奖',
  '投注方案：01 02 03': '投注方 案：01 02 03',
  '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前三直选。': '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前三直选',
  '前四直选复式玩法说明：选号与开奖号码按位猜对4位即中奖': '前四直选复式玩法说明：选号与开奖号码按位猜对4位即中奖',
  '投注方案：01 02 03 04': '投注方案：01 02 03 04',
  '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前四直选。': '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前四直选',
  '前五直选复式玩法说明：选号与开奖号码按位猜对5位即中奖': '前五直选复式玩法说明：选号与开奖号码按位猜对5位即中奖',
  '投注方案：01 02 03 04 05': '投注方案：01 02 03 04 05',
  '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前五直选。': '开奖号码：01 02 03 04 05 06 07 08 09 10 即中前五直选',
  '龙虎玩法说明：开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖': '龙虎玩法说明：开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖',
  '定位胆玩法说明：从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖': '定位胆玩法说明：从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖',
  '定位玩法说明：指冠军、亚 军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖': '定位玩法说明：指冠军、亚军、 季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖',
  '大小玩法说明：开出的号码大于或等于6为大，小于或等于5为小 ': '大小玩法说明：开出的号码大于或等于6为大，小于或等于5为小 ',
  '单双玩法说明：号码为双数叫双，如4、6；号码为单数叫单，如3、5 ': '单双玩法说明：号码为双数叫双，如4、6；号码为单数叫单，如3、5 ',
  '家禽、野兽开出的特码属于十二生肖中的牛、马、羊、鸡、狗、猪号码为家禽，开出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。': '家禽、野兽开出的特码属于十二生肖中的牛、马、羊、鸡、狗、猪号码为家禽，开出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。',
  '开奖结果万位、仟位、佰位、拾位或个位数字为1、3、5、7、9时为"单"，若为0、2、4、6、8时为"双"，当投注位数单双与开奖结果的位数单双相符时，即为中奖': '开奖结果万位、仟位、佰位、拾位或个位数字为1、3、5、7、9时为"单"，若为0、2、4、6、8时为"双"，当投注位数单双与开奖结果的位数单双相符时，即为中奖',
  '合尾大、小以特码个位和十位数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。': '合尾大、小以特码个位和十位数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。',
  '冠亚军和玩法说明：冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖 ': '冠亚军和玩法说明：冠军号码与亚军号码的和值区间为3~19，当投注组合符合冠亚军和值，即视为中奖 ',
  '冠亚军和大小玩法说明：当开奖结果冠军号码与亚军号码的和值大于11为大，投注"和大"则视为中奖；小于等于11为小，投注"和小"则视为中奖': '冠亚军和大小玩法说明：当开奖结果冠军号码与亚军号码的和值大于11为大，投注"和大"则视为中奖；小于等于11为小，投注"和小"则视为中奖',
  '冠亚军和单双玩法说明：当开奖结果冠军号码与亚军号码的和值为单数如9、13，投注"和单"则视为中奖；为双数如12、16，投注"和双"则视为中奖': '冠亚军和单双玩法说明：当开奖结果冠军号码与亚军号码的和值为单数如9、13，投注"和单"则视为中奖；为双数如12、16，投注"和双"则视为中奖',
  '每期六合彩开奖球数共七粒(最后一码为特码)具体玩法规则如下': '每期六合彩开奖球数共七粒(最后一码为特码)具体玩法规则如下',
  '定位说明：指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖': '定位说明：指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖',
  '特码︰': '特码︰',
  "奇偶开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注”偶“者中奖；如果奇数和偶数号码数目相同时（均为 3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。": "奇偶开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注”偶“者中奖；如果奇数和偶数号码数目相同时（均为 3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。",
  '特码单、双 特码为双数叫特双，如8、16；特码为单数叫特单，如21、35；49则均为和。': '特码单、双 特码为双数叫特双，如8、16；特码为单数叫特单，如21、35；49则均为和。',
  '特码大、小开出之特码大于或等于25为特码大，小于或等于24为特码小；49则均为和。': '特码大、小开出之特码大于或等于25为特码大，小于或等于24为特码小；49则均为和。',
  '特码大单、大双特码为双数且大于或等于26叫大双，如26、42；特码为单数且大于或等于25叫大单，如25、37；49则均为和。': '特码大单、大双特码为双数且大于或等于26叫大双，如26、42；特码为单数且大于或等于25叫大单，如25、37；49则均为和。',
  '特码小单、小双特码为双数且小于或等于24叫小双，如8、16；特码为单数且小于或等于23叫小单，如11、21；49则均为和。': '特码小单、小双特码为双数且小于或等于24叫小双，如8、16；特码为单数且小于或等于23叫小单，如11、21；49则均为和。',
  '特码总和大所有七个开奖号码的分数总和大于或等于175。': '特码总和大所有七个开奖号码的分数总和大于或等于175。',
  '特码总和小所有七个开奖号码的分数总和小于或等于174。': '特码总和小所有七个开奖号码的分数总和小于或等于174。',
  '特码总和单所有七个开奖号码的分数总和是‘单数’，如分数总和是133、197。': '特码总和单所有七个开奖号码的分数总和是‘单数’，如分数总和是133、197。',
  '特码总和双所有七个开奖号码的分数总和是‘双数’，如分数总和是120、188。': '特码总和双所有七个开奖号码的分数总和是‘双数’，如分数总和是120、188。',
  '特尾大、小开出之特码取出尾数大于或等于5为特尾大，小于或等于4为特尾小；49则均为和。': '特尾大、小开出之特码取出尾数大于或等于5为特尾大，小于或等 于4为特尾小；49则均为和。',
  '特码合单双以特码个位和十位数字之和来判断胜负，如01、12、29、32、47为合单；02、11、33、48为合双；49则均为和。': '特码合单双以特码个位和十位数字之和来判 断胜负，如01、12、29、32、47为合单；02、11、33、48为合双；49则均为和。',
  '特码合大小以特码个位和十位数字之和来判断胜负，介于1-6为合小；介于7-12为合大；13则为和。如01、24、33为合小；07、34、48为合大；49则为和。': '特码合大小以特码个位和十位数字之和来判断胜负，介于1-6为合小；介于7-12为合大；13则为和。如01、24、33为合小；07、34、48为合大；49则为和。',
  '合尾大 、小以特码个位和十位数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。': '合尾大、小以特码个位和十位 数字之和取出尾数来判断胜负，尾数大于或等于5为合尾大，如14、24、42；尾数小于或等于4为合尾小，如19、37、49；若特码开出25则为和局。',
  '家禽、野兽开出的特码属于十二生肖中的牛、马、羊 、鸡、狗、猪号码为家禽，开出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。': '家禽、野兽开出的特码属于十二生肖中的牛、马、羊、鸡、狗、猪号码为家禽，开 出的特码属于十二生肖中的鼠、虎、龙、蛇、兔、猴号码为野兽；开出49则视为和局。',
  '特码六合彩公司当期开出的最后一码为特码，假如投注号码为开出之特码，视为中奖，其余情形视为不中奖。': '特码六合彩公司当期开出的最后一码为特码，假如投注号码为开出之特码，视为中奖，其余情形视为不中奖。',
  '特大小开出之特码落在1~16为小；17~32为中；33~48为大；49则为和。': '特大小开出之特码落在1~16为小；17~32为中；33~48为大；49则为和。',
  '上下号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特 码替换，最终计算结果：1,2,3,5,6,7）。': '上下号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号 码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最 终计算结果：1,2,3,5,6,7）。',
  descText2: "奇偶开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注”偶“者中奖；如果奇数和偶数 号码数目相同时（均为 3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。",
  '上下号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。': '上下号码1至24为上盘号码，25至48为下盘号码。开出的前6个正码中：如上盘号码占多数（超过4个）时，此局为上盘；下盘号码占多数时为下盘；上下盘号码在此局开出的数目相同时（各3个数字），此局为和盘。如果6个正码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。',
  '以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖； 若当期特码开出49号，则视为和局；其余情形视为不中奖。': '以特码色波和特单，特双，特大，特小为一个投注组合，当期特码开出符合投注组合，即视为中奖； 若当期特码 开出49号，则视为和局；其余情形视为不中奖。',
  特肖生肖顺序为: '特肖生肖顺序为',
  '依顺序将49个号码分为12个生肖(如下)，再以生肖下注；若当期特码落在下注生肖范围内，则视为中奖。': '依顺序将49个号码分为12个生肖(如下)，再以生肖下注；若当期特码落在下注生肖范围内，则视为中奖。',
  '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为中奖，其余情形视为不中奖(请注意49亦算输赢，不为和)': '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为中奖，其余情形视为不中奖(请注意49亦算输赢，不为和)',
  '大小单双后三玩法说明：对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '大小单双后三玩法说明：对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '任选胆拖四中四说明：分别从胆码和拖码的01-11中，至少选择1个胆码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖': '任选胆拖四中四说明：分别从胆码和拖码的01-11中，至少选择1个胆码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖',
  '任选胆拖五中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖': '任选胆拖五中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖',
  '任选胆拖六中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖': '任选胆拖六中五说明：分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖',
  '定位玩法说明：指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖': '定位玩法说明：指冠军、亚军、季军、第四、第五、第六、第七、第八、第九、第十名出现的顺序与号码为派彩依据如现场第一个开奖号码为3号，投注冠军为3则视为中奖，其它号码视为不中奖',
  '正码特正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其余情形视为不中奖。': '正码特正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其余情形视为不中奖。',
  '六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码一，依次为正码二、正码三┅ 正码六 （并不以号码大小排序）。正码一、正码二┅ 正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、为单；正码二为10，则正码二为小、为双；号 码若开出为49，则大小、单双与合码皆视为和局。': '六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫 正码一，依次为正码二、正码三┅ 正码六 （并不以号码大小排序）。正码一、正码二┅ 正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、 为单；正码二为10，则正码二为小、为双；号 码若开出为49，则大小、单双与合码皆视为和局。',
  '龙虎斗以龙和虎点数大小比较来判断胜负，龙大于虎则投注"龙"者中奖，如龙开8，虎开1；若龙小于虎则投注"虎"者中奖。 注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49。': '龙虎斗以龙和虎点数大小比较来判断胜负，龙大于虎则投注"龙"者中奖，如龙开8，虎开1；若龙小于虎则投注"虎"者中奖。 注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49。',
  '连码︰': '连码︰',
  '(1)三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为 三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。': '(1)三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三 个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。',
  '(2)三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其余情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖': '(2)三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其余情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖',
  '(3)二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其余情形（含一个正码加一个特码）视为不中奖。': '(3)二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其余情形（含一个正码加一个特码）视为不中奖。',
  '(4)二中特:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其余情形视为不中奖。': '(4)二中特:所投注的每二个号码为一组合，二个号码都是开奖号码 之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其余情形视为不中奖。',
  '复式是多个号码的不完全重复组合。': '复式是多个号码的不完全重复组合。',
  '胆拖只有胆选项 与拖选项，把胆选项选入的号码与拖选项选入的号码根据玩法指定号码个数，进行排列组合成为投注项号码的一种投注方法(胆项与拖项的同项号码不进行排列组合)。': '胆拖只有胆选项与拖选项，把胆 选项选入的号码与拖选项选入的号码根据玩法指定号码个数，进行排列组合成为投注项号码的一种投注方法(胆项与拖项的同项号码不进行排列组合)。',
  '(5)特串:所投注的每二个号码为一组合，其中一 个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正码）视为不中奖。': '(5)特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正 码）视为不中奖。',
  '(6)生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '(6)生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '(7)生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对 碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '(7)生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不 重复组合进行下注。[应用于连码等项目]',
  '(8)尾数对碰:是一种简易模式，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '(8)尾 数对碰:是一种简易模式，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三 中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。': '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三 中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。',
  '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其余情形视为不中 奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖': '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其余情形视为不 中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖',
  '二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其余情形（含一 个正码加一个特码）视为不中奖。': '二全中:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，视为中奖，其余情形（含一个正码加一个特码）视为不中奖。',
  '二中特:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其余情形视为不中奖。': '二中特:所投注的每二个号码为一组合，二个号码都是开奖号码之正码，叫二中特之中二；若其中一个是正码，一个是特码，叫二中特之中特；其余情形视为不中奖。',
  '特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正码）视为不中奖。': '特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正码）视为不中奖。',
  '生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '生肖对碰:是一种简易模式，生肖都相对应号码，选择两个生肖对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于 连码等项目]': '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '尾数对碰:是一种简易模式 ，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '尾数对碰:是一种简易模式，尾数都相对应号码，选择两个尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '一肖指开奖正码及特码７个号码当中含有所下注生肖内的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。': '一肖指开奖正码及特码７个号码当中含有所下注生肖内的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。',
  '今年为鼠年，则由鼠年为起始生肖，其生肖号码代表请参考「特肖」项目规则': '今年为鼠年，则由鼠年为起始生肖，其生肖号码代表请参考「特肖」项目规则',
  '3. 如果充值成功后，2小时或者长时间用户账户余额未变，请核实银行账户是否扣款成功。': '3. 如果充值成功后，2小时或者长时间用户账户余额未变，请核实银行账户是否扣款成功。',
  '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码': '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码',
  '七色波:': '七色波:',
  '以开出的7个色波为例，哪种 颜色最多为中奖。 开出的6个正码各以1个色波计，特别号以1.5个色波计。而以下3种结果视为和局。': '以开出的7个色波为例，哪种颜色最多为中奖。 开出的6个正码各以1个色波计，特别号以1.5个色 波计。而以下3种结果视为和局。',
  '3：6个正码开出3绿3红，而特别码是1.5蓝;': '3：6个正码开出3绿3红，而特别码是1.5蓝;',
  '尾数:': '尾数:',
  '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不 论同尾数号码出现一个或多个号码都只派彩一次。': '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同尾数号码出现一个或多个号码都只派彩一次 。',
  '1尾:01, 11, 21, 31, 41': '1尾:01, 11, 21, 31, 41',
  '2尾:02, 12, 22, 32, 42': '2尾:02, 12, 22, 32, 42',
  '3尾:03, 13, 23, 33, 43': '3尾:03, 13, 23, 33, 43',
  '4尾:04, 14, 24, 34, 44': '4尾:04, 14, 24, 34, 44',
  '5尾:05, 15, 25, 35, 45': '5尾:05, 15, 25, 35, 45',
  '6尾:06, 16, 26, 36, 46': '6尾:06, 16, 26, 36, 46',
  '7尾:07, 17, 27, 37, 47': '7尾:07, 17, 27, 37, 47',
  '8尾:08, 18, 28, 38, 48': '8尾:08, 18, 28, 38, 48',
  '9尾:09, 19, 29, 39, 49': '9尾:09, 19, 29, 39, 49',
  '0尾:10, 20, 30, 40': '0尾:10, 20, 30, 40',
  '例如：开奖结果正码是 11、31、 42、 44、 35、 32 特码21，则1尾2尾4尾5尾都为中奖，其他尾数都不中奖。': '例如：开奖结果正码是 11、31、 42、 44、 35、 32 特码21，则1尾2尾4尾5尾都为中奖，其他尾数都不中奖。',
  '合肖：': '合肖：',
  '依合肖类别挑选1到11个生肖（排列如同生肖）为一个组合，并选择开奖号码的特码是否在此组合内，若选择【中】且开奖号码的特码亦在此组合内，则视为中奖。若选择【不中】且开奖号码的特码一不在此组合内，即视为中奖，其余情形视为不中奖；开出49则视为和局。': '依合肖类别挑选1到11个生肖（排列如同生肖）为一个组合，并选择开奖号码的特码是否在此组合内，若选择【中】且开奖号码的特码亦在此组合内，则视为中奖。若选择【不中】且开奖号码的特码一不在此组合内，即视为中奖，其余情形视为不中奖；开出49则视为和局。',
  '自选不中︰': '自选不中︰',
  '(1)五不中:所投注的 每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(1)五不中: 所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(3)七不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(3)七不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(4)八不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(4)八不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(5)九不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(5)九不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(6)十不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注 号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(6)十不中:所投注的每个号码为一个组合,其 中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(7)十一不中:所投 注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢 ，不为和)': '(7)十一不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号 码,视为中奖(请注意49亦算输赢，不为和)',
  '(8)十二不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(8)十二不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '连肖依选择的连肖类别挑选 2 ～ 5 个生肖（排列如同生肖）为一个组合，当期的开奖号码 （六个正码及特码）座落于所勾选之生肖组合所属号码内，且所勾选之生肖皆至少有中一个号码，则视为中奖；其余情形一律视为不中奖；若选择的生肖组合内有包含本年生肖则称之为正肖，没有包含本年生肖则称之为平肖，正肖与平肖的中奖赔率不同(请注意49亦算输赢，不为和)。': '连肖依选择的连肖类别挑选 2 ～ 5 个生肖（排列如同生肖）为一个组合，当期的开奖号码 （六个正码及特码）座落于所勾选之生肖组合所属号码内，且所勾选之生肖皆至少有中一个号码，则视为中奖；其余情形一律视为不中奖；若选择的生肖组合内有包含本年生肖则称之为正肖，没有包含本年生肖则称之为平肖，正肖与平肖的中奖赔率不同(请注意49亦算输赢，不为和)。',
  '连尾:': '连尾:',
  '组选4玩法说明：选择1个三重号码和1个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖': '组选4玩法说明：选择1个三重号码和1个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖',
  '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为 中奖，其余情形视为不中奖(请注意49亦算输赢，不为和)': '挑选2～7个尾数为一组合，当期号码（所有正码与最后出的特码）座落于投注时所勾选之尾数组合所属号码内，则视为中奖，其余情形视为不 中奖(请注意49亦算输赢，不为和)',
  '举例1∶下注2尾碰，勾选0,1，当期七个号码若0尾及1尾皆有开出，视为中奖。 （尾数所对应的号码和尾数项目的一样；一个尾数对应多个号码，不论同尾数的号码出现一个或多个，派彩只派一次。每个尾数都有自己的赔率，下注组合的总赔率，取该组合尾数的最低赔率为总赔率）': '举例1∶下注2尾碰，勾选0,1，当期七个号码若0尾及1尾皆有开出，视为中奖。 （尾数所对应的号码和尾数项目的一样；一个尾数对应多个号码，不论同尾数的号码出现一个或多个，派彩只派一次。每个尾数都有自己的赔率，下注组合的总赔率，取该组合尾数的最低赔率为总赔率）',
  '1. 二尾连[中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '1. 二尾连[中]：选择二个尾数为一投注组合进行下注。该注的二个 尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '2. 三尾连[中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '2. 三尾连[中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '3. 四尾连[中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '3. 四尾连[中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '4. 二尾连[不中]：选择二个尾数为一投注组合进行下注。该注的二个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '4. 二尾连[不中]：选择二个尾数为一投注组合进行下注。 该注的二个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '5. 三尾连[不中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '5. 三尾连[不中]：选择三个尾数为一投注组合进行下注。该注的三个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  '6. 四尾连[不中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。': '6. 四尾连[不中]：选择四个尾数为一投注组合进行下注。该注的四个尾数必须没在当期开出的7个开奖号码相对应的尾数中，视为中奖。',
  "龙虎斗以龙和虎点数大小比较来判断胜负，龙大于虎则投注'龙'者中奖，如龙开8，虎开1；若龙小于虎则投注'虎'者中奖。 注:1点最小，48点最大，如龙和虎点数有49则打为和。��龙开3，虎开49。": "龙虎斗以龙和虎点数大小比较来判断胜负，龙大于虎则投注'龙'者中奖，如龙开8，虎开1；若龙小于虎则投注'虎'者中奖。 注:1点最小，48点最大，如龙和虎点数有49 则打为和。��龙开3，虎开49。",
  '(1)三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。': '(1)三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其余情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。',
  '胆拖只有胆选项与拖选项，把胆选项选入的号码与拖选项选入的号码根据玩法指定号码个数，进行排列组合成为投注项号码的一种投注方法(胆项与拖项的同项号码不进行排列组合)。': '胆拖只有胆选项与拖选项，把胆选项选入的号码与拖选项选入的号码根据玩法指定号码个数，进行排列组合成为投注项号码的一种投注方法(胆项与拖项的同项号码不进行排列组合)。',
  '(5)特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正码）视为不中奖。': '(5)特串:所投注的每二个号码为一组合，其中一个是正码，一个是特码，视为中奖，其余情形（含二个号码都是正码）视为不中奖。',
  '(7)生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]': '(7)生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目]',
  '(1)五不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(1)五不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(2)六不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(2)六不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(6)十不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(6)十不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '(7)十一不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '(7)十一不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  '以开出的7个色波为例，哪种颜色最多为中奖。 开出的6个正码各以1个色波计，特别号以1.5个色波计。而以下3种结果视为和局。': '以开出的7个色波为例，哪种颜色最多为中奖。 开出的6个正码各以1个色波计，特别号以1.5个色波计。而以下3种结果视为和局。',
  '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同尾数号码出现一个或多个号码都只派彩一次。': '指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同尾数号码出现一个或多个号码都只派彩一次。',
  '销售时间:00:00:00~24:00:00': '销售时间:00:00:00~24:00:00',
  '每日期数:288': '每日期数:288',
  '开奖频率:5分钟一次': '开奖频率:5分钟 一次',
  '玩法说明:参考时时彩信用彩': '玩法说明:参考时时彩信用彩',
  '玩法说明:参考PK10信用彩': '玩法说明:参考PK10信用彩',
  '玩法说明:参考PC蛋蛋': '玩法说明:参考PC蛋蛋',
  '每日期数:203': '每日期数:203',
  '投注方案:3456': '投注方案:3456',
  '投注方桉:13456': '投注方桉:13456',
  '投注方案:1': '投注方案:1',
  '封盘后系统瞬时提取数字货币价格，该价格的后3位数字相加得到“和值X”': '封盘后系统瞬时提取数字货币价格，该价格的后3位数字相加得到“和值X”',
  '正反投玩法：如果“和值X”大于等于10则只取个位数，若小于10则取“和值X”作为结果': '正反投玩法：如果“和值X”大于等于10则只取个位数，若小于10则取“和值X”作为结果',
  '0，2，4，6，8 是双；1，3，5，7，9为单；0，1，2，3，4 是小；5，6，7，8，9是大': '0，2，4，6，8 是双；1，3，5，7，9为单；0，1，2，3，4 是小；5，6，7，8，9是大',
  '反投：竞猜不是开奖结果的数值。 比如反投“ 0 ”若开奖结果不是”0 “就中奖 ，若开奖结果是”0 “就没中奖。反投一期最多投3个不同数值': '反投：竞猜不是开奖结果的数值。 比如反投“ 0 ”若开奖结果不是”0 “就中奖 ，若开奖结果是”0 “就没中奖。反投一期最多投3个不同数值',
  '和值玩法：竞猜“和值X”的具体数值': '和值玩法：竞猜“和值X”的具体数值',
  '不能同时购买“大”“小”、“单”“双”': '不能同时购买“大”“小”、“单”“双”',
  '猜哈希值末位，0-7为小，8-f为大；0、2、4、6、8、a、c、e为双，1、3、5、7、9、b、d、f为单。': '猜哈希值末位，0-7为小，8-f为大；0、2、4、6、8、a、c、e为双，1、3、5、7、9、b、d、f为单。',
  '连尾二尾单选/复式': '连尾二尾单选/复式',
  '连肖二肖单选/复式': '连肖二肖单选/复式',
  自选不中五不中: '自选不中五不中',
  合肖一肖中: '合肖一肖中',
  '连码三中二单选/复式': '连码三中二单选/复式',
  '从“单、双”中至少选择一个组成一注,开奖号码冠亚军的和值单双与所选号码一致即为中奖。': '从“单、双”中至少选择一个组成一注,开奖号码冠亚军的和值单双与所选号码一致即为中奖。',
  '从“大、小”中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖。': '从“大、小”中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖。',
  '【正投玩法】': '【正投玩法】',
  '0.1.2.3.4.5.6.7.8.9个点数任选1-3个数字进行下注，当开奖号码与所选数字相同时，视为中奖': '0.1.2.3.4.5.6.7.8.9个点数任选1-3个数字进行下注，当开奖号码与所选数字相同时，视为中奖',
  '【和值反投玩法】': '【和值反投玩法】',
  '猜3个开奖号相加的和，当开奖号码与竞猜结果不相同时，视为中奖，0-13为小，14-27为大，1，3，5 、7 、9、11、13、15、17，19，21，23，25，27为单，0，2，4，6，8，10，12，14，16，18，20，22，24，26为双': '猜3个开奖号相加的和，当开奖号码与竞猜结果不相同时，视为中奖，0-13为小，14-27为大，1，3，5 、7 、9、11、13、15、17，19，21，23，25，27为单，0，2，4，6，8，10，12，14，16，18，20，22，24，26为双',
  和值反投: '和值反投',
  '【和值玩法】': '【和值玩法】',
  '猜3个开奖号相加的和，0-13为小，14-27为大，1，3，5 、7 、9、11、13、15、17，19，21，23，25，27为单，0，2，4，6，8，10，12，14，16，18，20，22，24，26为双': '猜3个开奖号相加的和，0-13为小，14-27为大，1，3，5 、7 、9、11、13、15、17，19，21，23，25，27为单，0，2，4，6，8，10，12，14，16，18，20，22，24，26为双',
  '一、开奖时间（GMT+7）': '一、开奖时间（GMT+7）',
  'BTC/USDT 00:01-24:00每5分钟一期，开奖前15秒停止下注': 'BTC/USDT 00:01-24:00每5分钟一期，开奖前15秒停止下注',
  'ETC/USDT 00:01-24:00每10分钟一期，开奖前15秒停止下注': 'ETC/USDT 00:01-24:00每10分钟一期，开奖前15秒停止下注',
  '二、玩法介绍': '二、玩法介绍',
  '每期开奖号码取BTC/USDT后小数点前一位＋小数点后两位共三位数字相加取最终得数得各位数为开奖号码，例如：本期开奖号码为': '每期开奖号码取BTC/USDT后小数点前一位＋小数点后两位共三位数字相加取最终得数得各位数为开奖号码，例如：本期开奖号码为',
  '（46542.46），那么开奖号码为2+4+6=12 ，取个位数开奖结果为（2） ，大小开奖结果为（小），单双开奖结果为（双）': '（46542.46），那么开奖号码为2+4+6=12 ，取个位数开奖结果为（2） ，大小开奖结果为（小），单双开奖结果为（双）',
  '【数字玩法】': '【数字玩法】',
  '0.1.2.3.4.5.6.7.8.9个点数任选1-3个数字进行下注，当开奖号码与所选数字相不同时，视为中奖': '0.1.2.3.4.5.6.7.8.9个点数任选1-3个数字进行下注，当开奖号码与所选数字相不同时，视为中奖',
  '【大小玩法】': '【大小玩法】',
  '0.1.2.3.4为小，5.6.7.8.9为大，任选（大）或（小）进行竞猜下注，当开奖号码与竞猜结果相同时，视为中奖': '0.1.2.3.4为小，5.6.7.8.9为大，任选（大）或（小）进行竞猜下注，当开奖号码与竞猜结果相同时，视为中奖',
  '【单双玩法】': '【单双玩法】',
  '1.3.5.7.9为单，0.2.4.6.8为双，任选（单）或（双）进行竞猜下注，当开奖号码与竞猜结果相同时，视为中奖': '1.3.5.7.9为单，0.2.4.6.8为双，任选（单）或（双）进行竞猜下注，当开奖号码与竞猜结果相同时，视为中奖',
  印度三色彩规则: '印度三色彩规则',
  '如果您花费100{dw}进行投注，将扣除{fwf}{dw}服务费，您的有效投注金额为{sj}{dw}': '如果您花费100{dw}进行投注，将扣除{fwf}{dw}服务费，您的有效投注金额为{sj}{dw}',
  '购买绿色：如果结果显示1,3,7,9，你将得到（{sj}*2）{at}{dw}': '购买绿色：如果结果显示1,3,7,9，你将得到（{sj}*2）{at}{dw}',
  '如果结果显示为5，您将得到（{sj}*1.5）{at}{dw}': '如果结果显示为5，您将得到（{sj}*1.5）{at}{dw}',
  '购买红色：如果结果显示2,4,6,8，您将获得（{sj}*2）{at}{dw}': '购买红色：如果结果显示2,4,6,8，您将获得（{sj}*2）{at}{dw}',
  '如果结果显示0，您将获得（{sj}*1.5）{at}{dw}': '如果结果显示0，您将获得（{sj}*1.5）{at}{dw}',
  '购买紫色：如果结果显示0或5，你将得到（{sj}*4.5）{at}{dw}': '购买紫色：如果结果显示0或5，你将得到（{sj}*4.5）{at}{dw}',
  '购买数字：如果结果与您选择的号码相同，您将获得（{sj}*9）{at}{dw}': '购买数字：如果结果与您选择的号码相同，您将获得（{sj}*9）{at}{dw}',
  '祝君好运~~连连': '祝君好运~~连连',
  '2分钟1期，1分40秒下单时间，20秒后显示开奖结果。全天24小时都开奖。总期数为720期': '2分钟1期，1分40秒下单时间，20秒后显示开奖结果。全天24小时都开奖。总期数为720期',
  '3分钟1期，2分30秒下单时间，30秒后显示开奖结果。全天24小时都开奖。总期数为480期': '3分钟1期，2分30秒下单时间，30秒后显示开奖结果。全天24小时都开奖。总期数为480期',
  '1分钟1期，50秒下单时间，10秒后显示开奖结果。全天24小时都开奖。总期数为1440期': '1分钟1期，50秒下单时间，10秒后显示开奖结果。全天24小时都开奖。总期数为1440期',
  '5分钟1期，4分30秒下单时间，30秒后显示开奖结果。全天24小时都开奖。总期数为288期': '5分钟1期，4分30秒下单时间，30秒后显示开奖结果。全天24小时都开奖。总期数为288期',
  '如今年是鼠年，就以鼠为开始，': '如今年是鼠年，就以鼠为开始，',
  '如今年是牛年，就以牛为开始，': '如今年是牛年，就以牛为开始，',
  '如今年是虎年，就以虎为开始，': '如今年是虎年，就以虎为开始，',
  '如今年是兔年，就以兔为开始，': '如今年是兔年，就以兔为开始，',
  '如今年是龙年，就以龙为开始，': '如今年是龙年，就以龙为开始，',
  '如今年是蛇年，就以蛇为开始，': '如今年是蛇年，就以蛇为开始，',
  '如今年是马年，就以马为开始，': '如今年是马年，就以马为开始，',
  '如今年是羊年，就以羊为开始，': '如今年是羊年，就以羊为开始，',
  '如今年是猴年，就以猴为开始，': '如今年是猴年，就以猴为开始，',
  '如今年是鸡年，就以鸡为开始，': '如今年是鸡年，就以鸡为开始，',
  '如今年是狗年，就以狗为开始，': '如今年是狗年，就以狗为开始，',
  '如今年是猪年，就以猪为开始，': '如今年是猪年，就以猪为开始，',
  '特码对应的生肖，如今年是鼠年，所以号码1是鼠，按生肖顺序': '特码对应的生肖，如今年是鼠年，所以号码1是鼠，按生肖顺序',
  '特码对应的生肖，如今年是牛年，所以号码1是牛，按生肖顺序': '特码对应的生肖，如今年是牛年，所以号码1是牛，按生肖顺序',
  '特码对应的生肖，如今年是虎年，所以号码1是虎，按生肖顺序': '特码对应的生肖，如今年是虎年，所以号码1是虎，按生肖顺序',
  '特码对应的生肖，如今年是兔年，所以号码1是兔，按生肖顺序': '特码对应的生肖，如今年是兔年，所以号码1是兔，按生肖顺序',
  '特码对应的生肖，如今年是龙年，所以号码1是龙，按生肖顺序': '特码对应的生肖，如今年是龙年，所以号码1是龙，按生肖顺序',
  '特码对应的生肖，如今年是蛇年，所以号码1是蛇，按生肖顺序': '特码对应的生肖，如今年是蛇年，所以号码1是蛇，按生肖顺序',
  '特码对应的生肖，如今年是马年，所以号码1是马，按生肖顺序': '特码对应的生肖，如今年是马年，所以号码1是马，按生肖顺序',
  '特码对应的生肖，如今年是羊年，所以号码1是羊，按生肖顺序': '特码对应的生肖，如今年是羊年，所以号码1是羊，按生肖顺序',
  '特码对应的生肖，如今年是猴年，所以号码1是猴，按生肖顺序': '特码对应的生肖，如今年是猴年，所以号码1是猴，按生肖顺序',
  '特码对应的生肖，如今年是鸡年，所以号码1是鸡，按生肖顺序': '特码对应的生肖，如今年是鸡年，所以号码1是鸡，按生肖顺序',
  '特码对应的生肖，如今年是狗年，所以号码1是狗，按生肖顺序': '特码对应的生肖，如今年是狗年，所以号码1是狗，按生肖顺序',
  '特码对应的生肖，如今年是猪年，所以号码1是猪，按生肖顺序': '特码对应的生肖，如今年是猪年，所以号码1是猪，按生肖顺序',
  '和数{key}': '和数{key}',
  佰: '佰',
  拾: '拾',
  二字定位请挑选2个号码再进行投注: '二字定位请挑选2个号码再进行投注',
  三字定位请挑选3个号码再进行投注: '三字定位请挑选3个号码再进行投注',
  佰大: '佰大',
  佰小: '佰小',
  佰单: '佰单',
  佰双: '佰双',
  佰质: '佰质',
  佰合: '佰合',
  拾大: '拾大',
  拾小: '拾小',
  拾单: '拾单',
  拾双: '拾双',
  拾质: '拾质',
  拾合: '拾合',
  个大: '个大',
  个小: '个小',
  个单: '个单',
  个双: '个双',
  个质: '个质',
  个合: '个合',
  佰拾单: '佰拾单',
  佰拾双: '佰拾双',
  佰个单: '佰个单',
  佰个双: '佰个双',
  拾个双: '拾个双',
  佰拾和尾数大: '佰拾和尾数大',
  佰拾和尾数小: '佰拾和尾数小',
  佰拾和尾数质: '佰拾和尾数质',
  佰拾和尾数合: '佰拾和尾数合',
  佰个和尾数大: '佰个和尾数大',
  佰个和尾数小: '佰个和尾数小',
  佰个和尾数质: '佰个和尾数质',
  佰个和尾数合: '佰个和尾数合',
  拾个和尾数大: '拾个和尾数大',
  拾个和尾数小: '拾个和尾数小',
  拾个和尾数质: '拾个和尾数质',
  拾个和尾数合: '拾个和尾数合',
  佰拾个和数大: '佰拾个和数大',
  佰拾个和数小: '佰拾个和数小',
  佰拾个和数单: '佰拾个和数单',
  佰拾个和数双: '佰拾个和数双',
  佰拾个和尾数大: '佰拾个和尾数大',
  佰拾个和尾数小: '佰拾个和尾数小',
  佰拾个和尾数质: '佰拾个和尾数质',
  佰拾个和尾数合: '佰拾个和尾数合',
  '佰拾和数0~4': '佰拾和数0~4',
  佰拾和数5: '佰拾和数5',
  佰拾和数6: '佰拾和数6',
  佰拾和数7: '佰拾和数7',
  佰拾和数8: '佰拾和数8',
  佰拾和数9: '佰拾和数9',
  佰拾和数10: '佰拾和数10',
  佰拾和数11: '佰拾和数11',
  佰拾和数12: '佰拾和数12',
  佰拾和数13: '佰拾和数13',
  '佰拾和数14~18': '佰拾和数14~18',
  佰拾和数尾数: '佰拾和数尾数',
  '佰个和数0~4': '佰个和数0~4',
  佰个和数5: '佰个和数5',
  佰个和数6: '佰个和数6',
  佰个和数7: '佰个和数7',
  佰个和数8: '佰个和数8',
  佰个和数9: '佰个和数9',
  佰个和数10: '佰个和数10',
  佰个和数11: '佰个和数11',
  佰个和数12: '佰个和数12',
  佰个和数13: '佰个和数13',
  '佰个和数14~18': '佰个和数14~18',
  佰个和数尾数: '佰个和数尾数',
  '拾个和数0~4': '拾个和数0~4',
  拾个和数5: '拾个和数5',
  拾个和数6: '拾个和数6',
  拾个和数7: '拾个和数7',
  拾个和数8: '拾个和数8',
  拾个和数9: '拾个和数9',
  拾个和数10: '拾个和数10',
  拾个和数11: '拾个和数11',
  拾个和数12: '拾个和数12',
  拾个和数13: '拾个和数13',
  '拾个和数14~18': '拾个和数14~18',
  拾个和数尾数: '拾个和数尾数',
  '三字和数0~6': '三字和数0~6',
  三字和数7: '三字和数7',
  三字和数8: '三字和数8',
  三字和数9: '三字和数9',
  三字和数10: '三字和数10',
  三字和数11: '三字和数11',
  三字和数12: '三字和数12',
  三字和数13: '三字和数13',
  三字和数14: '三字和数14',
  三字和数15: '三字和数15',
  三字和数16: '三字和数16',
  三字和数17: '三字和数17',
  三字和数18: '三字和数18',
  三字和数19: '三字和数19',
  三字和数20: '三字和数20',
  '三字和数21~27': '三字和数21~27',
  三字和数尾数: '三字和数尾数',
  '组合{key}': '组合{key}',
  '种类{key}': '种类{key}',
  '跨度{key}': '跨度{key}',
  '佰{key}': '佰{key}',
  '拾{key}': '拾{key}',
  '个{key}': '个{key}',
  佰拾定位: '佰拾定位',
  佰个定位: '佰个定位',
  拾个定位: '拾个定位',
  '0~9任选1号进行投注': '0~9任选1号进行投注',
  '0~9任选2号进行投注': '0~9任选2号进行投注',
  '当开奖结果佰拾个任一数与所选的号码相同时，即为中奖；若开奖结果出现重覆数字时，视为中奖一次。': '当开奖结果佰拾个任一数与所选的号码相同时，即为中奖；若开奖结果出现重覆数字时，视为中奖一次。',
  '佰/拾/个 大小：0~4为小，5~9为大。佰/拾/个 单双：1、3、5、7、9为单，0、2、4、6、8为双。佰/拾/个 质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰/拾/个 大小：0~4为小，5~9为大。佰/拾/个 单双：1、3、5、7、9为单，0、2、4、6、8为双。佰/拾/个 质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  '当开奖结果佰拾个任二数与所选的号码相同时，即为中奖。': '当开奖结果佰拾个任二数与所选的号码相同时，即为中奖。',
  '佰拾和数：开奖结果佰拾二位数的总和值若与投注的佰拾数字的总和值相同时，即为中奖。佰个和数：开奖结果佰个二位数的总和值若与投注的佰个数字的总和值相同时，即为中奖。拾个和数：开奖结果拾个二位数的总和值若与投注的拾个数字的总和值相同时，即为中奖。佰拾/佰个/拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾和数尾数：佰拾总和为7，尾数为7。佰个和数尾数：佰个总和为8，尾数为8。拾个和数尾数：拾个总和为9，尾数为9。佰拾/佰个/拾个 和数单双：1、3、5、7、9、11、13、15、17为单，0、2、4、6、8、10、12、14、16、18为双。佰拾/佰个/拾个 和数尾数大小：0~4为小，5~9为大。佰拾/佰个/拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰拾和数：开奖结果佰拾二位数的总和值若与投注的佰拾数字的总和值相同时，即为中奖。佰个和数：开奖结果佰个二位数的总和值若与投注的佰个数字的总和值相同时，即为中奖。拾个和数：开奖结果拾个二位数的总和值若与投注的拾个数字的总和值相同时，即为中奖。佰拾/佰个/拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾和数尾数：佰拾总和为7，尾数为7。佰个和数尾数：佰个总和为8，尾数为8。拾个和数尾数：拾个总和为9，尾数为9。佰拾/佰个/拾个 和数单双：1、3、5、7、9、11、13、15、17为单，0、2、4、6、8、10、12、14、16、18为双。佰拾/佰个/拾个 和数尾数大小：0~4为小，5~9为大。佰拾/佰个/拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  '0~9任选3号进行投注': '0~9任选3号进行投注',
  '当开奖结果佰拾个任三数与所选的号码相同时，即为中奖。': '当开奖结果佰拾个任三数与所选的号码相同时，即为中奖。',
  '佰拾个和数：开奖结果佰拾个三位数的总和值若与投注的佰拾个数字的总和值相同时，即为中奖。佰拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾个的总和为12，尾数为2。佰拾个 和数大小：0~13为小，14~27为大。佰拾个 和数单双：1、3、5、7、9、11、13、15、17、19、21、23、25、27为单，0、2、4、6、8、10、12、14、16、18、20、22、24、26、28为双。佰拾个 和数尾数大小：0~4为小，5~9为大。佰拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰拾个和数：开奖结果佰拾个三位数的总和值若与投注的佰拾个数字的总和值相同时，即为中奖。佰拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾个的总和为12，尾数为2。佰拾个 和数大小：0~13为小，14~27为大。佰拾个 和数单双：1、3、5、7、9、11、13、15、17、19、21、23、25、27为单，0、2、4、6、8、10、12、14、16、18、20、22、24、26、28为双。佰拾个 和数尾数大小：0~4为小，5~9为大。佰拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  '于佰拾个任选一位，自0~9任选1号进行投注': '于佰拾个任选一位，自0~9任选1号进行投注',
  '当开奖结果与所选的定位与号码相同时，即为中奖。': '当开奖结果与所选的定位与号码相同时，即为中奖。',
  '开奖号码：01 02 03 即中一字定位。': '开奖号码：01 02 03 即中一字定位。',
  '于佰拾个任选二位，自0~9任选2号进行投注': '于佰拾个任选二位，自0~9任选2号进行投注',
  '当开奖结果与所选号码相同且顺序一致时，即为中奖。': '当开奖结果与所选号码相同且顺序一致时，即为中奖。',
  '开奖号码：01 02 即中二字定位。': '开奖号码：01 02 即中二字定位。',
  '于佰拾个位自0~9任选3号进行投注': '于佰拾个位自0~9任选3号进行投注',
  '开奖号码：01 02 03 即中三字定位。': '开奖号码：01 02 03 即中三字定位。',
  '会员可以挑选5~10个号码': '会员可以挑选5~10个号码',
  '当开奖结果中有且只有两个号码重复，则视为中奖。挑选不同个数号码有其相对应的赔率。如果是选择 1、2、3、4、5中的任何两个号码，且其中有一个号码重复则中奖。': '当开奖结果中有且只有两个号码重复，则视为中奖。挑选不同个数号码有其相对应的赔率。如果是选择 1、2、3、4、5中的任何两个号码，且其中有一个号码重复则中奖。',
  '投注方案：112、344': '投注方案：112、344',
  '开奖号码：112、344 即中奖。若是开出豹子则不算中奖。【附注】："豹子"为三字同号，例如：111、222。': '开奖号码：112、344 即中奖。若是开出豹子则不算中奖。【附注】："豹子"为三字同号，例如：111、222。',
  '会员可以挑选择4~8个号码': '会员可以挑选择4~8个号码',
  '当开奖结果都出现在所下注的号码中且没有任何号码重复，则视为中奖。挑选不同的号码有其相对应的赔率，中奖赔率以所选号码中的最小赔率计算彩派。': '当开奖结果都出现在所下注的号码中且没有任何号码重复，则视为中奖。挑选不同的号码有其相对应的赔率，中奖赔率以所选号码中的最小赔率计算彩派。',
  '投注方案：1、2、3、4': '投注方案：1、2、3、4',
  '开奖结果为123、124、134、234都中奖，其他都是不中奖。例如：112、133、145、444等都是不中奖。': '开奖结果为123、124、134、234都中奖，其他都是不中奖。例如：112、133、145、444等都是不中奖。',
  '以开奖三个号码的最大差距(跨度)，作为中奖的依据。会员可以选择0~9的任一跨度。': '以开奖三个号码的最大差距(跨度)，作为中奖的依据。会员可以选择0~9的任一跨度。',
  '开奖结果为3，4，8。中奖的跨度为5。(最大号码 8减最小号码 3 = 5)。若开奖结果三号码都相同，称作豹子，投注注豹子者中奖，其馀为不中奖。': '开奖结果为3，4，8。中奖的跨度为5。(最大号码 8减最小号码 3 = 5)。若开奖结果三号码都相同，称作豹子，投注注豹子者中奖，其馀为不中奖。',
  '组选三请挑选5~10个号码再进行投注': '组选三请挑选5~10个号码再进行投注',
  '组选六请挑选4~8个号码再进行投注': '组选六请挑选4~8个号码再进行投注',
  '福彩3D是依照中国福利彩票管理中心发行的3D的开奖结果为派彩依据，营业时间为北京时间(GMT+8)每天上午10:00到晚上21:15，每天开奖一次。': '福彩3D是依照中国福利彩票管理中心发行的3D的开奖结果为派彩依据，营业时间为北京时间(GMT+8)每天上午10:00到晚上21:15，每天开奖一次。',
  一字盘势: '一字盘势',
  '一字定位：于佰拾个任选一位，自0~9任选1号进行投注，当开奖结果与所选的定位与号码相同时，即为中奖。': '一字定位：于佰拾个任选一位，自0~9任选1号进行投注，当开奖结果与所选的定位与号码相同时，即为中奖。',
  '一字组合：0~9任选1号进行投注，当开奖结果佰拾个任一数与所选的号码相同时，即为中奖；若开奖结果出现重覆数字时，视为中奖一次。': '一字组合：0~9任选1号进行投注，当开奖结果佰拾个任一数与所选的号码相同时，即为中奖；若开奖结果出现重覆数字时，视为中奖一次。',
  '佰/拾/个 大小：0~4为小，5~9为大。': '佰/拾/个 大小：0~4为小，5~9为大。',
  '佰/拾/个 单双：1、3、5、7、9为单，0、2、4、6、8为双。': '佰/拾/个 单双：1、3、5、7、9为单，0、2、4、6、8为双。',
  '佰/拾/个 质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰/拾/个 质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  二字盘势: '二字盘势',
  '二字定位：于佰拾个任选二位，自0~9任选2号进行投注，当开奖结果与所选号码相同且顺序一致时，即为中奖。': '二字定位：于佰拾个任选二位，自0~9任选2号进行投注，当开奖结果与所选号码相同且顺序一致时，即为中奖。',
  '二字组合：0~9任选2号进行投注，当开奖结果佰拾个任二数与所选的号码相同时，即为中奖。': '二字组合：0~9任选2号进行投注，当开奖结果佰拾个任二数与所选的号码相同时，即为中奖。',
  '佰拾和数：开奖结果佰拾二位数的总和值若与投注的佰拾数字的总和值相同时，即为中奖。': '佰拾和数：开奖结果佰拾二位数的总和值若与投注的佰拾数字的总和值相同时，即为中奖。',
  '佰个和数：开奖结果佰个二位数的总和值若与投注的佰个数字的总和值相同时，即为中奖。': '佰个和数：开奖结果佰个二位数的总和值若与投注的佰个数字的总和值相同时，即为中奖。',
  '拾个和数：开奖结果拾个二位数的总和值若与投注的拾个数字的总和值相同时，即为中奖。': '拾个和数：开奖结果拾个二位数的总和值若与投注的拾个数字的总和值相同时，即为中奖。',
  '佰拾/佰个/拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。': '佰拾/佰个/拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。',
  '佰拾和数尾数：佰拾总和为7，尾数为7。': '佰拾和数尾数：佰拾总和为7，尾数为7。',
  '佰个和数尾数：佰个总和为8，尾数为8。': '佰个和数尾数：佰个总和为8，尾数为8。',
  '拾个和数尾数：拾个总和为9，尾数为9。': '拾个和数尾数：拾个总和为9，尾数为9。',
  '佰拾/佰个/拾个 和数单双：1、3、5、7、9、11、13、15、17为单，0、2、4、6、8、10、12、14、16、18为双。': '佰拾/佰个/拾个 和数单双：1、3、5、7、9、11、13、15、17为单，0、2、4、6、8、10、12、14、16、18为双。',
  '佰拾/佰个/拾个 和数尾数大小：0~4为小，5~9为大。': '佰拾/佰个/拾个 和数尾数大小：0~4为小，5~9为大。',
  '佰拾/佰个/拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰拾/佰个/拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  三字盘势: '三字盘势',
  '三字定位：于佰拾个位自0~9任选3号进行投注，当开奖结果与所选号码相同且顺序一致时，即为中奖。': '三字定位：于佰拾个位自0~9任选3号进行投注，当开奖结果与所选号码相同且顺序一致时，即为中奖。',
  '三字组合：0~9任选3号进行投注，当开奖结果佰拾个任三数与所选的号码相同时，即为中奖。': '三字组合：0~9任选3号进行投注，当开奖结果佰拾个任三数与所选的号码相同时，即为中奖。',
  '佰拾个和数：开奖结果佰拾个三位数的总和值若与投注的佰拾个数字的总和值相同时，即为中奖。': '佰拾个和数：开奖结果佰拾个三位数的总和值若与投注的佰拾个数字的总和值相同时，即为中奖。',
  '佰拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾个的总和为12，尾数为2。': '佰拾个 和数尾数：以开奖号码的总和尾数，作为中奖依据。会员可以选择0~9的任何一个号码。如：开奖结果为：3、4、5。佰拾个的总和为12，尾数为2。',
  '佰拾个 和数大小：0~13为小，14~27为大。': '佰拾个 和数大小：0~13为小，14~27为大。',
  '佰拾个 和数单双：1、3、5、7、9、11、13、15、17、19、21、23、25、27为单，0、2、4、6、8、10、12、14、16、18、20、22、24、26、28为双。': '佰拾个 和数单双：1、3、5、7、9、11、13、15、17、19、21、23、25、27为单，0、2、4、6、8、10、12、14、16、18、20、22、24、26、28为双。',
  '佰拾个 和数尾数大小：0~4为小，5~9为大。': '佰拾个 和数尾数大小：0~4为小，5~9为大。',
  '佰拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。': '佰拾个 和数尾数质合：1、2、3、5、7为质数，0、4、6、8、9为合数。',
  '会员可以挑选5~10个号码，当开奖结果中有且只有两个号码重复，则视为中奖。挑选不同个数号码有其相对应的赔率。如果是选择1、2、3、4、5中的任何两个号码，且其中有一个号码重复则中奖。举例：112、344，若是开出豹子则不算中奖。【附注】："豹子"为三字同号，例如：111、222。': '会员可以挑选5~10个号码，当开奖结果中有且只有两个号码重复，则视为中奖。挑选不同个数号码有其相对应的赔率。如果是选择1、2、3、4、5中的任何两个号码，且其中有一个号码重复则中奖。举例：112、344，若是开出豹子则不算中奖。【附注】："豹子"为三字同号，例如：111、222。',
  '会员可以挑选择4~8个号码，当开奖结果都出现在所下注的号码中且没有任何号码重复，则视为中奖。挑选不同的号码有其相对应的赔率，中奖赔率以所选号码中的最小赔率计算彩派。举例：如果是选择(1、2、3、4)，则开奖结果为123、124、134、234都中奖，其他都是不中奖。例如：112、133、145、444等都是不中奖。': '会员可以挑选择4~8个号码，当开奖结果都出现在所下注的号码中且没有任何号码重复，则视为中奖。挑选不同的号码有其相对应的赔率，中奖赔率以所选号码中的最小赔率计算彩派。举例：如果是选择(1、2、3、4)，则开奖结果为123、124、134、234都中奖，其他都是不中奖。例如：112、133、145、444等都是不中奖。',
  '以开奖三个号码的最大差距(跨度)，作为中奖的依据。会员可以选择0~9的任一跨度。举例：开奖结果为3，4，8。中奖的跨度为5。(最大号码 8减最小号码 3=5)。若开奖结果三号码都相同，称作豹子，投注注豹子者中奖，其馀为不中奖。': '以开奖三个号码的最大差距(跨度)，作为中奖的依据。会员可以选择0~9的任一跨度。举例：开奖结果为3，4，8。中奖的跨度为5。(最大号码 8减最小号码 3=5)。若开奖结果三号码都相同，称作豹子，投注注豹子者中奖，其馀为不中奖。',
  ' 从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。': ' 从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。',
  "* 虎：亚军号码小于第九名号码视为'虎'中奖，如亚军开出03，第九名开出07。": "* 虎：亚军号码小于第九名号码视为'虎'中奖，如亚军开出03，第九名开出07。",
  "* 虎：冠军号码小于第十名号码视为'虎'中奖，如冠军开出03，第十名开出07。": "* 虎：冠军号码小于第十名号码视为'虎'中奖，如冠军开出03，第十名开出07。",
  "* 虎：季军号码小于第八名号码视为'虎'中奖，如季军开出03，第八名开出07。": "* 虎：季军号码小于第八名号码视为'虎'中奖，如季军开出03，第八名开出07。",
  "* 虎：第五名号码小于第六名号码视为'虎'中奖，如第五名开出03，第六名开出07。": "* 虎：第五名号码小于第六名号码视为'虎'中奖，如第五名开出03，第六名开出07。",
  "* 虎：第四名号码小于第七名号码视为'虎'中奖，如第四名开出03，第七名开出07。": "* 虎：第四名号码小于第七名号码视为'虎'中奖，如第四名开出03，第七名开出07。",
  "* 龙：亚军号码大于第九名号码视为'龙'中奖，如亚军开出07，第九名开出03。": "* 龙：亚军号码大于第九名号码视为'龙'中奖，如亚军开出07，第九名开出03。",
  "* 龙：冠军号码大于第十名号码视为'龙'中奖，如冠军开出07，第十名开出03。": "* 龙：冠军号码大于第十名号码视为'龙'中奖，如冠军开出07，第十名开出03。",
  "* 龙：季军号码大于第八名号码视为'龙'中奖，如季军开出07，第八名开出03。": "* 龙：季军号码大于第八名号码视为'龙'中奖，如季军开出07，第八名开出03。",
  "* 龙：第五名号码大于第六名号码视为'龙'中奖，如第五名开出07，第六名开出03。": "* 龙：第五名号码大于第六名号码视为'龙'中奖，如第五名开出07，第六名开出03。",
  "* 龙：第四名号码大于第七名号码视为'龙'中奖，如第四名开出07，第七名开出03。": "* 龙：第四名号码大于第七名号码视为'龙'中奖，如第四名开出07，第七名开出03。",
  '0/无限': '0/无限',
  '00:00~23:59, 每1分钟一期，00001-1440': '00:00~23:59, 每1分钟一期，00001-1440',
  '0头': '0头',
  '0尾': '0尾',
  '1 赔 1.80 倍 ': '1 赔 1.80 倍 ',
  '1 赔 10.40 倍 ': '1 赔 10.40 倍 ',
  '1 赔 2.70 倍': '1 赔 2.70 倍',
  '1 赔 3.60 倍 ': '1 赔 3.60 倍 ',
  '1 赔 41.00 倍': '1 赔 41.00 倍',
  '“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖。': '“冠亚和值”可能出现的结果为3～19， 投中对应“冠亚和值”数字的视为中奖，其余视为不中奖。',
  一中一: '一中一',
  一位形态: '一位形态',
  一位走势: '一位走势',
  一肖: '一肖',
  一肖不中: '一肖不中',
  一肖中: '一肖中',
  '一肖指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。': '一肖指开奖正码及特码７个号码中含有所下注尾数的一个或多个号码则视为中奖，但派彩只派一次，即不论同生肖号码出现一个或多个号码都只派彩一次。',
  七不中: '七不中',
  '七不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '七不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  七中五: '七中五',
  七肖: '七肖',
  七肖不中: '七肖不中',
  七肖中: '七肖中',
  万位: '万位',
  三不同: '三不同',
  三中三: '三中三',
  三中二: '三中二',
  '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其馀情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。': '三中二:所投注的每三个号码为一组合，若其中2个是开奖号码中的正码，即为三中 二，视为中奖；若3个都是开奖号码中的正码，即为三中二之中三，其馀情形视为不中奖，如06、07、08为一组合，开奖号码中有06、07两个正码，没有 08，即为三中二，按三中二赔付；如开奖 号码中有06、07、08三个正码，即为三中二之中三，按中三赔付；如出现1个或没有，视为不中奖。',
  '三中二单选/复式': '三中二单选/复式',
  三中二胆拖: '三中二胆拖',
  三位走势: '三位走势',
  三全中: '三全中',
  '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其馀情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖。': '三全中:所投注的每三个号码为一组合，若三个号码都是开奖号码之正码，视为中奖，其馀情形视为不中奖。如06、07、08三个都是开奖号码之正码，视为中奖，如两个正码加上一个特码 码视为不中奖。',
  '三全中单选/复式': '三全中单选/复式',
  三全中胆拖: '三全中胆拖',
  三同号: '三同号',
  三尾: '三尾',
  三尾不中: '三尾不中',
  '三尾不中单选/复式': '三尾不中单选/复式',
  三尾不中胆拖: '三尾不中胆拖',
  '三尾单选/复式': '三尾单选/复式',
  三尾胆拖: '三尾胆拖',
  三星报喜: '三星报喜',
  三肖: '三肖',
  三肖不中: '三肖不中',
  三肖中: '三肖中',
  '三肖单选/复式': '三肖单选/复式',
  三肖胆拖: '三肖胆拖',
  三连号: '三连号',
  三重号: '三重号',
  不中: '不中',
  不同号: '不同号',
  不定位中三: '不定位中三',
  不定位前三: '不定位前三',
  不定位后三: '不定位后三',
  两面: '两面',
  两面盘: '两面盘',
  个位: '个位',
  '两面说明：从冠、亚、季至第十名中的“大、小、单、双中至少选择一个组成一注”': '两面说明：从冠、亚、季至第十名中的“大、小、单、双中至少选择一个组成一注”',
  '中2:55.00,中1:2.00': '中2:55.00,中1:2.00',
  '中3:160.00,中2:10.00,中1:2.00.': '中3:160.00,中2:10.00,中1:2.00.',
  中三其他和值尾数: '中三其他和值尾数',
  中三其他特殊号码: '中三其他特殊号码',
  '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码': '中三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码中3位属性一致，即为中奖其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码',
  中三直选单式: '中三直选单式',
  中三直选和值: '中三直选和值',
  中三直选复式: '中三直选复式',
  中三直选组合: '中三直选组合',
  中三直选跨度: '中三直选跨度',
  中三组选包胆: '中三组选包胆',
  中三组选和值: '中三组选和值',
  中三组选复式: '中三组选复式',
  中三组选组三: '中三组选组三',
  中三组选组六: '中三组选组六',
  中三组选胆拖: '中三组选胆拖',
  中三走势: '中三走势',
  '中奖率小于等于2％的单挑最高派奖': '中奖率小于等于2％的单挑最高派奖',
  正码: '正码',
  九不中: '九不中',
  '九不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '九不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  九肖: '九肖',
  九肖不中: '九肖不中',
  九肖中: '九肖中',
  二不同: '二不同',
  二中二: '二中二',
  二中特: '二中特',
  '二中特单选/复选': '二中特单选/复选',
  二中特尾数对碰: '二中特尾数对碰',
  二中特混合对碰: '二中特混合对碰',
  二中特生肖对碰: '二中特生肖对碰',
  二中特胆拖: '二中特胆拖',
  二位形态: '二位形态',
  二位走势: '二位走势',
  二全中: '二全中',
  '二全中单选/复式': '二全中单选/复式',
  二全中尾数对碰: '二全中尾数对碰',
  二全中混合对碰: '二全中混合对碰',
  二全中生肖对碰: '二全中生肖对碰',
  二全中胆拖: '二全中胆拖',
  二同号: '二同号',
  二尾: '二尾',
  二尾不中: '二尾不中',
  '二尾不中单选/复式': '二尾不中单选/复式',
  二尾不中胆拖: '二尾不中胆拖',
  '二尾单选/复式': '二尾单选/复式',
  二尾胆拖: '二尾胆拖',
  二肖: '二肖',
  二肖不中: '二肖不中',
  二肖中: '二肖中',
  '二肖单选/复式': '二肖单选/复式',
  二肖胆拖: '二肖胆拖',
  二重号: '二重号',
  五不中: '五不中',
  '五不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '五不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  五中五: '五中五',
  五位VS六位: '五位VS六位',
  五位形态: '五位形态',
  五位走势: '五位走势',
  五星一码不定位: '五星一码不定位',
  五星三码不定位: '五星三码不定位',
  五星二码不定位: '五星二码不定位',
  五星宏辉: '五星宏辉',
  五星直选单式: '五星直选单式',
  五星直选复式: '五星直选复式',
  五肖: '五肖',
  五肖不中: '五肖不中',
  五肖中: '五肖中',
  '五肖单选/复式': '五肖单选/复式',
  五肖胆拖: '五肖胆拖',
  五龙捕鱼: '五龙捕鱼',
  亚: '亚',
  亚军: '亚军',
  亚军VS九位: '亚军VS九位',
  亚军冷热: '亚军冷热',
  亚军走势: '亚军走势',
  '从"单、双"中至少选择一个组成一注': '从"单、双"中至少选择一个组成一注',
  '从"大、小"中至少选择一个组成一注': "从'大、小'中至少选择一个组成一注",
  '从"龙、虎"中至少选择一个组成一注': '从"龙、虎"中至少选择一个组成一注',
  "从'单、双'中至少选择一个组成一注": "从'单、双'中至少选择一个组成一注",
  "从'大、小'中至少选择一个组成一注": "从'大、小'中至少选择一个组成一注",
  "从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖。": "从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖。",
  "从'龙、虎'中至少选择一个组成一注": "从'龙、虎'中至少选择一个组成一注",
  '从0-18中任意选择1个或1个以上号码': '从0-18中任意选择1个或1个以上号码',
  '从0-27中任意选择1个或1个以上号码': '从0-27中任意选择1个或1个以上号码',
  '从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖': '从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖',
  '从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖。': '从0-9中任意选1个包胆号码，开奖号码的万位，千位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖。',
  '从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖': '从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖',
  '从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖。': '从0-9中任意选1个包胆号码，开奖号码的十位，个位中任意1位包含所选的包胆号码相同（不含对子号）即为中奖。',
  '从0-9中任意选择1个以上号码': '从0-9中任意选择1个以上号码',
  '从0-9中任意选择1个以上的三重号码': '从0-9中任意选择1个以上的三重号码',
  '从0-9中任意选择1个以上的二重号码': '从0-9中任意选择1个以上的二重号码',
  '从0-9中任意选择1个以上的四重号码': '从0-9中任意选择1个以上的四重号码',
  '从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖',
  '从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。': '从0-9中任意选择1个包胆号码，开奖号码的万位、千位、百位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。',
  '从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖',
  '从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。': '从0-9中任意选择1个包胆号码，开奖号码的千位、百位、十位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。',
  '从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（不含豹子号），即为中奖': '从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（不含豹子号），即为中奖',
  '从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。': '从0-9中任意选择1个包胆号码，开奖号码的百位、十位、个位中任意1位与所选包胆号码相同（不含豹子号），即为中奖。',
  '从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖。': '从0-9中任意选择1个号码组成一注，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖。',
  '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现2次，即为中奖。': '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现2次，即为中奖。',
  '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现3次，即为中奖。': '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现3次，即为中奖。',
  '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现4次，即为中奖。': '从0-9中任意选择1个号码组成一注，只要所选号码在开奖号码的万位、千位、百位、十位、个位中出现4次，即为中奖。',
  '从0-9中任意选择2个以上号码': '从0-9中任意选择2个以上号码',
  '从0-9中任意选择2个或2个以上号码': '从0-9中任意选择2个或2个以上号码',
  '从0-9中任意选择3个以上号码': '从0-9中任意选择3个以上号码',
  '从0-9中任意选择3个或3个以上号码': '从0-9中任意选择3个或3个以上号码',
  '从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖。': '从0-9中任意选择4个号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且顺序不限，即为中奖。',
  '从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖。': '从0-9中任意选择5个号码组成一注，所选号码与开奖号码的万位、千位、百位、十位、个位相同，顺序不限，即为中奖。',
  '从0-9中任选1个号码': '从0-9中任选1个号码',
  '从0-9中选2个号码组成一注，所选号码与开奖号码的万位、千位相同（不含对子号），顺序不限，即中奖': '从0-9中选2个号码组成一注，所选号码与开奖号码的万位、千位相同（不含对子号），顺序不限，即中奖',
  '从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同（不含对子号），顺序不限，即中奖': '从0-9中选2个号码组成一注，所选号码与开奖号码的十位、个位相同（不含对子号），顺序不限，即中奖',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖。': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的万位、千位、百位、十位中同时包含所选的2个号码，即为中奖。',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖',
  '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。': '从0-9中选2个号码，每注由2个不同的号码组成，开奖号码的千位、百位、十位、个位中同时包含所选的2个号码，即为中奖。',
  '从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖': '从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖',
  '从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖。': '从0-9中选3个号码，每注由3个不同的号码组成，开奖号码的万位、千位、百位、十位、个位中同时包含所选的3个号码，即为中奖。',
  '从0-9中选择1个号码': '从0-9中选择1个号码',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖。': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位、个位中包含所选号码，即为中奖。',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖。': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位、十位中包含所选号码，即为中奖。',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖',
  '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖。': '从0-9中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位、个位中包含所选号码，即为中奖。',
  '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖': '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖',
  '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。': '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。',
  '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖': '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖',
  '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。': '从0-9中选择1个号码，每注由1号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。',
  '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖': '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖',
  '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖。': '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的万位、千位、百位中包所选的2个号码，即为中奖。',
  '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖': '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖',
  '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖。': '从0-9中选择2个号码，每注由2个不同号码组成，开奖号码的百位、十位、个位中包所选的2个号码，即为中奖。',
  '从0-9中选择4个号码组成一注': '从0-9中选择4个号码组成一注',
  '从0-9中选择5个号码组成一注': '从0-9中选择5个号码组成一注',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖': '从0-9选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。': '从0-9选择2个数字组成二注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖': '从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖。': '从0-9选择2个数字组成二注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖。',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖': '从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖',
  '从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。': '从0-9选择2个数字组成二注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖': '从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。': '从0-9选择3个数字组成一注，所选号码与开奖号码的万位、千位、百位相同，且顺序不限，即为中奖。',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖': '从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖。': '从0-9选择3个数字组成一注，所选号码与开奖号码的千位、百位、十位相同，且顺序不限，即为中奖。',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖': '从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖',
  '从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。': '从0-9选择3个数字组成一注，所选号码与开奖号码的百位、十位、个位相同，且顺序不限，即为中奖。',
  '从01-11中任意选择1个以上号码': '从01-11中任意选择1个以上号码',
  '从01-11中任意选择1个或1个以上号码': '从01-11中任意选择1个或1个以上号码',
  '从01-11中任意选择2个或2个以上号码': '从01-11中任意选择2个或2个以上号码',
  '从01-11中任意选择2个或2个以上号码组成一注': '从01-11中任意选择2个或2个以上号码组成一注',
  '从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的万位、千位相同，顺序不限，即为中奖。': '从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的万位、千位相同，顺序不限，即为中奖。',
  '从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。': '从01-11中任意选择2个或2个以上号码组成一注，所选号码与开奖号码的十位、个位相同，顺序不限，即为中奖。',
  '从01-11中任意选择3个或3个以上号码': '从01-11中任意选择3个或3个以上号码',
  '从01-11中任意选择3个或3个以上号码组成一注': '从01-11中任意选择3个或3个以上号码组成一注',
  '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。': '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。',
  '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖。': '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖。',
  '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。': '从01-11中任意选择3个或3个以上号码组成一注，所选号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。',
  '从01-11中任意选择4个或4个以上号码': '从01-11中任意选择4个或4个以上号码',
  '从01-11中任意选择5个或5个以上号码': '从01-11中任意选择5个或5个以上号码',
  '从01-11中任意选择6个或6个以上号码': '从01-11中任意选择6个或6个以上号码',
  '从01-11中任意选择7个或7个以上号码': '从01-11中任意选择7个或7个以上号码',
  '从01-11中任意选择8个或8个以上号码': '从01-11中任意选择8个或8个以上号码',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的万位、千位、百位中包含所选号码，即为中奖。',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位中包含所选号码，即为中奖': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位中包含所选号码，即为中奖',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位中包含所选号码，即为中奖。': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的千位、百位、十位中包含所选号码，即为中奖。',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖',
  '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。': '从01-11中选择1个号码，每注由1个号码组成，只要开奖号码的百位、十位、个位中包含所选号码，即为中奖。',
  '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码': '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码',
  '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖。': '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的万位、千位相同，顺序不限，即为中奖。',
  '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的十位、个位相同，顺序不限，即为中奖。': '从01-11中，选取2个及以上的号码进行投注，每注需至少包括1个胆码及1个拖码。所选单注号码与开奖号码的十位、个位相同，顺序不限，即为中奖。',
  '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码': '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码',
  '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。': '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的万位、千位、百位相同，顺序不限，即为中奖。',
  '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖。': '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的千位、百位、十位相同，顺序不限，即为中奖。',
  '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。': '从01-11中，选取3个及以上的号码进行投注，每注需至少包括1个胆码及2个拖码。所选单注号码与开奖号码的百位、十位、个位相同，顺序不限，即为中奖。',
  '从01-11中，选取4个及以上的号码进行投注，每注需至少包括1个胆码及3个拖码': '从01-11中，选取4个及以上的号码进行投注，每注需至少包括1个胆码及3个拖码',
  '从01-11中，选取5个及以上的号码进行投注，每注需至少包括1个胆码及4个拖码': '从01-11中，选取5个及以上的号码进行投注，每注需至少包括1个胆码及4个拖码',
  '从01-11中，选取6个及以上的号码进行投注，每注需至少包括1个胆码及5个拖码': '从01-11中，选取6个及以上的号码进行投注，每注需至少包括1个胆码及5个拖码',
  '从01-11中，选取7个及以上的号码进行投注，每注需至少包括1个胆码及6个拖码': '从01-11中，选取7个及以上的号码进行投注，每注需至少包括1个胆码及6个拖码',
  '从01-11中，选取8个及以上的号码进行投注，每注需至少包括1个胆码及7个拖码': '从01-11中，选取8个及以上的号码进行投注，每注需至少包括1个胆码及7个拖码',
  '从01-11共11号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择1个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择2个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择3个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择4个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择4个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择5个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择6个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择7个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择7个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从01-11共11号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。': '从01-11共11号码中选择8个号码进行购买，只要当期顺序摇出的5个开奖号码中包含所选号码，即为中奖。',
  '从03~19的号码中至少选择一个号码进行投注': '从03~19的号码中至少选择一个号码进行投注',
  '从1-17中任意选择1个或1个以上号码': '从1-17中任意选择1个或1个以上号码',
  '从1-26中任意选择1个以上号码': '从1-26中任意选择1个以上号码',
  '从1-6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖': '从1-6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖',
  '从1-6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖。': '从1-6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖。',
  '从1-6中任选3个或多个号码,所选号码与开奖号码的3个号码相同,即为中奖': '从1-6中任选3个或多个号码,所选号码与开奖号码的3个号码相同,即为中奖',
  '从1-6中任选3个或多个号码,所选号码与开奖号码的3个号码相同,即为中奖。': '从1-6中任选3个或多个号码,所选号码与开奖号码的3个号码相同,即为中奖。',
  '从11-66中任选1个或多个号码，选号与奖号(包含11-66，不限顺序)相同，即为中奖（不含豹子）': '从11-66中任选1个或多个号码，选号与奖号(包含11-66，不限顺序)相同，即为中奖（不含豹子）',
  '从11～66中任选1个或多个号码，选号与奖号（包含11～66，不限顺序）相同，即为中奖。': '从11～66中任选1个或多个号码，选号与奖号（包含11～66，不限顺序）相同，即为中奖。',
  '从1～6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖。': '从1～6中任选2个或多个号码，所选号码与开奖号码任意2个号码相同，即为中奖。',
  '从1～6中任选3个或多个号码，所选号码与开奖号码的3个号码相同，即为中奖。': '从1～6中任选3个或多个号码，所选号码与开奖号码的3个号码相同，即为中奖。',
  '从“三重号”中选择一个号码，“单号”中选择一个号码组成一注': '从“三重号”中选择一个号码，“单号”中选择一个号码组成一注',
  '从“三重号”选择一个号码，“二重号”中选择一个号码组成一注': '从“三重号”选择一个号码，“二重号”中选择一个号码组成一注',
  '从“三重号”选择一个号码，“单号”中选择两个号码组成一注': '从“三重号”选择一个号码，“单号”中选择两个号码组成一注',
  '从“二重号”中选择一个号码，“单号”中选择两个号码组成一注': '从“二重号”中选择一个号码，“单号”中选择两个号码组成一注',
  '从“二重号”中选择两个号码组成一注': '从“二重号”中选择两个号码组成一注',
  '从“二重号”选择一个号码，“单号”中选择三个号码组成一注': '从“二重号”选择一个号码，“单号”中选择三个号码组成一注',
  '从“二重号”选择两个号码，“单号”中选择一个号码组成一注': '从“二重号”选择两个号码，“单号”中选择一个号码组成一注',
  '从“四重号”选择一个号码，“单号”中选择一个号码组成一注': '从“四重号”选择一个号码，“单号”中选择一个号码组成一注',
  '从“龙、虎”中至少选择一个组成一注': '从“龙、虎”中至少选择一个组成一注',
  '从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注': '从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注',
  '从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万、千、百、十、个位中至少选择四个位置,从“三重号”中选择一个号码，“单号”中选择一个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注': '从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注',
  '从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万、千、百、十、个位中至少选择四个位置,从“二重号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注': '从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注',
  '从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万、千、百、十、个位中至少选择四个位置,从“二重号”选择一个号码，“单号”中选择两个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万、千、百、十、个位号选一个号码组成一注': '从万、千、百、十、个位号选一个号码组成一注',
  '从万、千、百、十、个位各选一个号码组成一注': '从万、千、百、十、个位各选一个号码组成一注',
  '从万、千、百位中至少各选择一个号码组成一注': '从万、千、百位中至少各选择一个号码组成一注',
  '从万、千位号各选一个号码组成一注': '从万、千位号各选一个号码组成一注',
  '从万、千位号选一个号码组成一注': '从万、千位号选一个号码组成一注',
  '从万位、千位、百位、十位、个任意位置上任意选择1个或1个以上号码': '从万位、千位、百位、十位、个任意位置上任意选择1个或1个以上号码',
  '从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注': '从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注',
  '从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。': '从万位、千位、百位、十位、个位中至少三位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。',
  '从万位、千位、百位、十位、个位中至少两位上各选1个号码组成一注': '从万位、千位、百位、十位、个位中至少两位上各选1个号码组成一注',
  '从万位、千位、百位、十位、个位中至少两位上各选1个号码组成一注，所有号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。': '从万位、千位、百位、十位、个位中至少两位上各选1个号码组成一注，所有号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。',
  '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注': '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注',
  '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖': '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖',
  '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。': '从万位、千位、百位、十位、个位中至少四位上各选1个号码组成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注': '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注': '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,号码区至少选择两个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注': '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号）': '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号）',
  '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注（不包含豹子号），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,手动至少输入三个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注': '从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,至少手动输入一个三位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序一致，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择三个位置,至少选择一个和值号码构成一注': '从万位、千位、百位、十位、个位中至少选择三个位置,至少选择一个和值号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择三个位置,至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖。': '从万位、千位、百位、十位、个位中至少选择三个位置,至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择两个位置,号码区至少选择两个号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择两个位置,号码区至少选择两个号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择两个位置,至少手动输入一个两位数的号码构成一注（不含对子），所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择两个位置，号码区至少选择两个号码构成一注（不含对子）': '从万位、千位、百位、十位、个位中至少选择两个位置，号码区至少选择两个号码构成一注（不含对子）',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少手动输入一个两位数的号码构成一注': '从万位、千位、百位、十位、个位中至少选择两个位置，至少手动输入一个两位数的号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少手动输入一个两位数的号码构成一注（不含对子）': '从万位、千位、百位、十位、个位中至少选择两个位置，至少手动输入一个两位数的号码构成一注（不含对子）',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注': '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子）': '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子）',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。': '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注（不含对子），所选号码与开奖号码的和值相同，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖。': '从万位、千位、百位、十位、个位中至少选择两个位置，至少选择一个和值号码构成一注，所选号码与开奖号码的和值相同，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注': '从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。': '从万位、千位、百位、十位、个位中至少选择四个位置,号码区至少选择四个号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序不限，即为中奖。',
  '从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注': '从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注',
  '从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序致，即为中奖。': '从万位、千位、百位、十位、个位中至少选择四个位置,至少手动输入一个四位数的号码构成一注，所选号码与开奖号码的指定位置上的号码相同，且顺序致，即为中奖。',
  '从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖': '从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖',
  '从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖。': '从万位、千位、百位、十位、个位任意位置上至少选择1个以上号码，所选号码与相同位置上的开奖号码一致，即为中奖。',
  '从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖': '从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖',
  '从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。': '从万位、千位、百位、十位、个位选择一个5位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。',
  '从万位、千位、百位中的“大、小、单、双”中至少各选一个组成一注': '从万位、千位、百位中的“大、小、单、双”中至少各选一个组成一注',
  '从万位、千位、百位中至少各选一个号码组成1-3星的组合共3注，所选号码的百位与开奖号码全部相同，则中1个3等奖；所选号码的千位、百位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '从万位、千位、百位中至少各选一个号码组成1-3星的组合共3注，所选号码的百位与开奖号码全部相同，则中1个3等奖；所选号码的千位、百位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖': '从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖',
  '从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖。': '从万位、千位、百位中选择一个3位数号码组成一注，所选号码与开奖号码前3位相同，且顺序一致，即为中奖。',
  '从万位、千位、百位号选一个号码组成三注': '从万位、千位、百位号选一个号码组成三注',
  '从万位、千位、百位各选一个号码组成一注': '从万位、千位、百位各选一个号码组成一注',
  '从万位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码一致，即为中奖。': '从万位、千位、百位至少选择1个号码组成一注，所选号码与相同位置上的开奖号码一致，即为中奖。',
  '从万位、千位中的“大、小、单、双”中至少各选一个组成一注': '从万位、千位中的“大、小、单、双”中至少各选一个组成一注',
  '从万位、千位中至少各选择1个号码组成一注': '从万位、千位中至少各选择1个号码组成一注',
  '从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖': '从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖',
  '从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖。': '从万位、千位中选择一个2位数号码组成一注，所选号码与开奖号码的前2位相同，且顺序一致，即为中奖。',
  '从万位、千位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖。': '从万位、千位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖。',
  '从冠、亚、季至第十名中的“大、小、单、双中至少选择一个组成一注”': '从冠、亚、季至第十名中的“大、小、单、双中至少选择一个组成一注”',
  '从十、个位号各选一个号码组成一注': '从十、个位号各选一个号码组成一注',
  '从十、个位号选一个号码组成一注': '从十、个位号选一个号码组成一注',
  '从十位、个位中的“大、小、单、双”中至少各选一个组成一注': '从十位、个位中的“大、小、单、双”中至少各选一个组成一注',
  '从十位、个位中至少各选择1个号码组成一注': '从十位、个位中至少各选择1个号码组成一注',
  '从十位、个位中选择一个2位数号码组成一注，所选号码与开奖号码的后2位相同，且顺序一致，即为中奖。': '从十位、个位中选择一个2位数号码组成一注，所选号码与开奖号码的后2位相同，且顺序一致，即为中奖。',
  '从十位、个位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖。': '从十位、个位至少个选1个号码组成一注，所选号码与开奖号码前2位相同，且顺序一致，即为中奖。',
  '从千、百、十、个位号选一个号码组成一注': '从千、百、十、个位号选一个号码组成一注',
  '从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖': '从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖',
  '从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。': '从千位、百位、十位、个位选择一个4位数号码组成一注，所选号码与开奖号码全部相同，且顺序一致，即为中奖。',
  '从千位、百位、十位中至少各选一个号码组成1-3星的组合共3注，所选号码的十位与开奖号码全部相同，则中1个3等奖；所选号码的百位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '从千位、百位、十位中至少各选一个号码组成1-3星的组合共3注，所选号码的十位与开奖号码全部相同，则中1个3等奖；所选号码的百位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '从千位、百位、十位中至少各选择1个号码组成一注': '从千位、百位、十位中至少各选择1个号码组成一注',
  '从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖': '从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖',
  '从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖。': '从千位、百位、十位中选择一个3位数号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖。',
  '从千位、百位、十位号选一个号码组成三注': '从千位、百位、十位号选一个号码组成三注',
  '从千位、百位、十位各选一个号码组成一注': '从千位、百位、十位各选一个号码组成一注',
  '从千位、百位、十位至少个选1个号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖。': '从千位、百位、十位至少个选1个号码组成一注，所选号码与开奖号码中3位相同，且顺序一致，即为中奖。',
  '从百位、十位、个位中的“大、小、单、双”中至少各选一个组成一注': '从百位、十位、个位中的“大、小、单、双”中至少各选一个组成一注',
  '从百位、十位、个位中至少各选一个号码组成1-3星的组合共3注，所选号码的个位与开奖号码全部相同，则中1个3等奖；所选号码的个位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖': '从百位、十位、个位中至少各选一个号码组成1-3星的组合共3注，所选号码的个位与开奖号码全部相同，则中1个3等奖；所选号码的个位、十位与开奖号码全部相同，则中1个3等奖以及1个2等奖，依此类推，最高可中3个奖',
  '从百位、十位、个位中至少各选择1个号码组成一注': '从百位、十位、个位中至少各选择1个号码组成一注',
  '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖': '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖',
  '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。': '从百位、十位、个位中选择一个3位数号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。',
  '从百位、十位、个位号选一个号码组成三注': '从百位、十位、个位号选一个号码组成三注',
  '从百位、十位、个位各选一个号码组成一注': '从百位、十位、个位各选一个号码组成一注',
  '从百位、十位、个位至少个选1个号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。': '从百位、十位、个位至少个选1个号码组成一注，所选号码与开奖号码后3位相同，且顺序一致，即为中奖。',
  '从第一名、第二名、第三名、第四名、第五名中至少各选1个号码组成一注': '从第一名、第二名、第三名、第四名、第五名中至少各选1个号码组成一注',
  '从第一名、第二名、第三名、第四名中至少各选1个号码组成一注': '从第一名、第二名、第三名、第四名中至少各选1个号码组成一注',
  '从第一名、第二名、第三名中各选择1个号码组成一注': '从第一名、第二名、第三名中各选择1个号码组成一注',
  '从第一名、第二名、第三名中至少各选1个号码组成一注': '从第一名、第二名、第三名中至少各选1个号码组成一注',
  '从第一名、第二名中各选择1个号码组成一注': '从第一名、第二名中各选择1个号码组成一注',
  '从第一名、第二名中至少各选1个号码组成一注': '从第一名、第二名中至少各选1个号码组成一注',
  从第一名中至少选择1个号码组成一注: '从第一名中至少选择1个号码组成一注',
  从第一名至第十名任意位置上选择1个或1个以上号码: '从第一名至第十名任意位置上选择1个或1个以上号码',
  '从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖。': '从第一名至第十名任意位置上选择1个或1个以上号码,所选号码与相同位置上的开奖号码一致即为中奖。',
  任选三直选单式: '任选三直选单式',
  任选三直选和值: '任选三直选和值',
  任选三直选复式: '任选三直选复式',
  任选三组三单式: '任选三组三单式',
  任选三组三复式: '任选三组三复式',
  任选三组六单式: '任选三组六单式',
  任选三组六复式: '任选三组六复式',
  任选三组选混合: '任选三组选混合',
  任选二直选单式: '任选二直选单式',
  任选二直选和值: '任选二直选和值',
  任选二直选复式: '任选二直选复式',
  任选二组选单式: '任选二组选单式',
  任选二组选和值: '任选二组选和值',
  任选二组选复式: '任选二组选复式',
  任选四直选单式: '任选四直选单式',
  任选四直选复式: '任选四直选复式',
  任选四组选12: '任选四组选12',
  任选四组选24: '任选四组选24',
  任选四组选4: '任选四组选4',
  任选四组选6: '任选四组选6',
  任选复式一中一: '任选复式一中一',
  任选复式七中五: '任选复式七中五',
  任选复式三中三: '任选复式三中三',
  任选复式二中二: '任选复式二中二',
  任选复式五中五: '任选复式五中五',
  任选复式八中五: '任选复式八中五',
  任选复式六中五: '任选复式六中五',
  任选复式四中四: '任选复式四中四',
  任选胆拖七中五: '任选胆拖七中五',
  任选胆拖三中三: '任选胆拖三中三',
  任选胆拖二中二: '任选胆拖二中二',
  任选胆拖五中五: '任选胆拖五中五',
  任选胆拖八中五: '任选胆拖八中五',
  任选胆拖六中五: '任选胆拖六中五',
  任选胆拖四中四: '任选胆拖四中四',
  任选走势: '任选走势',
  八不中: '八不中',
  '八不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '八不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  八中五: '八中五',
  八肖: '八肖',
  八肖不中: '八肖不中',
  八肖中: '八肖中',
  六不中: '六不中',
  '六不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '六不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  六中五: '六中五',
  六合彩: '六合彩',
  六肖: '六肖',
  六肖不中: '六肖不中',
  六肖中: '六肖中',
  '共有21个单独的投注台面，每一个投注台面的左边为龙，右边为虎。如在正1vs正2的投注台面，则正1为龙，正2为虎；计算公式为：正1的结果为龙的点数，正2的结果为虎的点��。若选择正1vs正5台面，则正1为龙，正5为虎，以此类推。': '共有21个单独的投注台面，每一个投注台面的左边为龙，右边为虎。如在正1vs正2的投注台面，则正1为龙，正2为虎；计算公式为：正1的结果为龙的点数，正2的结果为虎的点��。若选择正1vs正5台面，则正1为龙，正5为虎，以此类推。',
  关闭: '关闭',
  '冠、亚军和': '冠、亚军和',
  冠亚军组合: '冠亚军组合',
  冠亚单: '冠亚单',
  冠亚双: '冠亚双',
  冠亚和: '冠亚和',
  冠亚和单双: '冠亚和单双',
  guanyafushi: "冠亚和单双复式说明：从'单、双'中至少选择一个组成一注,开奖号码冠亚军的和值单双与所选号码一致即为中奖",
  guanyadanshaung: "冠亚和单双玩法说明：从'单、双'中至少选择一个组成一注,开奖号码冠亚军的和值单双与所选号码一致即为中奖",
  冠亚和大小: '冠亚和大小',
  "冠亚和大小玩法说明：从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖": "冠亚和大小玩法说明：从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖",
  "冠亚和大小说明：从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖": "冠亚和大小说明：从'大、小'中至少选择一个组成一注,和值大于11为大，小于或等于11为小，开奖号码冠亚军的和值大小与所选号码一致即为中奖",
  冠亚和指定: '冠亚和指定',
  冠亚大: '冠亚大',
  冠亚小: '冠亚小',
  冠军: '冠军',
  冠军VS十位: '冠军VS十位',
  冠军冷热: '冠军冷热',
  冠军走势: '冠军走势',
  出现次数: '出现次数',
  冷热: '冷热',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和1个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和拖码，所选胆码必须全中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和1个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和拖码，所选胆码必须全中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和2个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和2个拖码，所选胆码必须全中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和2个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和2个拖码，所选胆码必须全中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和3个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和3个拖码，所选胆码必须全中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和4个拖码组成一注，只要当期顺序摇出的5个开奖号码中同时包含所选的1个胆码和4个拖码，所选胆码必须全中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和5个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和6个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。',
  '分别从胆码和拖码的01-11中，至少选择1个胆码和7个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。': '分别从胆码和拖码的01-11中，至少选择1个胆码和7个拖码组成一注，只要当期顺序摇出的5个开奖号码同时存在于胆码和拖码的任意组合中，即为中奖。',
  分红: '分红',
  '前 往 购 彩': '前 往 购 彩',
  前一: '前一',
  前一直选复式: '前一直选复式',
  前三一码不定位: '前三一码不定位',
  前三二码不定位: '前三二码不定位',
  前三其他和值尾数: '前三其他和值尾数',
  前三其他特殊号码: '前三其他特殊号码',
  '前三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码前3位属性一致，即为中奖其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码': '前三其他特殊号码玩法说明：所选的号码特殊属性和开奖号码前3位属性一致，即为中奖其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码',
  前三形态: '前三形态',
  前三直选单式: '前三直选单式',
  前三直选和值: '前三直选和值',
  前三直选复式: '前三直选复式',
  前三直选组合: '前三直选组合',
  前三直选跨度: '前三直选跨度',
  前三组选包胆: '前三组选包胆',
  前三组选和值: '前三组选和值',
  前三组选复式: '前三组选复式',
  前三组选组三: '前三组选组三',
  前三组选组六: '前三组选组六',
  前三组选胆拖: '前三组选胆拖',
  前三走势: '前三走势',
  前二: '前二',
  前二形态: '前二形态',
  前二直选单式: '前二直选单式',
  前二直选和值: '前二直选和值',
  前二直选复式: '前二直选复式',
  前二直选跨度: '前二直选跨度',
  前二组选包胆: '前二组选包胆',
  前二组选单式: '前二组选单式',
  前二组选和值: '前二组选和值',
  前二组选胆拖: '前二组选胆拖',
  前二走势: '前二走势',
  前五直选复式: '前五直选复式',
  前四一码不定位: '前四一码不定位',
  前四二码不定位: '前四二码不定位',
  前四直选复式: '前四直选复式',
  前往注单: '前往注单',
  剩余投注时间: '剩余投注时间',
  剩余期数: '剩余期数',
  副玩法: '副玩法',
  十一不中: '十一不中',
  '十一不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十一不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  十一肖: '十一肖',
  十一肖不中: '十一肖不中',
  十一肖中: '十一肖中',
  十不中: '十不中',
  '十不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  十二不中: '十二不中',
  '十二不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)': '十二不中:所投注的每个号码为一个组合,其中包含7个号码如会员下注号码为07,08,09,10,11,12,13,14,15,16,17,18,为一个组合.开奖结果为01,02.03.04.05.06.49,没出现组合选择中的号码,视为中奖(请注意49亦算输赢，不为和)',
  十位: '十位',
  十肖: '十肖',
  十肖不中: '十肖不中',
  十肖中: '十肖中',
  千位: '千位',
  '单注10 - 10000封顶，总注80000封顶；': '单注10 - 10000封顶，总注80000封顶；',
  '单注50 - 20000封顶，总注100000封顶；': '单注50 - 20000封顶，总注100000封顶；',
  '单注500 - 30000封顶，总注150000封顶；': '单注500 - 30000封顶，总注150000封顶；',
  '单选/复式': '单选/复式',
  '只要开奖的四个数字从小到大排列为 0、6、8、8，即可中四星组选12。': '只要开奖的四个数字从小到大排列为 0、6、8、8，即可中四星组选12。',
  '只要开奖的四个数字从小到大排列为2、2、8、8，即可中四星组选6。': '只要开奖的四个数字从小到大排列为2、2、8、8，即可中四星组选6。',
  '只要开奖的四个数字从小到大排列为2、8、8、8，即可中四星组选4。': '只要开奖的四个数字从小到大排列为2、8、8、8，即可中四星组选4。',
  号码: '号码',
  号码分布: '号码分布',
  号码形态: '号码形态',
  号码篮: '号码篮',
  号码走势: '号码走势',
  合值组合: '合值组合',
  合单: '合单',
  合双: '合双',
  合大: '合大',
  合小: '合小',
  合尾大: '合尾大',
  合尾小: '合尾小',
  合码: '合码',
  合肖: '合肖',
  同号: '同号',
  后三一码不定位: '后三一码不定位',
  后三二码不定位: '后三二码不定位',
  后三其他和值尾数: '后三其他和值尾数',
  后三其他特殊号码: '后三其他特殊号码',
  '后三其他特殊号码尾数玩法说明：所选的号码特殊属性和开奖号码后3位属性一致，即为中奖其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码': '后三其他特殊号码尾数玩法说明：所选的号码特殊属性和开奖号码后3位属性一致，即为中奖其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码',
  后三形态: '后三形态',
  后三直选单式: '后三直选单式',
  后三直选和值: '后三直选和值',
  后三直选复式: '后三直选复式',
  后三直选组合: '后三直选组合',
  后三直选跨度: '后三直选跨度',
  后三组选包胆: '后三组选包胆',
  后三组选和值: '后三组选和值',
  后三组选复式: '后三组选复式',
  后三组选组三: '后三组选组三',
  后三组选组六: '后三组选组六',
  后三组选胆拖: '后三组选胆拖',
  后三走势: '后三走势',
  后二形态: '后二形态',
  后二直选单式: '后二直选单式',
  后二直选和值: '后二直选和值',
  后二直选复式: '后二直选复式',
  后二直选跨度: '后二直选跨度',
  后二组选包胆: '后二组选包胆',
  后二组选单式: '后二组选单式',
  后二组选和值: '后二组选和值',
  后二组选复式: '后二组选复式',
  后二组选胆拖: '后二组选胆拖',
  后二走势: '后二走势',
  后四一码不定位: '后四一码不定位',
  后四二码不定位: '后四二码不定位',
  后四直选单式: '后四直选单式',
  后四直选复式: '后四直选复式',
  和值: '和值',
  和值组: '和值组',
  '和值组 ': '和值组',
  和值组合: '和值组',
  和局: '和局',
  和局返还: '和局返还',
  和局追号返还: '和局追号返还',
  四中四: '四中四',
  四位VS七位: '四位VS七位',
  四位形态: '四位形态',
  四位走势: '四位走势',
  四尾: '四尾',
  四尾不中: '四尾不中',
  '四尾不中单选/复式': '四尾不中单选/复式',
  四尾不中胆拖: '四尾不中胆拖',
  '四尾单选/复式': '四尾单选/复式',
  四尾胆拖: '四尾胆拖',
  四肖: '四肖',
  四肖不中: '四肖不中',
  四肖中: '四肖中',
  '四肖单选/复式': '四肖单选/复式',
  四肖胆拖: '四肖胆拖',
  四重号: '四重号',
  '在龙、虎任意选择1个或1个以上玩法': '在龙、虎任意选择1个或1个以上玩法',
  基本走势: '基本走势',
  大单: '大单',
  '大单|小双': '大单|小双',
  大双: '大双',
  '大小单双- 开13、14，总注<=10000时，大小单双和组合类型赔率均为1.5倍': '大小单双- 开13、14，总注<=10000时，大小单双和组合类型赔率均为1.5倍',
  '大小单双- 开13、14，总注<=1000时，大小单双赔率1.65倍': '大小单双- 开13、14，总注<=1000时，大小单双赔率1.65倍',
  '大小单双-13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双-13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍',
  '大小单双-开13、14，大小单双总注1001-10000时，大小单双赔率1.5倍': '大小单双-开13、14，大小单双总注1001-10000时，大小单双赔率1.5倍',
  '大小单双-开13、14，大小单双总注<=1000时，大小单双赔率1.7倍': '大小单双-开13、14，大小单双总注<=1000时，大小单双赔率1.7倍',
  '大小单双-开13、14，总注1001-10000时，大小单双赔率1.5倍': '大小单双-开13、14，总注1001-10000时，大小单双赔率1.5倍',
  '大小单双-开13、14，总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双-开13、14，总注>10000时，大小单双和组合类型赔率均为1倍',
  '大小单双-开13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双-开13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍',
  大小单双前三: '大小单双前三',
  大小单双前二: '大小单双前二',
  '大小单双单注10000封顶，组合单注10000封顶，单点单注3000封顶，极大极小单注3000封顶，红绿蓝10000封顶，豹子10000封顶': '大小单双单注10000封顶，组合单注10000封顶，单点单注3000封顶，极大极小单注3000封顶，红绿蓝10000封顶，豹子10000封顶',
  '大小单双单注20000封顶，组合单注20000封顶，单点单注5000封顶，极大极小单注5000封顶，红绿蓝10000封顶，豹子10000封顶': '大小单双单注20000封顶，组合单注20000封顶，单点单注5000封顶，极大极小单注5000封顶，红绿蓝10000封顶，豹子10000封顶',
  '大小单双单注30000封顶，组合单注30000封顶，单点单注8000封顶，极大极小单注8000封顶，红绿蓝10000封顶，豹子10000封顶': '大小单双单注30000封顶，组合单注30000封顶，单点单注8000封顶，极大极小单注8000封顶，红绿蓝10000封顶，豹子10000封顶',
  大小单双后三: '大小单双后三',
  大小单双后二: '大小单双后二',
  '大小单双组合- 开13、14，总注<=10000时 ，大小单双和组合类型赔率均为1倍': '大小单双组合- 开13、14，总注<=10000时 ，大小单双和组合类型赔率均为1倍',
  '大小单双组合- 开13、14，总注<=10000时，大小单双和组合类型赔率均为1倍': '大小单双组合- 开13、14，总注<=10000时，大小单双和组合类型赔率均为1倍',
  '大小单双组合-13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双组合-13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍',
  '大小单双组合-开13、14，总注50-10000时，赔率2.5倍': '大小单双组合-开13、14，总注50-10000时，赔率2.5倍',
  '大小单双组合-开13、14，总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双组合-开13、14，总注>10000时，大小单双和组合类型赔率均为1倍',
  '大小单双组合-开13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍': '大小单双组合-开13、14，所有类型总注>10000时，大小单双和组合类型赔率均为1倍',
  大小比: '大小比',
  头尾: '头尾',
  奇偶: '奇偶',
  奇偶和: '奇偶和',
  奇偶比: '奇偶比',
  季军: '季军',
  季军VS八位: '季军VS八位',
  季军冷热: '季军冷热',
  季军走势: '季军走势',
  定位: '定位',
  家禽: '家禽',
  '对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。': '对万位、千位和百位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。',
  '对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。': '对万位、千位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。',
  '对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。': '对十位、个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。',
  '对所有3个相连的号码（123、234、345、456）进行投注，任意号码开出，即为中奖。': '对所有3个相连的号码（123、234、345、456）进行投注，任意号码开出，即为中奖。',
  '对所有的3个相连号码(123、234、345、456)进行投注，任意号码开出，即为中奖': '对所有的3个相连号码(123、234、345、456)进行投注，任意号码开出，即为中奖',
  '对所有的3个相连号码(123、234、345、456)进行投注，任意号码开出，即为中奖。': '对所有的3个相连号码(123、234、345、456)进行投注，任意号码开出，即为中奖。',
  '对所有相同的三个号码(111、222、333、444、555、666)进行投注，任意号码开出，即为中奖': '对所有相同的三个号码(111、222、333、444、555、666)进行投注，任意号码开出，即为中奖',
  '对所有相同的三个号码(111、222、333、444、555、666)进行投注，任意号码开出，即为中奖。': '对所有相同的三个号码(111、222、333、444、555、666)进行投注，任意号码开出，即为中奖。',
  '对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出，即为中奖。': '对所有相同的三个号码（111、222、333、444、555、666）进行投注，任意号码开出，即为中奖。',
  '对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖': '对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖',
  '对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。': '对百位、十位和个位的“大（56789）小（01234）、单（13579）双（02468）”型态进行购买，所选号码的位置、型态与开奖号码的位置、型态相同，即为中奖。',
  '对相同的三个号码(111、222、333、444、555、666)中的任意一个或多个进行投注，所选号码开出，即为中奖': '对相同的三个号码(111、222、333、444、555、666)中的任意一个或多个进行投注，所选号码开出，即为中奖',
  '对相同的三个号码(111、222、333、444、555、666)中的任意一个或多个进行投注，所选号码开出，即为中奖。': '对相同的三个号码(111、222、333、444、555、666)中的任意一个或多个进行投注，所选号码开出，即为中奖。',
  '对相同的三个号码（111、222、333、444、555、666）中的任意一个进行投注，所选号码开出，即为中奖。': '对相同的三个号码（111、222、333、444、555、666）中的任意一个进行投注，所选号码开出，即为中奖。',
  '小单|大双': '小单|大双',
  小: '小',
  小双: '小双',
  '小双 ': '小双',
  尾: '尾',
  尾大: '尾大',
  尾小: '尾小',
  尾数: '尾数',
  尾数对碰: '尾数对碰',
  "开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注'偶'者中奖；如果奇数和偶数号码数目相同时（均为 3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。": "开出的6个正码中，如奇数号码数目占多数（超过4个），则为奇盘，投注'奇'者中奖；偶数号码占多数（超过4个），则为偶盘，投注'偶'者中奖；如果奇数和偶数号码数目相同时（均为 3个），则为和，投注'和'者中奖。如果6个号码中有一个开49的用特码替换（比如前六个正码为：1,2,3,49,5,6，特码为：7。前六个正码中有49，则该号码失效并由特码替换，最终计算结果：1,2,3,5,6,7）。",
  '开出的号码大于或等于6为大，小于或等于5为小 。': '开出的号码大于或等于6为大，小于或等于5为小 。',
  '开奖号码:13456，即中五星直选。': '开奖号码:13456，即中五星直选。',
  '开奖号码:3456，即中四星直选。': '开奖号码:3456，即中四星直选。',
  '开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24。': '开奖号码的四个数字只要包含0、5、6、8，即可中四星组选24。',
  '开奖号码：01688（顺序不限），即可中五星组选60。': '开奖号码：01688（顺序不限），即可中五星组选60。',
  '开奖号码：01888（顺序不限），即可中五星组选20。': '开奖号码：01888（顺序不限），即可中五星组选20。',
  '开奖号码：06688（顺序不限），即可中五星组选30。': '开奖号码：06688（顺序不限），即可中五星组选30。',
  '开奖号码：10568（顺序不限），即可中五星组选120。': '开奖号码：10568（顺序不限），即可中五星组选120。',
  '开奖号码：11888（顺序不限），即可中五星组选10。': '开奖号码：11888（顺序不限），即可中五星组选10。',
  '开奖号码：18888（顺序不限），即可中五星组选5。': '开奖号码：18888（顺序不限），即可中五星组选5。',
  '开奖号码：前二位58，即中前二星直选': '开奖号码：前二位58，即中前二星直选',
  '开奖号码：后二位01，10，即中后二直选': '开奖号码：后二位01，10，即中后二直选',
  '开奖号码：后二位58或是85（顺序不限，不含对子）即中后二组选。': '开奖号码：后二位58或是85（顺序不限，不含对子）即中后二组选。',
  '开奖号码：后二位58，即中后二直选。': '开奖号码：后二位58，即中后二直选。',
  '开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖。': '开奖结果中第一位车号对比第十位。大即是龙中奖，小的话是虎中奖。',
  形态: '形态',
  形态走势: '形态走势',
  总单: '总单',
  总双: '总双',
  '总和/龙虎': '总和/龙虎',
  总和单: '总和单',
  总和双: '总和双',
  总和大: '总和大',
  总和小: '总和小',
  总大: '总大',
  总小: '总小',
  拖码: '拖码',
  '所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖': '所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖',
  '所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖。': '所选数值等于开奖号码万位、千位、百位三个数字相加之和（非豹子号），即为中奖。',
  '所选数值等于开奖号码万位、千位二个数字相加之和，即为中奖': '所选数值等于开奖号码万位、千位二个数字相加之和，即为中奖',
  '所选数值等于开奖号码万位、千位二个数字相加之和，即为中奖。': '所选数值等于开奖号码万位、千位二个数字相加之和，即为中奖。',
  '所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖': '所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖',
  '所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖。': '所选数值等于开奖号码十位、个位二个数字相加之和，即为中奖。',
  '所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖': '所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖',
  '所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖。': '所选数值等于开奖号码千位、百位、十位三个数字相加之和（非豹子号），即为中奖。',
  '所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖': '所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖',
  '所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖。': '所选数值等于开奖号码百位、十位、个位三个数字相加之和（非豹子号），即为中奖。',
  '所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖': '所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖',
  '所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖。': '所选数值等于开奖号码的万位、千位、百位三个数字相加之和的尾数，即为中奖。',
  '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖': '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖',
  '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖。': '所选数值等于开奖号码的万位、千位、百位三个数字相加之和，即为中奖。',
  '所选数值等于开奖号码的万位、千位的数字之和，即为中奖': '所选数值等于开奖号码的万位、千位的数字之和，即为中奖',
  '所选数值等于开奖号码的万位、千位的数字之和，即为中奖。': '所选数值等于开奖号码的万位、千位的数字之和，即为中奖。',
  '所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖': '所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖',
  '所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖。': '所选数值等于开奖号码的中三位最大与最小相减之差，即为中奖。',
  '所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖': '所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖',
  '所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖。': '所选数值等于开奖号码的前2位最大与最小数字相减之差，即为中奖。',
  '所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖': '所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖',
  '所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖。': '所选数值等于开奖号码的前三位最大与最小相减之差，即为中奖。',
  '所选数值等于开奖号码的十位、个位的数字之和，即为中奖': '所选数值等于开奖号码的十位、个位的数字之和，即为中奖',
  '所选数值等于开奖号码的十位、个位的数字之和，即为中奖。': '所选数值等于开奖号码的十位、个位的数字之和，即为中奖。',
  '所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖': '所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖',
  '所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖。': '所选数值等于开奖号码的千位、百位、十位三个数字相加之和的尾数，即为中奖。',
  '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖': '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖',
  '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖。': '所选数值等于开奖号码的千位、百位、十位三个数字相加之和，即为中奖。',
  '所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖': '所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖',
  '所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖。': '所选数值等于开奖号码的后2位最大与最小数字相减之差，即为中奖。',
  '所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖': '所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖',
  '所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖。': '所选数值等于开奖号码的后三位最大与最小相减之差，即为中奖。',
  '所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖': '所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖',
  '所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖。': '所选数值等于开奖号码的百位、十位、个位三个数字相加之和的尾数，即为中奖。',
  '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖': '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖',
  '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖。': '所选数值等于开奖号码的百位、十位、个位三个数字相加之和，即为中奖。',
  '所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码中3位属性一致，即为中奖。其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码',
  '所选的号码特殊属性和开奖号码中3位属性一致，即为中奖其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码中3位属性一致，即为中奖其中；1.顺子号的千、百、十位不分顺序；2.对子号指的是开奖号码的中三位当中，任意2位数字相同的三位数号码',
  '所选的号码特殊属性和开奖号码前3位属性一致，即为中奖。其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码前3位属性一致，即为中奖。其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码',
  '所选的号码特殊属性和开奖号码前3位属性一致，即为中奖其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码前3位属性一致，即为中奖其中；1.顺子号的万、千、百位不分顺序；2.对子号指的是开奖号码的前三位当中，任意2位数字相同的三位数号码',
  '所选的号码特殊属性和开奖号码后3位属性一致，即为中奖。其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码后3位属性一致，即为中奖。其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码',
  '所选的号码特殊属性和开奖号码后3位属性一致，即为中奖其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码': '所选的号码特殊属性和开奖号码后3位属性一致，即为中奖其中；1.顺子号的百、十、个位不分顺序；2.对子号指的是开奖号码的后三位当中，任意2位数字相同的三位数号码',
  '手动输入一个2位数号码组成一注，输入号码万位、千位与开奖号码相同（不含对子号），顺序不限，即中奖。': '手动输入一个2位数号码组成一注，输入号码万位、千位与开奖号码相同（不含对子号），顺序不限，即中奖。',
  '手动输入一个2位数号码组成一注，输入号码十位、个位与开奖号码相同（不含对子号），顺序不限，即中奖。': '手动输入一个2位数号码组成一注，输入号码十位、个位与开奖号码相同（不含对子号），顺序不限，即中奖。',
  '手动输入一个3位数号码组成一注，所选号码与开奖号码万位、千位、百位相同，且顺序一致，即为中奖。': '手动输入一个3位数号码组成一注，所选号码与开奖号码万位、千位、百位相同，且顺序一致，即为中奖。',
  '手动输入一个3位数号码组成一注，所选号码与开奖号码千位、百位、十位相同，且顺序一致，即为中奖。': '手动输入一个3位数号码组成一注，所选号码与开奖号码千位、百位、十位相同，且顺序一致，即为中奖。',
  '手动输入一个3位数号码组成一注，所选号码与开奖号码百位、十位、个位相同，且顺序一致，即为中奖。': '手动输入一个3位数号码组成一注，所选号码与开奖号码百位、十位、个位相同，且顺序一致，即为中奖。',
  '手动输入号码，至少输入1个2位数号码组成一注，万位、千位与开奖号码全部相同，且顺序一致，即为中奖。': '手动输入号码，至少输入1个2位数号码组成一注，万位、千位与开奖号码全部相同，且顺序一致，即为中奖。',
  '手动输入号码，至少输入1个2位数号码组成一注，十位、个位与开奖号码全部相同，且顺序一致，即为中奖。': '手动输入号码，至少输入1个2位数号码组成一注，十位、个位与开奖号码全部相同，且顺序一致，即为中奖。',
  '手动输入号码，至少输入1个三位数号码组成一注': '手动输入号码，至少输入1个三位数号码组成一注',
  '手动输入号码，至少输入1个二位数号码组成一注': '手动输入号码，至少输入1个二位数号码组成一注',
  '手动输入号码，至少输入1个五位数号码组成一注': '手动输入号码，至少输入1个五位数号码组成一注',
  '手动输入号码，至少输入1个四位数号码组成一注': '手动输入号码，至少输入1个四位数号码组成一注',
  最大连出: '最大连出',
  最大遗漏: '最大遗漏',
  正特: '正特',
  '正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其馀情形视为不中奖。': '正特一、正特二、正特三、正特四、正特五、正特六∶指下注的正码特与开出之正码其开奖顺序及开奖号码相同，视为中奖，如正码一开出号码8，下注正特一为8者视为中奖，其馀情形视为不中奖。',
  '正码1～6六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码一，依次为正码二、正码三┅ 正码六 （并不以号码大小排序）。正码一、正码二┅ 正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、为单；正码二为10，则正码二为小、为双；号 码若开出为49，则大小、单双与合码皆视为和局': '正码1～6六合彩公司当期开出之前6个号码叫正码。第一时间出来的叫正码一，依次为正码二、正码三┅ 正码六 （并不以号码大小排序）。正码一、正码二┅ 正码六的大小、单双、色波与合码和特码的大小、单双、色波与合码的规则相同，如正码一为29，则正码一为大、为单；正码二为10，则正码二为小、为双；号 码若开出为49，则大小、单双与合码皆视为和局',
  正码一: '正码一',
  正码一单: '正码一单',
  正码一双: '正码一双',
  正码三: '正码三',
  正码二: '正码二',
  正码二单: '正码二单',
  正码二双: '正码二双',
  正码二合单: '正码二合单',
  正码五: '正码五',
  正码六: '正码六',
  '正码六合彩公司当期开出之前6个号码叫正码。每一个号码为一投注组合，假如投注号码为开奖号码之正码，视为中奖，其余情形视为不中奖。': '正码六合彩公司当期开出之前6个号码叫正码。每一个号码为一投注组合，假如投注号码为开奖号码之正码，视为中奖，其余情形视为不中奖。',
  正码四: '正码四',
  正码四大: '正码四大',
  '每期出现大、小、单、双的概率相同，如果连续3期及以上的开奖结果相同，称之为“长龙”，通常会采用倍投的方式进行“砍龙”或“顺龙”。:中奖率小于等于2％的单挑最高派奖': '每期出现大、小、单、双的概率相同，如果连续3期及以上的开奖结果相同，称之为“长龙”，通常会采用倍投的方式进行“砍龙”或“顺龙”。:中奖率小于等于2％的单挑最高派奖',
  特单: '特单',
  特双: '特双',
  特大: '特大',
  特大小: '特大小',
  特小: '特小',
  特码: '特码',
  鼠: '鼠',
  牛: '牛',
  虎: '虎',
  兔: '兔',
  龙: '龙',
  蛇: '蛇',
  马: '马',
  羊: '羊',
  猴: '猴',
  鸡: '鸡',
  狗: '狗',
  猪: '猪',
  descText3: '特码对应的生肖,如今年是猴年，所以号码1是猴，按生肖顺序:鼠 > 牛 > 虎 > 兔 > 龙 > 蛇 > 马 > 羊 > 猴 > 鸡 > 狗 > 猪 依次将49个号码分为12个生肖（如下），再以生肖下注，若当期特码落在下注生肖范围内，则视为中奖。',
  特肖: '特肖',
  '猜3个开奖号相加的和，4-10为小，11-17为大': '猜3个开奖号相加的和，4-10为小，11-17为大',
  猜你喜欢: '猜你喜欢',
  猜冠亚军: '猜冠亚军',
  猜冠军: '猜冠军',
  猜前三名: '猜前三名',
  生肖: '生肖',
  生肖对碰: '生肖对碰',
  '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目] 。': '生肖尾数对碰:是一种简易模式，生肖和尾数都相对应号码，选择生肖尾数对碰下注，相应是选择多个号码组合成不重复组合进行下注。[应用于连码等项目] 。',
  第七名: '第七名',
  第七走势: '第七走势',
  第三名: '第三名',
  第九名: '第九名',
  第九走势: '第九走势',
  第五名: '第五名',
  第五走势: '第五走势',
  第八名: '第八名',
  第八走势: '第八走势',
  第六名: '第六名',
  第六走势: '第六走势',
  第十名: '第十名',
  第十走势: '第十走势',
  第四名: '第四名',
  第四走势: '第四走势',
  绿单: '绿单',
  绿双: '绿双',
  绿大: '绿大',
  绿小: '绿小',
  绿波: '绿波',
  '自中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。定义': '自中奖号码为157，中奖号码位数之间无关联性，则投注杂六者视为中奖，其它视为不中奖。定义',
  '至少选择1个和值（3个号码之和）进行投注，所选和值与开奖的3个号码的和值相同，即为中奖。': '至少选择1个和值（3个号码之和）进行投注，所选和值与开奖的3个号码的和值相同，即为中奖。',
  特头: '特头',
  合单双: '合单双',
  色波: '色波',
  蓝单: '蓝单',
  蓝双: '蓝双',
  蓝大: '蓝大',
  蓝小: '蓝小',
  蓝波: '蓝波',
  赔率类型: '赔率类型',
  赔率说明: '赔率说明',
  '返水': '返水',
  走势: '走势',
  走势图: '走势图',
  连码: '连码',
  连肖: '连肖',
  连肖三肖: '连肖三肖',
  连肖二肖: '连肖二肖',
  连肖五肖: '连肖五肖',
  连肖四肖: '连肖四肖',
  追号: '追号',
  追号中: '追号中',
  追号方案撤单返还: '追号方案撤单返还',
  追号期数: '追号期数',
  追号类型: '追号类型',
  追号返还: '追号返还',
  选号与开奖号码按位猜对1位即中奖: '选号与开奖号码按位猜对1位即中奖',
  选号与开奖号码按位猜对2位即中奖: '选号与开奖号码按位猜对2位即中奖',
  选号与开奖号码按位猜对3位即中奖: '选号与开奖号码按位猜对3位即中奖',
  选号与开奖号码按位猜对4位即中奖: '选号与开奖号码按位猜对4位即中奖',
  选号与开奖号码按位猜对5位即中奖: '选号与开奖号码按位猜对5位即中奖',
  '选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖。': '选择1个三重号码和1个二重号码，所选三重号码在开奖号码中出现3次，并且所选二重号码在开奖号码中出现了2次，即为中奖。',
  '选择1个三重号码和1个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖。': '选择1个三重号码和1个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选三重号码在开奖号码中出现了3次，即为中奖。',
  '选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。': '选择1个三重号码和2个单号号码组成一注，所选的单号号码与开奖号码相同，且所选三重号码在开奖号码中出现了3次，即为中奖。',
  '选择1个二重号码和2个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选二重号码在开奖号码中出现了2次，即为中奖。': '选择1个二重号码和2个单号号码组成一注，所选号码与开奖号码的千位、百位、十位、个位相同，且所选二重号码在开奖号码中出现了2次，即为中奖。',
  '选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。': '选择1个二重号码和3个单号号码组成一注，所选的单号号码与开奖号码相同，且所选二重号码在开奖号码中出现了2次，即为中奖。',
  '选择1个号码组成一注。所选号码与当期冠军一致，即为中奖。': '选择1个号码组成一注。所选号码与当期冠军一致，即为中奖。',
  '选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖。': '选择1个四重号码和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选四重号码在开奖号码中出现了4次，即为中奖。',
  '选择1对相同号码和1个不同号码投注，选号与奖号相同（顺序不限），即为中奖。': '选择1对相同号码和1个不同号码投注，选号与奖号相同（顺序不限），即为中奖。',
  '选择1对相同号码和1个不同号码投注，选号与奖号相同，即为中奖': '选择1对相同号码和1个不同号码投注，选号与奖号相同，即为中奖',
  '选择1对相同号码和1个不同号码投注，选号与奖号相同，即为中奖。': '选择1对相同号码和1个不同号码投注，选号与奖号相同，即为中奖。',
  '选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖。': '选择2个二重号和1个单号号码组成一注，所选的单号号码与开奖号码相同，且所选的2个二重号码分别在开奖号码中出现了2次，即为中奖。',
  '选择2个二重号码组成一注，所选的2个二重号码在开奖号码的千位、百位、十位、个位中分别出现了2次，即为中奖。': '选择2个二重号码组成一注，所选的2个二重号码在开奖号码的千位、百位、十位、个位中分别出现了2次，即为中奖。',
  '选择2个数字号码竞猜全部开奖号码，投注号码与开奖号码前2相同中奖。': '选择2个数字号码竞猜全部开奖号码，投注号码与开奖号码前2相同中奖。',
  '选择3个数字号码竞猜全部开奖号码，投注号码与开奖号码前3相同中奖': '选择3个数字号码竞猜全部开奖号码，投注号码与开奖号码前3相同中奖',
  选择一个号码形态: '选择一个号码形态',
  隐藏连接线: '隐藏连接线',
  隐藏遗漏: '隐藏遗漏',
  '长龙助手是对快3、时时彩、PK10、六合彩特定玩法的“大小单双” 开奖结果进行跟踪统计，并可进行快捷投注的助手工具；': '长龙助手是对快3、时时彩、PK10、六合彩特定玩法的“大小单双” 开奖结果进行跟踪统计，并可进行快捷投注的助手工具；',
  '龙、虎：以龙和虎点数大小比较来判断胜负，龙大于虎则投注龙者中奖，如龙开8，虎开1；若龙小于虎则投注虎者中奖。 注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49': '龙、虎：以龙和虎点数大小比较来判断胜负，龙大于虎则投注龙者中奖，如龙开8，虎开1；若龙小于虎则投注虎者中奖。 注:1点最小，48点最大，如龙和虎点数有49则打为和。如龙开3，虎开49',
  龙断后停止: '龙断后停止',
  龙虎斗: '龙虎斗',
  前二组选复式: '前二组选复式',
  自选不中: '自选不中',
  二同号单选: '二同号单选',
  二同号复选: '二同号复选',
  二不同号: '二不同号',
  三不同号: '三不同号',
  合肖十一肖不中: '合肖十一肖不中',
  合肖十肖不中: '合肖十肖不中',
  合肖九肖不中: '合肖九肖不中',
  合肖八肖不中: '合肖八肖不中',
  合肖七肖不中: '合肖七肖不中',
  合肖六肖不中: '合肖六肖不中',
  合肖五肖不中: '合肖五肖不中',
  合肖四肖不中: '合肖四肖不中',
  合肖三肖不中: '合肖三肖不中',
  合肖二肖不中: '合肖二肖不中',
  合肖一肖不中: '合肖一肖不中',
  合肖十一肖中: '合肖十一肖中',
  合肖十肖中: '合肖十肖中',
  合肖九肖中: '合肖九肖中',
  合肖八肖中: '合肖八肖中',
  合肖七肖中: '合肖七肖中',
  合肖六肖中: '合肖六肖中',
  合肖五肖中: '合肖五肖中',
  合肖四肖中: '合肖四肖中',
  合肖三肖中: '合肖三肖中',
  合肖二肖中: '合肖二肖中',
  连码特串混合对碰: '连码特串混合对碰',
  连码特串尾数对碰: '连码特串尾数对碰',
  连码特串生肖对碰: '连码特串生肖对碰',
  连码特串胆拖: '连码特串胆拖',
  '连码特串单选/复选': '连码特串单选/复选',
  连码二中特混合对碰: '连码二中特混合对碰',
  连码二中特尾数对碰: '连码二中特尾数对碰',
  连码二中特生肖对碰: '连码二中特生肖对碰',
  连码二中特胆拖: '连码二中特胆拖',
  连码二全中混合对碰: '连码二全中混合对碰',
  连码二全中尾数对碰: '连码二全中尾数对碰',
  连码二全中生肖对碰: '连码二全中生肖对碰',
  连码二全中胆拖: '连码二全中胆拖',
  '连码二全中单选/复式': '连码二全中单选/复式',
  '连码二中特单选/复选': '连码二中特单选/复选',
  连码三全中胆拖: '连码三全中胆拖',
  '连码三全中单选/复式': '连码三全中单选/复式',
  连码三中二胆拖: '连码三中二胆拖',
  '0-7为小，8-f为大；0,2,4,6,8,a,c,e为双，1,3,5,7,9,b,d,f为单；开奖号结果取最后一位': '0-7为小，8-f为大；0,2,4,6,8,a,c,e为双，1,3,5,7,9,b,d,f为单；开奖号结果取最后一位'
};

export default {
  ...lottyer_cn,
}